import common from './zh-CN/common'
import component from './zh-CN/component'
import PagesCustomer from './zh-CN/Customer'
import globalHeader from './zh-CN/globalHeader'
import menu from './zh-CN/menu'
import pages from './zh-CN/pages'
import pwa from './zh-CN/pwa'
import settingDrawer from './zh-CN/settingDrawer'
import settings from './zh-CN/settings'

export default {
  'navBar.lang': '语言',
  'layout.user.link.help': '帮助',
  'layout.user.link.privacy': '隐私',
  'layout.user.link.terms': '条款',
  'app.preview.down.block': '下载此页面到本地项目',
  'app.welcome.link.fetch-blocks': '获取全部区块',
  'app.welcome.link.block-list': '基于 block 开发，快速构建标准页面',
  ...pages,
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  ...common,
  ...PagesCustomer,
  'src.pages.404.c1': '抱歉，你访问的页面不存在',
  'src.pages.404.c2': '返回首页',
  'src.pages.Assessment.Records.AnswerModal.index.c1': '评估问卷',
  'src.pages.Assessment.Records.AnswerModal.index.c2':
    '如果有 recordId 则是查看答卷',
  'src.pages.Assessment.Records.AnswerModal.index.c3': '开始时间',
  'src.pages.Assessment.Records.AnswerModal.index.c4': '问卷详情',
  'src.pages.Assessment.Records.AnswerModal.index.c5': '问卷选项',
  'src.pages.Assessment.Records.AnswerModal.index.c6': '问卷记录详情',
  'src.pages.Assessment.Records.AnswerModal.index.c7': '问题描述',
  'src.pages.Assessment.Records.AnswerModal.index.c8': '进度',
  'src.pages.Assessment.Records.AnswerModal.index.c9':
    '用于控制哪些题目内容展开，以及自动滚动到当前答题位置',
  'src.pages.Assessment.Records.AnswerModal.index.c10':
    '如果这个选项现在是选中操作',
  'src.pages.Assessment.Records.AnswerModal.index.c11': '当前选中的是互斥项',
  'src.pages.Assessment.Records.AnswerModal.index.c12': '当前选中的不是互斥项',
  'src.pages.Assessment.Records.AnswerModal.index.c13':
    '将之前选中的选项中是互斥的选项剔除',
  'src.pages.Assessment.Records.AnswerModal.index.c14': '取消选中',
  'src.pages.Assessment.Records.AnswerModal.index.c15': '处理后置题目显示',
  'src.pages.Assessment.Records.AnswerModal.index.c16': '先隐藏后显示',
  'src.pages.Assessment.Records.AnswerModal.index.c17':
    '重新 setQuestons 触发渲染',
  'src.pages.Assessment.Records.AnswerModal.index.c18':
    '根据应该隐藏的问题id，设置应该隐藏的答案选项',
  'src.pages.Assessment.Records.AnswerModal.index.c22': '计算百分比',
  'src.pages.Assessment.Records.AnswerModal.index.c23': '计算答题数量',
  'src.pages.Assessment.Records.AnswerModal.index.c24': '非隐藏问题',
  'src.pages.Assessment.Records.AnswerModal.index.c25': '必答问题数量',
  'src.pages.Assessment.Records.AnswerModal.index.c26':
    '获取第一个未答问题序号 firstNullIndex、设置当前已展开问题序号 openedIndex、获取并设置已答必须问题数量 answeredRequiredCount',
  'src.pages.Assessment.Records.AnswerModal.index.c27':
    '如果有 recordId，则获取答卷详情',
  'src.pages.Assessment.Records.AnswerModal.index.c28':
    '如果有未答完的题目，则获取答过的问题答案',
  'src.pages.Assessment.Records.AnswerModal.index.c29':
    '如果是查看答卷，则忽略',
  'src.pages.Assessment.Records.AnswerModal.index.c30': '本次答题花了多久时间',
  'src.pages.Assessment.Records.AnswerModal.index.c31': '题目说明',
  'src.pages.Assessment.Records.AnswerModal.index.c61': '题目说明',
  'src.pages.Assessment.Records.AnswerModal.index.c62': '提交',
  'src.pages.Assessment.Records.AnswerModal.index.c63': '暂存',
  'src.pages.Assessment.Records.AnswerModal.index.c64': '问卷',
  'src.pages.Assessment.Records.AnswerModal.index.c65': '确认要{hint}问卷？',
  'src.pages.Assessment.Records.AnswerModal.index.c66': '成功',
  'src.pages.Assessment.Records.AnswerModal.index.c67': '问卷完成进度',
  'src.pages.Assessment.Records.AnswerModal.index.c68': '提交问卷',
  'src.pages.Assessment.Records.AnswerModal.index.c69': '暂存问卷',
  'src.pages.Assessment.Records.ChooseQuestionnaireModal.index.c1': '选择问卷',
  'src.pages.Assessment.Records.ChooseQuestionnaireModal.index.c2': '问卷名称',
  'src.pages.Assessment.Records.ChooseQuestionnaireModal.index.c3': '继续答题',
  'src.pages.Assessment.Records.ChooseQuestionnaireModal.index.c4': '开始答题',
  'src.pages.Assessment.Records.index.c1': '确认删除该问卷记录？',
  'src.pages.Assessment.Records.index.c2': '选择的客户和问卷',
  'src.pages.Assessment.Records.index.c3': '查看答卷 reportId',
  'src.pages.Assessment.Records.index.c4': '报告相关',
  'src.pages.Assessment.Records.index.c5': '问卷类型：',
  'src.pages.Assessment.Records.index.c6': '健康风险评估',
  'src.pages.Assessment.Records.index.c7': '中医体质辨识',
  'src.pages.Assessment.Records.index.c8': '心理健康评估',
  'src.pages.Assessment.Records.index.c9': '处理时间',
  'src.pages.Assessment.Records.index.c10': '选择客户',
  'src.pages.Assessment.Records.index.c11': '选择问卷',
  'src.pages.Assessment.Records.index.c12': '答卷',
  'src.pages.Assessment.Records.index.c13': '我的客户',
  'src.pages.Assessment.Records.index.c25': '部门客户',
  'src.pages.Assessment.Records.index.c37': '潜在客户',
  'src.pages.Assessment.Records.index.c49': '删除成功',
  'src.pages.Assessment.Records.index.c50': '删除失败，请稍后重试',
  'src.pages.Assessment.Records.index.c51': '问卷名称',
  'src.pages.Assessment.Records.index.c52': '选择问卷',
  'src.pages.Assessment.Records.index.c53': '评估客户',
  'src.pages.Assessment.Records.index.c54': '请输入姓名、手机号、身份证号',
  'src.pages.Assessment.Records.index.c55': '客户',
  'src.pages.Assessment.Records.index.c56': '评估时间',
  'src.pages.Assessment.Records.index.c57': '开始答卷',
  'src.pages.Assessment.Records.index.c58': '完成答卷',
  'src.pages.Assessment.Records.index.c59': '完成时长（分）',
  'src.pages.Assessment.Records.index.c60': '答卷状态',
  'src.pages.Assessment.Records.index.c61': '进行中',
  'src.pages.Assessment.Records.index.c62': '已完成',
  'src.pages.Assessment.Records.index.c63': '操作',
  'src.pages.Assessment.Records.index.c64': '继续答卷',
  'src.pages.Assessment.Records.index.c65': '查看报告',
  'src.pages.Assessment.Records.index.c66': '查看答卷',
  'src.pages.Assessment.Records.index.c67': '删除',
  'src.pages.Assessment.Records.index.c68': '新增评估',
  'src.pages.Assessment.Records.index.c69': '下一步',
  'src.pages.Assessment.Records.index.c70': '请选择客户',
  'src.pages.Assessment.Records.index.c71': '请选择问卷',
  'src.pages.Assessment.Records.index.c72': '岁',
  'src.pages.Assessment.Records.index.c73': '请选择',
  'src.pages.Assessment.Records.ReportModal.index.c1': '评估报告',
  'src.pages.Assessment.Records.ReportModal.index.c2':
    '通过开闭区间获取表达式，是 < 还是 <=',
  'src.pages.Assessment.Records.ReportModal.index.c3':
    '如果碰到无穷，则放到 50% 的位置',
  'src.pages.Assessment.Records.ReportModal.index.c4': '最后一项不显示',
  'src.pages.Assessment.Records.ReportModal.index.c5': '关闭',
  'src.pages.Assessment.ReportDetail.components.BackCover.index.c1': '地址',
  'src.pages.Assessment.ReportDetail.components.BackCover.index.c2': '电话',
  'src.pages.Assessment.ReportDetail.components.DietaryStructurePaper.index.c1':
    '每日食物能量配比',
  'src.pages.Assessment.ReportDetail.components.DietaryStructurePaper.index.c2':
    '目前摄入量：',
  'src.pages.Assessment.ReportDetail.components.DietaryStructurePaper.index.c3':
    '建议摄入量：{reference}',
  'src.pages.Assessment.ReportDetail.components.DietaryStructurePaper.index.c4':
    '注：{tips}',
  'src.pages.Assessment.ReportDetail.components.DietaryStructurePaper.index.c5':
    '健康饮食建议',
  'src.pages.Assessment.ReportDetail.components.DietaryStructurePaper.index.c9':
    '建议减少',
  'src.pages.Assessment.ReportDetail.components.DietaryStructurePaper.index.c10':
    '建议增加',
  'src.pages.Assessment.ReportDetail.components.DietaryStructurePaper.index.c11':
    '继续保持',
  'src.pages.Assessment.ReportDetail.components.DietHealthPaper.index.c1':
    '饮食保健建议',
  'src.pages.Assessment.ReportDetail.components.DietHealthPaper.index.c2':
    '待处理',
  'src.pages.Assessment.ReportDetail.components.DietHealthPaper.index.c3':
    '不良饮食习惯',
  'src.pages.Assessment.ReportDetail.components.DietHealthPaper.index.c4':
    '待处理',
  'src.pages.Assessment.ReportDetail.components.DietHealthPaper.index.c5':
    '一日食谱推荐',
  'src.pages.Assessment.ReportDetail.components.DietHealthPaper.index.c6':
    '待处理',
  'src.pages.Assessment.ReportDetail.components.DietHealthPaper.index.c11':
    '喜',
  'src.pages.Assessment.ReportDetail.components.DietHealthPaper.index.c12':
    '是',
  'src.pages.Assessment.ReportDetail.components.DietHealthPaper.index.c13':
    '根据你的身⾼、体重、年龄以及体⼒劳动强度计算得出，您每⽇所需的热量⼤约为XXXkcal。根据您所需热量，推荐以下⼀⽇⻝谱，供您参考：',
  'src.pages.Assessment.ReportDetail.components.DietHealthPaper.index.c14':
    '可调因素建议',
  'src.pages.Assessment.ReportDetail.components.DietHealthPaper.index.c15':
    '【说明】如果您想更详细地了解您的膳食结构和饮食建议，请咨询膳食营养师。',
  'src.pages.Assessment.ReportDetail.components.FrontCover.index.c1':
    '评估报告',
  'src.pages.Assessment.ReportDetail.components.FrontCover.index.c2':
    '如家人般 关爱您的健康',
  'src.pages.Assessment.ReportDetail.components.FrontCover.index.c3':
    '客户姓名',
  'src.pages.Assessment.ReportDetail.components.FrontCover.index.c4':
    '客户编号',
  'src.pages.Assessment.ReportDetail.components.FrontCover.index.c5':
    '年龄性别',
  'src.pages.Assessment.ReportDetail.components.FrontCover.index.c6':
    '评估日期',
  'src.pages.Assessment.ReportDetail.components.FrontCover.index.c7':
    '评估机构',
  'src.pages.Assessment.ReportDetail.components.HealthInfoPaper.index.c1':
    '健康信息汇总',
  'src.pages.Assessment.ReportDetail.components.HealthInfoPaper.index.c2':
    '等待后台提供接口',
  'src.pages.Assessment.ReportDetail.components.HealthInfoPaper.index.c3':
    '疾病风险评估概况',
  'src.pages.Assessment.ReportDetail.components.HealthInfoPaper.index.c5':
    '主要生活方式评价',
  'src.pages.Assessment.ReportDetail.components.HealthInfoPaper.index.c7':
    '主要健康问题',
  'src.pages.Assessment.ReportDetail.components.HealthInfoPaper.index.c9':
    '温馨提示',
  'src.pages.Assessment.ReportDetail.components.HealthInfoPaper.index.c11':
    '根据您{date}填写的疾病风险评估问卷信息，我们对您进行了基本健康信息汇总。如有疑问，请及时联系您的服务医生或相关服务人员。',
  'src.pages.Assessment.ReportDetail.components.HealthInfoPaper.index.c12':
    '本评估针对您当前的生活习惯和体检数据，分析您未来5～10年内患某种慢性病的可能性。风险程度是随着个人情况变化的，希望您能过对危险因素的控制，有效降低您的患病风险。本结论属于趋势性分析，不作为诊断或治疗依据。',
  'src.pages.Assessment.ReportDetail.components.HealthInfoPaper.components.RiskAssessTable.index.c1':
    '疾病名称',
  'src.pages.Assessment.ReportDetail.components.HealthInfoPaper.components.RiskAssessTable.index.c2':
    '风险评估',
  'src.pages.Assessment.ReportDetail.components.HealthInfoPaper.components.RiskAssessTable.index.c3':
    '评估结果',
  'src.pages.Assessment.ReportDetail.components.HealthInfoPaper.components.RiskAssessTable.index.c4':
    '未评估',
  'src.pages.Assessment.ReportDetail.components.HealthInfoPaper.components.RiskAssessTable.index.c5':
    '有',
  'src.pages.Assessment.ReportDetail.components.HealthInfoPaper.components.RiskAssessTable.index.c6':
    '已患病',
  'src.pages.Assessment.ReportDetail.components.IndicatorSituationPaper.index.c1':
    '重要指标情况',
  'src.pages.Assessment.ReportDetail.components.IndicatorSituationPaper.index.c2':
    '数据说明',
  'src.pages.Assessment.ReportDetail.components.IndicatorSituationPaper.index.c3':
    '指标',
  'src.pages.Assessment.ReportDetail.components.IndicatorSituationPaper.index.c4':
    '最新测量值',
  'src.pages.Assessment.ReportDetail.components.IndicatorSituationPaper.index.c5':
    '参考值',
  'src.pages.Assessment.ReportDetail.components.LifestylePaper.components.LifestyleInfoCard.index.c1':
    '需注意',
  'src.pages.Assessment.ReportDetail.components.LifestylePaper.index.c1':
    '生活方式分析',
  'src.pages.Assessment.ReportDetail.components.LifestylePaper.index.c2':
    '生活方式评分',
  'src.pages.Assessment.ReportDetail.components.LifestylePaper.index.c3':
    '汇总分析',
  'src.pages.Assessment.ReportDetail.components.LifestylePaper.index.c4':
    '说明：',
  'src.pages.Assessment.ReportDetail.components.MedicalReferencePaper.index.c1':
    '医学参考文献',
  'src.pages.Assessment.ReportDetail.components.MentalHealthChart.index.c1':
    '躯体化',
  'src.pages.Assessment.ReportDetail.components.MentalHealthChart.index.c2':
    '强迫症状',
  'src.pages.Assessment.ReportDetail.components.MentalHealthChart.index.c3':
    '人际敏感',
  'src.pages.Assessment.ReportDetail.components.MentalHealthChart.index.c4':
    '抑郁',
  'src.pages.Assessment.ReportDetail.components.MentalHealthChart.index.c5':
    '焦虑',
  'src.pages.Assessment.ReportDetail.components.MentalHealthChart.index.c6':
    '敌对',
  'src.pages.Assessment.ReportDetail.components.MentalHealthChart.index.c7':
    '恐怖',
  'src.pages.Assessment.ReportDetail.components.MentalHealthChart.index.c8':
    '偏执',
  'src.pages.Assessment.ReportDetail.components.MentalHealthChart.index.c9':
    '精神病性',
  'src.pages.Assessment.ReportDetail.components.MentalHealthChart.index.c10':
    '饮食睡眠',
  'src.pages.Assessment.ReportDetail.components.MentalHealthTable.index.c1':
    '症状因子',
  'src.pages.Assessment.ReportDetail.components.MentalHealthTable.index.c2':
    '得分',
  'src.pages.Assessment.ReportDetail.components.MentalHealthTable.index.c3':
    '参考值',
  'src.pages.Assessment.ReportDetail.components.MentalHealthTable.index.c4':
    '结论',
  'src.pages.Assessment.ReportDetail.components.PaperWrap.index.c1': '编号',
  'src.pages.Assessment.ReportDetail.components.PhysiqueCharts.index.c1':
    '中医平和体质分析',
  'src.pages.Assessment.ReportDetail.components.PhysiqueCharts.index.c2':
    '当前状态',
  'src.pages.Assessment.ReportDetail.components.PhysiqueCharts.index.c3':
    '理想状态',
  'src.pages.Assessment.ReportDetail.components.PhysiqueCharts.index.c4': '是',
  'src.pages.Assessment.ReportDetail.components.PhysiqueCharts.index.c5':
    '中医偏颇体质分析',
  'src.pages.Assessment.ReportDetail.components.PhysiqueCharts.index.c6':
    '气虚质',
  'src.pages.Assessment.ReportDetail.components.PhysiqueCharts.index.c7':
    '阳虚质',
  'src.pages.Assessment.ReportDetail.components.PhysiqueCharts.index.c8':
    '阴虚质',
  'src.pages.Assessment.ReportDetail.components.PhysiqueCharts.index.c9':
    '湿热质',
  'src.pages.Assessment.ReportDetail.components.PhysiqueCharts.index.c10':
    '痰湿质',
  'src.pages.Assessment.ReportDetail.components.PhysiqueCharts.index.c11':
    '血瘀质',
  'src.pages.Assessment.ReportDetail.components.PhysiqueCharts.index.c12':
    '气郁质',
  'src.pages.Assessment.ReportDetail.components.PhysiqueCharts.index.c13':
    '特禀质',
  'src.pages.Assessment.ReportDetail.components.PhysiqueInfoPaper.index.c1':
    '详细特征',
  'src.pages.Assessment.ReportDetail.components.PhysiqueInfoPaper.index.c2':
    '保健建议',
  'src.pages.Assessment.ReportDetail.components.PhysiqueInfoPaper.index.c3':
    '常见疾病及防治建议',
  'src.pages.Assessment.ReportDetail.components.PhysiqueInfoPaper.index.c4':
    '中医药膳',
  'src.pages.Assessment.ReportDetail.components.PhysiqueInfoPaper.index.c5':
    '原料',
  'src.pages.Assessment.ReportDetail.components.PhysiqueInfoPaper.index.c6':
    '做法',
  'src.pages.Assessment.ReportDetail.components.PhysiqueInfoPaper.index.c7':
    '自我调理',
  'src.pages.Assessment.ReportDetail.components.PhysiqueTable.index.c1':
    '体质类型',
  'src.pages.Assessment.ReportDetail.components.PhysiqueTable.index.c2': '得分',
  'src.pages.Assessment.ReportDetail.components.PhysiqueTable.index.c3':
    '参考值',
  'src.pages.Assessment.ReportDetail.components.PhysiqueTable.index.c4':
    '平和质',
  'src.pages.Assessment.ReportDetail.components.PhysiqueTable.index.c5': '结论',
  'src.pages.Assessment.ReportDetail.components.PrefacePaper.index.c1': '前言',
  'src.pages.Assessment.ReportDetail.components.PrefacePaper.index.c2':
    '尊敬的{name}{gender}',
  'src.pages.Assessment.ReportDetail.components.PrefacePaper.index.c3':
    '您好！感谢您的信任，我们将秉承现代健康体检与健康管理服务理念，贯彻“专业、高效、科学、规范”的服务宗旨，为您的健康保驾护航。',
  'src.pages.Assessment.ReportDetail.components.PrefacePaper.index.c4':
    '在当代社会，人们越来越关注健康，但在实际追求健康的过程中，却常常无计可施。事实上，健康是有规律可循的，世界卫生组织指出：',
  'src.pages.Assessment.ReportDetail.components.PrefacePaper.index.c5':
    '人类的健康长寿7%取决于气候与地理条件；8%取决于医疗条件；10%取决于社会条件；15%取决于遗传；60%取决于个人的生活方式和行为。',
  'src.pages.Assessment.ReportDetail.components.PrefacePaper.index.c6':
    '因此，健康需要科学的管理，健康管理也是本世纪初全世界公认的可以改变目前人类健康现状，提升人类健康品质的一次继医疗产业之后的新产业革命。',
  'src.pages.Assessment.ReportDetail.components.PrefacePaper.index.c7':
    '健康管理的四大基石：',
  'src.pages.Assessment.ReportDetail.components.PrefacePaper.index.c8':
    '合理膳食、适量运动、戒烟限酒、心理平衡。',
  'src.pages.Assessment.ReportDetail.components.PrefacePaper.index.c9':
    '世界卫生组织提出，人们若能做到这四点，便可解决70%以上的健康行为问题，从而达到“预防疾病产生，促进身体健康，提高生命质量”的目的。',
  'src.pages.Assessment.ReportDetail.components.PrefacePaper.index.c10':
    '走进健康管理，首先从健康风险评估做起。',
  'src.pages.Assessment.ReportDetail.components.PrefacePaper.index.c11':
    '健康风险评估与健康管理措施有着密切的联系，健康风险评估通过对健康状况及未来患病风险性的全面考察和评估，有利于帮助您综合、正确地认识自身健康危险因素及其危害。',
  'src.pages.Assessment.ReportDetail.components.PrefacePaper.index.c12':
    '本健康风险评估报告将根据您的体检结果及健康问卷调查情况进行汇总分析，为您呈上个性化健康报告，提出综合评估结论和健康干预建议。健康干预建议主要包括以下几个方面：',
  'src.pages.Assessment.ReportDetail.components.PrefacePaper.index.c13':
    '1. 生理参数：主要为健康体检指标。',
  'src.pages.Assessment.ReportDetail.components.PrefacePaper.index.c14':
    '2.个人特征：日常习惯（主要从饮食、运动、心理、吸烟、饮酒、睡眠等不同的方面）；疾病家族史、职业等。',
  'src.pages.Assessment.ReportDetail.components.PrefacePaper.index.c15':
    '3. 环境因素包括暴露于不良的生活环境和生产环境等。',
  'src.pages.Assessment.ReportDetail.components.PrefacePaper.index.c16':
    '健康从了解自己的疾病风险开始，您可以仔细阅读并妥善保存这份个性化健康报告，重视自己的健康状况，并逐渐养成健康的生活方式。扫描报告尾页的二维码，查看更多个人健康档案信息及获取更多健康资讯。也可通过尾页的联系电话，联系您的专属健管师详细解读报告并制定个性化健康管理方案。',
  'src.pages.Assessment.ReportDetail.components.PrefacePaper.index.c17':
    '注：此报告仅为健康管理报告，不可作为诊断和治疗的依据。',
  'src.pages.Assessment.ReportDetail.components.RiskAssessCharts.index.c1':
    '风险等级',
  'src.pages.Assessment.ReportDetail.components.RiskAssessCharts.index.c2':
    '平均风险',
  'src.pages.Assessment.ReportDetail.components.RiskAssessCharts.index.c3':
    '当前状态',
  'src.pages.Assessment.ReportDetail.components.RiskAssessCharts.index.c4':
    '您患{remark}等级：',
  'src.pages.Assessment.ReportDetail.components.RiskAssessCharts.index.c5':
    '说明',
  'src.pages.Assessment.ReportDetail.components.RiskAssessCharts.index.c6':
    '已评估人群分布',
  'src.pages.Assessment.ReportDetail.components.RiskAssessCharts.index.c7':
    '您战胜',
  'src.pages.Assessment.ReportDetail.components.RiskAssessCharts.index.c8':
    '的用户',
  'src.pages.Assessment.ReportDetail.components.RiskAssessCharts.index.c9':
    '样本来源',
  'src.pages.Assessment.ReportDetail.components.RiskAssessCharts.index.c10':
    '东软集团、中国健康促进基金会和中华医学会健康管理学分会于2010年合作建立的基于各级各类健康管理（体检）机构的标准化健康信息数据库。',
  'src.pages.Assessment.ReportDetail.components.RiskAssessPaper.index.c1':
    '主要评估参数',
  'src.pages.Assessment.ReportDetail.components.RiskAssessPaper.index.c2':
    '您未来10年{remark}的发病风险等级',
  'src.pages.Assessment.ReportDetail.components.RiskAssessPaper.index.c3':
    '未评估',
  'src.pages.Assessment.ReportDetail.components.RiskAssessPaper.index.c4': '有',
  'src.pages.Assessment.ReportDetail.components.RiskAssessPaper.index.c5':
    '已患病',
  'src.pages.Assessment.ReportDetail.components.RiskAssessPaper.index.c6':
    '因缺失重要体检评估指标',
  'src.pages.Assessment.ReportDetail.components.RiskAssessPaper.index.c7':
    '您本次的患病风险等级未评估，您可以提供完整体检报告后重新进行患病风险评估',
  'src.pages.Assessment.ReportDetail.components.RiskAssessPaper.index.c8':
    '根据您的评估参数，您目前可能已患病，请及时就医并保持良好生活习惯',
  'src.pages.Assessment.ReportDetail.components.RiskAssessPaper.index.c9':
    '参数名称',
  'src.pages.Assessment.ReportDetail.components.RiskAssessPaper.index.c10':
    '本次结果',
  'src.pages.Assessment.ReportDetail.components.RiskAssessPaper.index.c11':
    '正常参考',
  'src.pages.Assessment.ReportDetail.components.RiskAssessPaper.index.c12':
    '可调因素建议',
  'src.pages.Assessment.ReportDetail.components.RiskAssessPaper.index.c13':
    'Framingham⾼⾎压⻛险指数·2008，中国成⼈⾼⾎压分析预测研究·2014，中国⾼⾎压基线指南·2018',
  'src.pages.Assessment.ReportDetail.components.RiskCatalog.index.c1': '目录',
  'src.pages.Assessment.ReportDetail.components.RiskCatalog.index.c2':
    '健康综合信息',
  'src.pages.Assessment.ReportDetail.components.RiskCatalog.index.c3':
    '健康信息汇总',
  'src.pages.Assessment.ReportDetail.components.RiskCatalog.index.c4':
    '重要指标情况',
  'src.pages.Assessment.ReportDetail.components.RiskCatalog.index.c5':
    '疾病风险评估',
  'src.pages.Assessment.ReportDetail.components.RiskCatalog.index.c6':
    '日常保健建议',
  'src.pages.Assessment.ReportDetail.components.RiskCatalog.index.c7':
    '生活方式分析',
  'src.pages.Assessment.ReportDetail.components.RiskCatalog.index.c8':
    '膳食结构分析',
  'src.pages.Assessment.ReportDetail.components.RiskCatalog.index.c9':
    '饮食保健建议',
  'src.pages.Assessment.ReportDetail.components.RiskCatalog.index.c10':
    '运动保健建议',
  'src.pages.Assessment.ReportDetail.components.RiskCatalog.index.c11':
    '睡眠保健建议',
  'src.pages.Assessment.ReportDetail.components.RiskCatalog.index.c12':
    '医学参考文献',
  'src.pages.Assessment.ReportDetail.components.ScoresBox.index.c1': '总分',
  'src.pages.Assessment.ReportDetail.components.ScoresBox.index.c2': '总均分',
  'src.pages.Assessment.ReportDetail.components.ScoresBox.index.c3':
    '阳性项目数',
  'src.pages.Assessment.ReportDetail.components.ScoresBox.index.c4': '阳性均分',
  'src.pages.Assessment.ReportDetail.components.ScoresBox.index.c5':
    'MentalHealth评估总均分',
  'src.pages.Assessment.ReportDetail.components.SleepHealthPaper.index.c1':
    '睡眠保健建议',
  'src.pages.Assessment.ReportDetail.components.SleepHealthPaper.index.c2':
    '睡眠质量整体情况',
  'src.pages.Assessment.ReportDetail.components.SleepHealthPaper.index.c3':
    '分',
  'src.pages.Assessment.ReportDetail.components.SleepHealthPaper.index.c4':
    '睡眠模型评估概况',
  'src.pages.Assessment.ReportDetail.components.SleepHealthPaper.index.c5':
    '说明',
  'src.pages.Assessment.ReportDetail.components.SleepHealthPaper.index.c6':
    '睡眠模型',
  'src.pages.Assessment.ReportDetail.components.SleepHealthPaper.index.c7':
    '所获分值',
  'src.pages.Assessment.ReportDetail.components.SleepHealthPaper.index.c8':
    '状态评估',
  'src.pages.Assessment.ReportDetail.components.SleepHealthPaper.index.c9':
    '具体现状',
  'src.pages.Assessment.ReportDetail.components.SleepHealthPaper.index.c10':
    '0分 (很好）；1分 (较好）；2分 (较差）；3分 (很差）',
  'src.pages.Assessment.ReportDetail.components.SleepHealthPaper.SleepNoticePaper.c1':
    '睡眠注意事项',
  'src.pages.Assessment.ReportDetail.components.SleepHealthPaper.SleepNoticePaper.c2':
    '睡眠质量好有利于提升免疫力、工作效率和专注力。可咨询健管师深度分析，实际的睡眠质量，并进行合理调整。',
  'src.pages.Assessment.ReportDetail.components.SleepHealthPaper.SleepNoticePaper.c3':
    '建议您在想睡觉的时候才上床，并且上床睡觉前要保持情绪稳定，请把忧虑暂时放在一边，闭上眼睛静静入眠。',
  'src.pages.Assessment.ReportDetail.components.SleepHealthPaper.SleepNoticePaper.c4':
    '每天保证7-8小时睡眠时间是很重要的，可以使人维持一个较稳定的生物节律，有益于身心健康。',
  'src.pages.Assessment.ReportDetail.components.SleepHealthPaper.SleepNoticePaper.c5':
    '您目前的睡眠效率很好，请继续保持，睡觉之前洗一个热水澡有助于放松肌肉，可令你睡得更好。',
  'src.pages.Assessment.ReportDetail.components.SleepHealthPaper.SleepNoticePaper.c6':
    '选择适合自己的寝具，室内保持适宜的温度和湿度，对提高睡眠质量，具有重要意义。',
  'src.pages.Assessment.ReportDetail.components.SleepHealthPaper.SleepNoticePaper.c7':
    '在服用安眠药之前一定要咨询医生，并且不能长期以来安眠药，更应注重日常习惯的改善。',
  'src.pages.Assessment.ReportDetail.components.SleepHealthPaper.SleepNoticePaper.c8':
    '税前保持安静，关掉电视和手机，对进一步提高睡眠质量是非常有益的。',
  'src.pages.Assessment.ReportDetail.components.SportHealthPaper.index.c1':
    '运动保健建议',
  'src.pages.Assessment.ReportDetail.components.SportHealthPaper.index.c2':
    '体重分析',
  'src.pages.Assessment.ReportDetail.components.SportHealthPaper.index.c3':
    '体脂率：',
  'src.pages.Assessment.ReportDetail.components.SportHealthPaper.index.c4':
    '目标体重范围：',
  'src.pages.Assessment.ReportDetail.components.SportHealthPaper.index.c5':
    '注：{TipsText}',
  'src.pages.Assessment.ReportDetail.components.SportHealthPaper.index.c6':
    '一周锻炼安排表',
  'src.pages.Assessment.ReportDetail.components.SportHealthPaper.index.c7':
    '体重分析',
  'src.pages.Assessment.ReportDetail.components.SportHealthPaper.index.c8':
    '体脂率：',
  'src.pages.Assessment.ReportDetail.components.SportHealthPaper.index.c9':
    '目标体重范围：',
  'src.pages.Assessment.ReportDetail.components.SportHealthPaper.index.c10':
    '体重指数为',
  'src.pages.Assessment.ReportDetail.components.SportHealthPaper.index.c11':
    '属于',
  'src.pages.Assessment.ReportDetail.components.SportHealthPaper.index.c12':
    '运动现状',
  'src.pages.Assessment.ReportDetail.components.SportHealthPaper.index.c13':
    '可调因素建议',
  'src.pages.Assessment.ReportDetail.components.SportHealthPaper.index.c14':
    '【说明】如果您想更全面的了解体适能的水平，请咨询运动管理师。',
  'src.pages.Assessment.ReportDetail.components.SportHealthPaper.SportAdvicePaper.c1':
    '运动保健建议',
  'src.pages.Assessment.ReportDetail.components.SportHealthPaper.SportAdvicePaper.c2':
    '运动强度自感应表',
  'src.pages.Assessment.ReportDetail.components.SportHealthPaper.SportAdvicePaper.c3':
    '经典运动',
  'src.pages.Assessment.ReportDetail.components.SportHealthPaper.SportAdvicePaper.c4':
    '分级方式',
  'src.pages.Assessment.ReportDetail.components.SportHealthPaper.SportAdvicePaper.c5':
    '低强度',
  'src.pages.Assessment.ReportDetail.components.SportHealthPaper.SportAdvicePaper.c6':
    '中等强度',
  'src.pages.Assessment.ReportDetail.components.SportHealthPaper.SportAdvicePaper.c7':
    '高强度',
  'src.pages.Assessment.ReportDetail.components.SportHealthPaper.SportAdvicePaper.c8':
    '注',
  'src.pages.Assessment.ReportDetail.components.SportHealthPaper.SportAdvicePaper.c9':
    '您可根据运动强度自感应表来自我判断运动的强度，若您有运动手环或心率检测设备，可参考心率储备百分比。',
  'src.pages.Assessment.ReportDetail.components.SportHealthPaper.SportAdvicePaper.c10':
    '【说明】如果您想更全面的了解体适能的水平，请咨询运动管理师。',
  'src.pages.Assessment.ReportDetail.components.SymptomFactorBox.index.c1':
    '理想',
  'src.pages.Assessment.ReportDetail.components.SymptomFactorBox.index.c2':
    '当前状态',
  'src.pages.Assessment.ReportDetail.components.SymptomFactorBox.index.c3':
    '理想状态',
  'src.pages.Assessment.ReportDetail.components.SymptomFactorBox.index.c4':
    '您的评估结果',
  'src.pages.Assessment.ReportDetail.components.SymptomFactorBox.index.c5':
    '已评估人群分布：您战胜',
  'src.pages.Assessment.ReportDetail.components.SymptomFactorBox.index.c6':
    '的用户',
  'src.pages.Assessment.ReportDetail.components.SymptomFactorBox.index.c7':
    '说明',
  'src.pages.Assessment.ReportDetail.index.c1': '心理健康评估报告',
  'src.pages.Assessment.ReportDetail.index.c2':
    '总均分: MentalHealth评估总均分',
  'src.pages.Assessment.ReportDetail.index.c3':
    '根据您完成的SCL90心理健康评估问卷得分，您近期的心理状况：',
  'src.pages.Assessment.ReportDetail.index.c4': '心理评测分析',
  'src.pages.Assessment.ReportDetail.index.c7': '评症状因子评分',
  'src.pages.Assessment.ReportDetail.index.c10': '温馨提示',
  'src.pages.Assessment.ReportDetail.index.c13': '症状因子分析',
  'src.pages.Assessment.ReportDetail.index.c16': 'MentalHealth评估总均分',
  'src.pages.Assessment.ReportDetail.index.c17': '评估结果汇总',
  'src.pages.Assessment.ReportDetail.index.c18': '症状因子',
  'src.pages.Assessment.ReportDetail.index.c19': '得分',
  'src.pages.Assessment.ReportDetail.index.c20': '参考值',
  'src.pages.Assessment.ReportDetail.index.c21': '结论',
  'src.pages.Assessment.ReportDetail.index.c22': '打印',
  'src.pages.Assessment.ReportDetail.index.c23':
    '《症状自评量表-SCL90》是世界上最著名的心理健康测试量表之一，是从感知、思维、情感、行为、人际关系、生活习惯等多种角度，评定一个人是否有某种心理症状及其严重程度如何。测评共90个项目，主要测试十个心理症状因子：躯体化、强迫症状、人际关系敏感、抑郁、焦虑、敌对、恐怖、偏执及精神病性以及附加因子，因子分用于反映有无各种心理症状及其严重程度。',
  'src.pages.Assessment.ReportDetail.index.c24':
    '本测评对有心理症状，即有可能处于心理障碍或心理障碍边缘的人有良好的区分能力。适用于测查某人群中那些人可能有心理障碍、某人可能有何种心理障碍及其严重程度如何。不适合于躁狂症和精神分裂症。',
  'src.pages.Assessment.ReportDetail.index.c25':
    '主要反映主观的身体不适感，包括心血管、胃肠道、呼吸和其他系统的不适，和头痛、背痛、肌肉酸痛，以及焦虑等躯体不适表现。',
  'src.pages.Assessment.ReportDetail.index.c26': '报告不存在',
  'src.pages.Assessment.ReportDetail.index.c27': '关闭页面',
  'src.pages.Assessment.ReportDetail.PhysiqueDetail.c1': '中医体质评估报告',
  'src.pages.Assessment.ReportDetail.PhysiqueDetail.c2':
    '将平和质移动到数组第一个，供 MultiColumnTableBox 使用',
  'src.pages.Assessment.ReportDetail.PhysiqueDetail.c3': '中医体质辨识',
  'src.pages.Assessment.ReportDetail.PhysiqueDetail.c5': '评估结果汇总',
  'src.pages.Assessment.ReportDetail.PhysiqueDetail.c7': '温馨提示',
  'src.pages.Assessment.ReportDetail.PhysiqueDetail.c9':
    '“亿万苍生，九种体质，人各有质，体病相关；体质平和，健康之源，体质偏颇，百病之因。”中医体质辨识，即以人的体质为认知对象，从体质状态及不同体质分类的特性，把握其健康与疾病的整体要素与个体差异的手段，从而制定防治原则，选择相应的治疗、预防、养生方法，进行“因人制宜”的干预。中医体质辨识为中医体质与易发健康风险的宏观对应开辟了新的标准化途径，通过体质辨识可以实现“未病先防”和“既病防变”的治未病目标。',
  'src.pages.Assessment.ReportDetail.PhysiqueDetail.c10':
    '从健康到亚健康再到疾病，体质因素的影响不可忽视，不同体质者在生理特性的表现、疾病易感性与发展上均有所不同。',
  'src.pages.Assessment.ReportDetail.PhysiqueDetail.c11': '是',
  'src.pages.Assessment.ReportDetail.PhysiqueDetail.c12': '倾向是',
  'src.pages.Assessment.ReportDetail.PhysiqueDetail.c13': '基本是',
  'src.pages.Assessment.ReportDetail.PhysiqueDetail.c14': '平和质',
  'src.pages.Assessment.ReportDetail.PhysiqueDetail.c15': '属于',
  'src.pages.Assessment.ReportDetail.PhysiqueDetail.c16': '倾向是',
  'src.pages.Assessment.ReportDetail.PhysiqueDetail.c17': '打印',
  'src.pages.Assessment.ReportDetail.PhysiqueDetail.c18':
    '根据问卷调查结果，您的体质判定结果',
  'src.pages.Assessment.ReportDetail.PhysiqueDetail.c19': '体质类型',
  'src.pages.Assessment.ReportDetail.PhysiqueDetail.c20': '得分',
  'src.pages.Assessment.ReportDetail.PhysiqueDetail.c21': '参考值',
  'src.pages.Assessment.ReportDetail.PhysiqueDetail.c22': '结论',
  'src.pages.Assessment.ReportDetail.PhysiqueDetail.c23': '否',
  'src.pages.Assessment.ReportDetail.PhysiqueDetail.c24':
    '现代学者的研究也证实了体质对某些致病因子确实具有易感性。因此，针对体质情况的不同进行个性诊疗、保健是很有必要的。通过中医体质的测试，我们根据您现有的体质，给您针对性的提供改善体质状况的方案，为您达到“未病先防”和“既病防变”的治未病目标。',
  'src.pages.Assessment.ReportDetail.RiskDetail.c1': '健康风险评估报告',
  'src.pages.Assessment.ReportDetail.RiskDetail.c2': '封面',
  'src.pages.Assessment.ReportDetail.RiskDetail.c3': '前言',
  'src.pages.Assessment.ReportDetail.RiskDetail.c4': '目录',
  'src.pages.Assessment.ReportDetail.RiskDetail.c5': '健康信息汇总',
  'src.pages.Assessment.ReportDetail.RiskDetail.c6': '重要指标情况',
  'src.pages.Assessment.ReportDetail.RiskDetail.c7': '疾病风险评估',
  'src.pages.Assessment.ReportDetail.RiskDetail.c8': '生活方式分析',
  'src.pages.Assessment.ReportDetail.RiskDetail.c9': '膳食结构分析',
  'src.pages.Assessment.ReportDetail.RiskDetail.c10': '饮食保健建议',
  'src.pages.Assessment.ReportDetail.RiskDetail.c11': '运动保健建议',
  'src.pages.Assessment.ReportDetail.RiskDetail.c12':
    '运动保健建议 -- 运动训练、运动强度自感应表',
  'src.pages.Assessment.ReportDetail.RiskDetail.c13': '睡眠保健建议',
  'src.pages.Assessment.ReportDetail.RiskDetail.c14':
    '睡眠保健建议 -- 睡眠注意事项',
  'src.pages.Assessment.ReportDetail.RiskDetail.c15': '医学参考文献',
  'src.pages.Assessment.ReportDetail.RiskDetail.c16': '封底',
  'src.pages.Assessment.ReportDetail.RiskDetail.c17': '风险评估',
  'src.pages.Assessment.ReportDetail.RiskDetail.c18': '评估',
  'src.pages.Assessment.ReportDetail.RiskDetail.c19': '睡眠',
  'src.pages.Assessment.ReportDetail.RiskDetail.c20': '生活方式',
  'src.pages.Assessment.ReportDetail.RiskDetail.c21': '分',
  'src.pages.Assessment.ReportDetail.RiskDetail.c22': '打印',
  'src.pages.Assessment.ReportDetail.RiskDetail.c23': '年',
  'src.pages.Assessment.ReportDetail.RiskDetail.c24': '月',
  'src.pages.Assessment.ReportDetail.RiskDetail.c25': '日',
  'src.pages.ContentManage.Food.index.c1': '配餐方案库',
  'src.pages.ContentManage.Food.index.c2': '菜品库',
  'src.pages.ContentManage.Food.components.ContentFoodFC.c1': '菜品名称',
  'src.pages.ContentManage.Food.components.ContentFoodFC.c2': '菜品分类',
  'src.pages.ContentManage.Food.components.ContentFoodFC.c3': '菜系',
  'src.pages.ContentManage.Food.components.ContentFoodFC.c4': '烹饪方法',
  'src.pages.ContentManage.Food.components.ContentFoodFC.c5': '能量',
  'src.pages.ContentManage.Food.components.ContentFoodFC.c6': '蛋白质',
  'src.pages.ContentManage.Food.components.ContentFoodFC.c7': '脂肪',
  'src.pages.ContentManage.Food.components.ContentFoodFC.c8': '碳水化合物',
  'src.pages.ContentManage.Food.components.ContentFoodFC.c9': '操作',
  'src.pages.ContentManage.Food.components.ContentFoodFC.c10': '详情',
  'src.pages.ContentManage.Food.components.ContentFoodPlanFC.c1': '启用',
  'src.pages.ContentManage.Food.components.ContentFoodPlanFC.c2': '关闭',
  'src.pages.ContentManage.Food.components.ContentFoodPlanFC.c3': '成功',
  'src.pages.ContentManage.Food.components.ContentFoodPlanFC.c4': '方案标题',
  'src.pages.ContentManage.Food.components.ContentFoodPlanFC.c5': '使用人数',
  'src.pages.ContentManage.Food.components.ContentFoodPlanFC.c6': '是否清真',
  'src.pages.ContentManage.Food.components.ContentFoodPlanFC.c7': '是',
  'src.pages.ContentManage.Food.components.ContentFoodPlanFC.c8': '否',
  'src.pages.ContentManage.Food.components.ContentFoodPlanFC.c9': '适用人群',
  'src.pages.ContentManage.Food.components.ContentFoodPlanFC.c10': '方案天数',
  'src.pages.ContentManage.Food.components.ContentFoodPlanFC.c11': '权限类型',
  'src.pages.ContentManage.Food.components.ContentFoodPlanFC.c12': '系统',
  'src.pages.ContentManage.Food.components.ContentFoodPlanFC.c13': '自定义',
  'src.pages.ContentManage.Food.components.ContentFoodPlanFC.c14': '启用状态',
  'src.pages.ContentManage.Food.components.ContentFoodPlanFC.c15': '操作',
  'src.pages.ContentManage.Food.components.ContentFoodPlanFC.c16': '编辑',
  'src.pages.ContentManage.Food.components.ContentFoodPlanFC.c17': '查看',
  'src.pages.ContentManage.Food.components.ContentFoodPlanFC.c18': '复制',
  'src.pages.ContentManage.Food.components.ContentFoodPlanFC.c19':
    '确认要{handle}该干预方案？',
  'src.pages.ContentManage.Food.components.ContentFoodPlanFC.c20': '开启',
  'src.pages.ContentManage.Food.components.ContentFoodPlanFC.c21': '添加方案',
  'src.pages.ContentManage.Food.components.ContentFoodPlanFC.c22': '是否素食',
  'src.pages.ContentManage.FoodPlanUpdate.index.c1': '{action}配餐方案模板',
  'src.pages.ContentManage.FoodPlanUpdate.index.c2': '保存成功',
  'src.pages.ContentManage.FoodPlanUpdate.index.c3': '请求失败，请稍后重试',
  'src.pages.ContentManage.FoodPlanUpdate.index.c4': '方案标题',
  'src.pages.ContentManage.FoodPlanUpdate.index.c5': '请输入方案标题',
  'src.pages.ContentManage.FoodPlanUpdate.index.c6': '适用人群',
  'src.pages.ContentManage.FoodPlanUpdate.index.c7': '标签',
  'src.pages.ContentManage.FoodPlanUpdate.index.c8': '是否清真',
  'src.pages.ContentManage.FoodPlanUpdate.index.c9': '否',
  'src.pages.ContentManage.FoodPlanUpdate.index.c10': '是',
  'src.pages.ContentManage.FoodPlanUpdate.index.c11': '简介',
  'src.pages.ContentManage.FoodPlanUpdate.index.c12': '请输入简介说明',
  'src.pages.ContentManage.FoodPlanUpdate.index.c13': '启用状态',
  'src.pages.ContentManage.FoodPlanUpdate.index.c14': '启用',
  'src.pages.ContentManage.FoodPlanUpdate.index.c15': '关闭',
  'src.pages.ContentManage.FoodPlanUpdate.index.c16': '封面图片',
  'src.pages.ContentManage.FoodPlanUpdate.index.c17':
    '说明：可上传1张封面图片，建议图片宽高比例为1:1，图片大小不超过2MB。',
  'src.pages.ContentManage.FoodPlanUpdate.index.c18': '方案设置',
  'src.pages.ContentManage.FoodPlanUpdate.index.c19': '提交',
  'src.pages.ContentManage.FoodPlanUpdate.index.c20': '取消',
  'src.pages.ContentManage.FoodPlanUpdate.index.c21': '是否素食',
  'src.pages.ContentManage.FoodPlanUpdate.index.c22': '模板中导入',
  'src.pages.ContentManage.FoodPlanUpdate.index.c23': '导入膳食原则',
  'src.pages.ContentManage.FoodPlanUpdate.index.c24': '自动生成',
  'src.pages.ContentManage.FoodPlanUpdate.index.c25': '谷薯类',
  'src.pages.ContentManage.FoodPlanUpdate.index.c26': '肉类',
  'src.pages.ContentManage.FoodPlanUpdate.index.c27': '鱼虾',
  'src.pages.ContentManage.FoodPlanUpdate.index.c28': '蛋类',
  'src.pages.ContentManage.FoodPlanUpdate.index.c29': '奶及奶制品',
  'src.pages.ContentManage.FoodPlanUpdate.index.c31': '大豆及坚果类',
  'src.pages.ContentManage.FoodPlanUpdate.index.c32': '蔬菜',
  'src.pages.ContentManage.FoodPlanUpdate.index.c33': '水果',
  'src.pages.ContentManage.FoodPlanUpdate.index.c34': '成分',
  'src.pages.ContentManage.FoodPlanUpdate.index.c35': '推荐量',
  'src.pages.ContentManage.FoodPlanUpdate.index.c36': '提供量',
  'src.pages.ContentManage.FoodPlanUpdate.index.c37': '物质及能量分配',
  'src.pages.ContentManage.FoodPlanUpdate.index.c38': '膳食纤维',
  'src.pages.ContentManage.FoodPlanUpdate.index.c39':
    '动物性及豆类蛋白质占总蛋白质比例',
  'src.pages.ContentManage.FoodPlanUpdate.index.c40': '动物性',
  'src.pages.ContentManage.FoodPlanUpdate.index.c41': '豆类',
  'src.pages.ContentManage.FoodPlanUpdate.index.c42': '其他',
  'src.pages.ContentManage.FoodPlanUpdate.index.c43': '营养食谱分析',
  'src.pages.ContentManage.FoodPlanUpdate.index.c44': '蛋白质',
  'src.pages.ContentManage.FoodPlanUpdate.index.c45': '脂肪',
  'src.pages.ContentManage.FoodPlanUpdate.index.c46': '碳水化合物',
  'src.pages.ContentManage.FoodPlanUpdate.index.c47': '指标量过高',
  'src.pages.ContentManage.FoodPlanUpdate.index.c48': '指标量过低',

  'src.pages.ContentManage.FoodPlanUpdate.Components.ChooseDishesModal.index.c1':
    '菜品名称',
  'src.pages.ContentManage.FoodPlanUpdate.Components.ChooseDishesModal.index.c2':
    '菜品分类',
  'src.pages.ContentManage.FoodPlanUpdate.Components.ChooseDishesModal.index.c3':
    '菜系',
  'src.pages.ContentManage.FoodPlanUpdate.Components.ChooseDishesModal.index.c4':
    '适用人群',
  'src.pages.ContentManage.FoodPlanUpdate.Components.ChooseDishesModal.index.c5':
    '禁用人群',
  'src.pages.ContentManage.FoodPlanUpdate.Components.ChooseDishesModal.index.c6':
    '疾病禁忌',
  'src.pages.ContentManage.FoodPlanUpdate.Components.ChooseDishesModal.index.c7':
    '选择菜品',
  'src.pages.ContentManage.FoodPlanUpdate.Components.ChooseDishesModal.index.c8':
    '取消',
  'src.pages.ContentManage.FoodPlanUpdate.Components.ChooseDishesModal.index.c9':
    '确认',
  'src.pages.ContentManage.FoodPlanUpdate.Components.CollapseDishes.index.c1':
    '确认删除该菜品吗？',
  'src.pages.ContentManage.FoodPlanUpdate.Components.CollapseDishes.index.c2':
    '未知',
  'src.pages.ContentManage.FoodPlanUpdate.Components.EditContentFoodGroup.index.c1':
    '提示',
  'src.pages.ContentManage.FoodPlanUpdate.Components.EditContentFoodGroup.index.c2':
    '请确认是否复制本日配餐方案，并新增成为新一天的方案？',
  'src.pages.ContentManage.FoodPlanUpdate.Components.EditContentFoodGroup.index.c3':
    '确认要新增配餐方案吗？',
  'src.pages.ContentManage.FoodPlanUpdate.Components.EditContentFoodGroup.index.c4':
    '复制',
  'src.pages.ContentManage.FoodPlanUpdate.Components.EditContentFoodGroup.index.c5':
    '新增',
  'src.pages.ContentManage.FoodPlanUpdate.Components.EditContentFoodGroup.index.c6':
    '成功',
  'src.pages.ContentManage.FoodPlanUpdate.Components.EditContentFoodGroup.index.c7':
    '最多配置{maxDay}天配餐方案',
  'src.pages.ContentManage.FoodPlanUpdate.Components.EditContentFoodGroup.index.c8':
    '确认要删除当日配餐方案吗？',
  'src.pages.ContentManage.FoodPlanUpdate.Components.EditContentFoodGroup.index.c9':
    '删除成功',
  'src.pages.ContentManage.FoodPlanUpdate.Components.EditContentFoodGroup.index.c10':
    '最少配置{minDay}天配餐方案',
  'src.pages.ContentManage.FoodPlanUpdate.Components.EditContentFoodGroup.index.c11':
    '第{num}天早餐不能为空',
  'src.pages.ContentManage.FoodPlanUpdate.Components.EditContentFoodGroup.index.c12':
    '第{num}天午餐不能为空',
  'src.pages.ContentManage.FoodPlanUpdate.Components.EditContentFoodGroup.index.c13':
    '第{num}天晚餐不能为空',
  'src.pages.ContentManage.FoodPlanUpdate.Components.EditContentFoodGroup.index.c14':
    '第{num}天',
  'src.pages.ContentManage.FoodPlanUpdate.Components.EditContentFoodGroup.index.c15':
    '本日营养素汇总',
  'src.pages.ContentManage.FoodPlanUpdate.Components.EditContentFoodGroup.index.c16':
    '复制本日套餐',
  'src.pages.ContentManage.FoodPlanUpdate.Components.EditContentFoodGroup.index.c17':
    '能量',
  'src.pages.ContentManage.FoodPlanUpdate.Components.EditContentFoodGroup.index.c18':
    '碳水化合物',
  'src.pages.ContentManage.FoodPlanUpdate.Components.EditContentFoodGroup.index.c19':
    '蛋白质',
  'src.pages.ContentManage.FoodPlanUpdate.Components.EditContentFoodGroup.index.c20':
    '脂肪',
  'src.pages.ContentManage.FoodPlanUpdate.Components.EditContentFoodGroup.index.c21':
    '各餐次能量汇总',
  'src.pages.ContentManage.FoodPlanUpdate.Components.EditContentFoodGroup.index.c22':
    '单位',
  'src.pages.ContentManage.FoodPlanUpdate.Components.EditContentFoodGroup.index.c23':
    '早餐',
  'src.pages.ContentManage.FoodPlanUpdate.Components.EditContentFoodGroup.index.c24':
    '午餐',
  'src.pages.ContentManage.FoodPlanUpdate.Components.EditContentFoodGroup.index.c25':
    '加餐',
  'src.pages.ContentManage.FoodPlanUpdate.Components.EditContentFoodGroup.index.c26':
    '晚餐',
  'src.pages.ContentManage.FoodPlanUpdate.Components.EditContentFoodGroup.index.c27':
    '营养素分析',
  'src.pages.ContentManage.FoodPlanUpdate.Components.EditContentFoodGroup.index.c28':
    '最少选择一个菜品',
  'src.pages.ContentManage.FoodPlanUpdate.Components.NurientAnalysisModal.index.c1':
    '成分',
  'src.pages.ContentManage.FoodPlanUpdate.Components.NurientAnalysisModal.index.c2':
    '提供量',
  'src.pages.ContentManage.FoodPrinciple.index.c1': '适用人群',
  'src.pages.ContentManage.FoodPrinciple.index.c2': '膳食原则',
  'src.pages.ContentManage.Intervention.index.c1': '操作',
  'src.pages.ContentManage.Intervention.index.c2': '启用',
  'src.pages.ContentManage.Intervention.index.c3': '关闭',
  'src.pages.ContentManage.Intervention.index.c4': '成功',
  'src.pages.ContentManage.Intervention.index.c5': '方案标题',
  'src.pages.ContentManage.Intervention.index.c6': '方案类型',
  'src.pages.ContentManage.Intervention.index.c7': '方案简述',
  'src.pages.ContentManage.Intervention.index.c8': '标签',
  'src.pages.ContentManage.Intervention.index.c9': '适用人群',
  'src.pages.ContentManage.Intervention.index.c10': '权限类型',
  'src.pages.ContentManage.Intervention.index.c11': '系统',
  'src.pages.ContentManage.Intervention.index.c12': '自定义',
  'src.pages.ContentManage.Intervention.index.c13': '启用状态',
  'src.pages.ContentManage.Intervention.index.c14': '编辑',
  'src.pages.ContentManage.Intervention.index.c15': '查看',
  'src.pages.ContentManage.Intervention.index.c16': '复制',
  'src.pages.ContentManage.Intervention.index.c17': '确认要',
  'src.pages.ContentManage.Intervention.index.c18': '开启',
  'src.pages.ContentManage.Intervention.index.c19': '该干预方案',
  'src.pages.ContentManage.Intervention.index.c20': '添加方案',
  'src.pages.ContentManage.InterventionUpdate.index.c1': '方案标题',
  'src.pages.ContentManage.InterventionUpdate.index.c2': '清空表单',
  'src.pages.ContentManage.InterventionUpdate.index.c3': '方案类型',
  'src.pages.ContentManage.InterventionUpdate.index.c4': '清空表单',
  'src.pages.ContentManage.InterventionUpdate.index.c5': '标签',
  'src.pages.ContentManage.InterventionUpdate.index.c6': '清空表单',
  'src.pages.ContentManage.InterventionUpdate.index.c7': '适用人群',
  'src.pages.ContentManage.InterventionUpdate.index.c8': '清空表单',
  'src.pages.ContentManage.InterventionUpdate.index.c9': '简介',
  'src.pages.ContentManage.InterventionUpdate.index.c10': '清空表单',
  'src.pages.ContentManage.InterventionUpdate.index.c11': '请输入简介说明',
  'src.pages.ContentManage.InterventionUpdate.index.c12': '清空表单',
  'src.pages.ContentManage.InterventionUpdate.index.c13': '启用状态',
  'src.pages.ContentManage.InterventionUpdate.index.c14': '清空表单',
  'src.pages.ContentManage.InterventionUpdate.index.c15': '干预方案',
  'src.pages.ContentManage.InterventionUpdate.index.c16': '保存成功',
  'src.pages.ContentManage.InterventionUpdate.index.c17': '未知错误',
  'src.pages.ContentManage.InterventionUpdate.index.c18': '请输入方案标题',
  'src.pages.ContentManage.InterventionUpdate.index.c19': '请选择方案类型',
  'src.pages.ContentManage.InterventionUpdate.index.c20': '启用',
  'src.pages.ContentManage.InterventionUpdate.index.c21': '关闭',
  'src.pages.ContentManage.InterventionUpdate.index.c22': '方案详情',
  'src.pages.ContentManage.InterventionUpdate.index.c23': '提交',
  'src.pages.ContentManage.InterventionUpdate.index.c24': '取消',
  'src.pages.ContentManage.Medicine.index.c1': '操作',
  'src.pages.ContentManage.Medicine.index.c2': '启用',
  'src.pages.ContentManage.Medicine.index.c3': '关闭',
  'src.pages.ContentManage.Medicine.index.c4': '成功',
  'src.pages.ContentManage.Medicine.index.c5': '药品',
  'src.pages.ContentManage.Medicine.index.c6': '药品分类',
  'src.pages.ContentManage.Medicine.index.c7': '厂商',
  'src.pages.ContentManage.Medicine.index.c8': '规格',
  'src.pages.ContentManage.Medicine.index.c9': '价格',
  'src.pages.ContentManage.Medicine.index.c10': '',
  'src.pages.ContentManage.Medicine.index.c11': '权限类型',
  'src.pages.ContentManage.Medicine.index.c12': '自定义',
  'src.pages.ContentManage.Medicine.index.c13': '系统',
  'src.pages.ContentManage.Medicine.index.c14': '可用状态',
  'src.pages.ContentManage.Medicine.index.c15': '编辑',
  'src.pages.ContentManage.Medicine.index.c16': '查看',
  'src.pages.ContentManage.Medicine.index.c17': '复制',
  'src.pages.ContentManage.Medicine.index.c18': '确认要',
  'src.pages.ContentManage.Medicine.index.c19': '开启',
  'src.pages.ContentManage.Medicine.index.c20': '该药品',
  'src.pages.ContentManage.Medicine.index.c21': '添加药品',
  'src.pages.ContentManage.Medicine.UpdateMedicine.index.c1': '药品名称',
  'src.pages.ContentManage.Medicine.UpdateMedicine.index.c2':
    '每次打开弹框的时候更新表单，避免 initialValue 不更新',
  'src.pages.ContentManage.Medicine.UpdateMedicine.index.c3': '药品分类',
  'src.pages.ContentManage.Medicine.UpdateMedicine.index.c5': '品牌',
  'src.pages.ContentManage.Medicine.UpdateMedicine.index.c7': '厂商',
  'src.pages.ContentManage.Medicine.UpdateMedicine.index.c9': '规格',
  'src.pages.ContentManage.Medicine.UpdateMedicine.index.c11': '价格',
  'src.pages.ContentManage.Medicine.UpdateMedicine.index.c13': '药品图片',
  'src.pages.ContentManage.Medicine.UpdateMedicine.index.c15': '{action}药品',
  'src.pages.ContentManage.Medicine.UpdateMedicine.index.c16': '关闭',
  'src.pages.ContentManage.Medicine.UpdateMedicine.index.c17': '成功',
  'src.pages.ContentManage.Medicine.UpdateMedicine.index.c18':
    '失败，请稍后重试',
  'src.pages.ContentManage.Medicine.UpdateMedicine.index.c19': '请输入药品名称',
  'src.pages.ContentManage.Medicine.UpdateMedicine.index.c20':
    '说明：建议上传最多9张清晰的药盒或药品图片，建议图片宽高至少在300px以上',
  'src.pages.ContentManage.ReturnVisit.index.c1': '操作',
  'src.pages.ContentManage.ReturnVisit.index.c2': '启用',
  'src.pages.ContentManage.ReturnVisit.index.c3': '关闭',
  'src.pages.ContentManage.ReturnVisit.index.c4': '成功',
  'src.pages.ContentManage.ReturnVisit.index.c5': '方案标题',
  'src.pages.ContentManage.ReturnVisit.index.c6': '方案类型',
  'src.pages.ContentManage.ReturnVisit.index.c7': '回访话术',
  'src.pages.ContentManage.ReturnVisit.index.c8': '标签',
  'src.pages.ContentManage.ReturnVisit.index.c9': '适用人群',
  'src.pages.ContentManage.ReturnVisit.index.c10': '权限类型',
  'src.pages.ContentManage.ReturnVisit.index.c11': '系统',
  'src.pages.ContentManage.ReturnVisit.index.c12': '自定义',
  'src.pages.ContentManage.ReturnVisit.index.c13': '启用状态',
  'src.pages.ContentManage.ReturnVisit.index.c14': '编辑',
  'src.pages.ContentManage.ReturnVisit.index.c15': '查看',
  'src.pages.ContentManage.ReturnVisit.index.c16': '复制',
  'src.pages.ContentManage.ReturnVisit.index.c17': '确认要',
  'src.pages.ContentManage.ReturnVisit.index.c18': '开启',
  'src.pages.ContentManage.ReturnVisit.index.c19': '该回访话术',
  'src.pages.ContentManage.ReturnVisit.index.c20': '添加方案',
  'src.pages.ContentManage.ReturnVisitUpdate.index.c1': '方案标题',
  'src.pages.ContentManage.ReturnVisitUpdate.index.c2': '方案类型',
  'src.pages.ContentManage.ReturnVisitUpdate.index.c3': '标签',
  'src.pages.ContentManage.ReturnVisitUpdate.index.c4': '适用人群',
  'src.pages.ContentManage.ReturnVisitUpdate.index.c5': '回访话术',
  'src.pages.ContentManage.ReturnVisitUpdate.index.c6': '请输入',
  'src.pages.ContentManage.ReturnVisitUpdate.index.c7': '启用状态',
  'src.pages.ContentManage.ReturnVisitUpdate.index.c8': '保存成功',
  'src.pages.ContentManage.ReturnVisitUpdate.index.c9': '未知错误',
  'src.pages.ContentManage.ReturnVisitUpdate.index.c10': '请输入方案标题',
  'src.pages.ContentManage.ReturnVisitUpdate.index.c11': '请选择方案类型',
  'src.pages.ContentManage.ReturnVisitUpdate.index.c12': '启用',
  'src.pages.ContentManage.ReturnVisitUpdate.index.c13': '关闭',
  'src.pages.ContentManage.ReturnVisitUpdate.index.c14': '提交',
  'src.pages.ContentManage.ReturnVisitUpdate.index.c15': '取消',
  'src.pages.ContentManage.ServicePlan.index.c1': '操作',
  'src.pages.ContentManage.ServicePlan.index.c2': '启用',
  'src.pages.ContentManage.ServicePlan.index.c3': '关闭',
  'src.pages.ContentManage.ServicePlan.index.c4': '成功',
  'src.pages.ContentManage.ServicePlan.index.c5': '方案标题',
  'src.pages.ContentManage.ServicePlan.index.c6': '方案类型',
  'src.pages.ContentManage.ServicePlan.index.c7': '方案简述',
  'src.pages.ContentManage.ServicePlan.index.c8': '标签',
  'src.pages.ContentManage.ServicePlan.index.c9': '适用人群',
  'src.pages.ContentManage.ServicePlan.index.c10': '权限类型',
  'src.pages.ContentManage.ServicePlan.index.c11': '系统',
  'src.pages.ContentManage.ServicePlan.index.c12': '自定义',
  'src.pages.ContentManage.ServicePlan.index.c13': '启用状态',
  'src.pages.ContentManage.ServicePlan.index.c14': '编辑',
  'src.pages.ContentManage.ServicePlan.index.c15': '查看',
  'src.pages.ContentManage.ServicePlan.index.c16': '复制',
  'src.pages.ContentManage.ServicePlan.index.c17': '确认要',
  'src.pages.ContentManage.ServicePlan.index.c18': '开启',
  'src.pages.ContentManage.ServicePlan.index.c19': '该服务方案',
  'src.pages.ContentManage.ServicePlan.index.c20': '添加方案',
  'src.pages.ContentManage.ServicePlanUpdate.index.c1': '方案标题',
  'src.pages.ContentManage.ServicePlanUpdate.index.c2': '方案类型',
  'src.pages.ContentManage.ServicePlanUpdate.index.c3': '标签',
  'src.pages.ContentManage.ServicePlanUpdate.index.c4': '适用人群',
  'src.pages.ContentManage.ServicePlanUpdate.index.c5': '简介',
  'src.pages.ContentManage.ServicePlanUpdate.index.c6': '请输入简介说明',
  'src.pages.ContentManage.ServicePlanUpdate.index.c7': '启用状态',
  'src.pages.ContentManage.ServicePlanUpdate.index.c8': '服务方案',
  'src.pages.ContentManage.ServicePlanUpdate.index.c9': '保存成功',
  'src.pages.ContentManage.ServicePlanUpdate.index.c10': '未知错误',
  'src.pages.ContentManage.ServicePlanUpdate.index.c11': '请输入方案标题',
  'src.pages.ContentManage.ServicePlanUpdate.index.c12': '请选择方案类型',
  'src.pages.ContentManage.ServicePlanUpdate.index.c13': '启用',
  'src.pages.ContentManage.ServicePlanUpdate.index.c14': '关闭',
  'src.pages.ContentManage.ServicePlanUpdate.index.c15': '方案详情',
  'src.pages.ContentManage.ServicePlanUpdate.index.c16': '提交',
  'src.pages.ContentManage.ServicePlanUpdate.index.c17': '取消',
  'src.pages.ContentManage.ServicePlanUpdate.index.c18': '新增',
  'src.pages.ContentManage.ServicePlanUpdate.index.c19': '编辑',
  'src.pages.ContentManage.ServicePlanUpdate.index.c20': '复制',
  'src.pages.ContentManage.ServicePlanUpdate.index.c21': '查看',
  'src.pages.ContentManage.SmsTemplate.index.c1': '编号',
  'src.pages.ContentManage.SmsTemplate.index.c2': '名称',
  'src.pages.ContentManage.SmsTemplate.index.c3': '短信模板',
  'src.pages.ContentManage.SportPlan.index.c1': '运动方案模板',
  'src.pages.ContentManage.SportPlan.index.c2': '运动方式库',
  'src.pages.ContentManage.SportPlan.components.SportPlan.c1': '启用',
  'src.pages.ContentManage.SportPlan.components.SportPlan.c2': '关闭',
  'src.pages.ContentManage.SportPlan.components.SportPlan.c3': '成功',
  'src.pages.ContentManage.SportPlan.components.SportPlan.c4': '方案标题',
  'src.pages.ContentManage.SportPlan.components.SportPlan.c5': '方案简述',
  'src.pages.ContentManage.SportPlan.components.SportPlan.c6': '适用人群',
  'src.pages.ContentManage.SportPlan.components.SportPlan.c7': '权限类型',
  'src.pages.ContentManage.SportPlan.components.SportPlan.c8': '系统',
  'src.pages.ContentManage.SportPlan.components.SportPlan.c9': '自定义',
  'src.pages.ContentManage.SportPlan.components.SportPlan.c10':
    '总消耗热量(kcal)',
  'src.pages.ContentManage.SportPlan.components.SportPlan.c11': '启用状态',
  'src.pages.ContentManage.SportPlan.components.SportPlan.c12': '操作',
  'src.pages.ContentManage.SportPlan.components.SportPlan.c13': '编辑',
  'src.pages.ContentManage.SportPlan.components.SportPlan.c14': '查看',
  'src.pages.ContentManage.SportPlan.components.SportPlan.c15': '复制',
  'src.pages.ContentManage.SportPlan.components.SportPlan.c16':
    '确认要{handle}该运动方案？',
  'src.pages.ContentManage.SportPlan.components.SportPlan.c17': '添加运动方案',
  'src.pages.ContentManage.SportPlan.components.SportPlan.c18': '开启',
  'src.pages.ContentManage.SportPlan.components.SportType.c1': '启用',
  'src.pages.ContentManage.SportPlan.components.SportType.c2': '关闭',
  'src.pages.ContentManage.SportPlan.components.SportType.c3': '成功',
  'src.pages.ContentManage.SportPlan.components.SportType.c4': '运动名称',
  'src.pages.ContentManage.SportPlan.components.SportType.c5': '运动类型',
  'src.pages.ContentManage.SportPlan.components.SportType.c6': '运动强度',
  'src.pages.ContentManage.SportPlan.components.SportType.c7':
    '消耗热量(kcal/kg*min)',
  'src.pages.ContentManage.SportPlan.components.SportType.c8': '权限类型',
  'src.pages.ContentManage.SportPlan.components.SportType.c9': '系统',
  'src.pages.ContentManage.SportPlan.components.SportType.c10': '自定义',
  'src.pages.ContentManage.SportPlan.components.SportType.c11': '启用状态',
  'src.pages.ContentManage.SportPlan.components.SportType.c12': '操作',
  'src.pages.ContentManage.SportPlan.components.SportType.c13': '编辑',
  'src.pages.ContentManage.SportPlan.components.SportType.c14': '查看',
  'src.pages.ContentManage.SportPlan.components.SportType.c15': '复制',
  'src.pages.ContentManage.SportPlan.components.SportType.c16':
    '确认要{handle}该运动方式？',
  'src.pages.ContentManage.SportPlan.components.SportType.c17': '开启',
  'src.pages.ContentManage.SportPlan.components.SportType.c18': '添加运动方式',
  'src.pages.ContentManage.SportPlan.components.UpdateSportType.c1':
    '{action}运动方式',
  'src.pages.ContentManage.SportPlan.components.UpdateSportType.c2': '关闭',
  'src.pages.ContentManage.SportPlan.components.UpdateSportType.c3':
    '{action}成功',
  'src.pages.ContentManage.SportPlan.components.UpdateSportType.c4':
    '{action}失败，请稍后重试',
  'src.pages.ContentManage.SportPlan.components.UpdateSportType.c5': '运动类型',
  'src.pages.ContentManage.SportPlan.components.UpdateSportType.c6':
    '请选择运动类型',
  'src.pages.ContentManage.SportPlan.components.UpdateSportType.c7': '运动强度',
  'src.pages.ContentManage.SportPlan.components.UpdateSportType.c8':
    '请选择运动强度',
  'src.pages.ContentManage.SportPlan.components.UpdateSportType.c9': '运动名称',
  'src.pages.ContentManage.SportPlan.components.UpdateSportType.c10':
    '请输入运动名称',
  'src.pages.ContentManage.SportPlan.components.UpdateSportType.c11':
    '消耗热量(kcal/kg*min)',
  'src.pages.ContentManage.SportPlan.components.UpdateSportType.c12':
    '请输入热量',
  'src.pages.ContentManage.SportPlan.components.UpdateSportType.c13':
    '运动描述',
  'src.pages.ContentManage.SportPlan.components.UpdateSportType.c14':
    '请输入题目描述文件，用于辅助用户理解题目意思',
  'src.pages.ContentManage.SportPlan.components.UpdateSportType.c15':
    '封面图片',
  'src.pages.ContentManage.SportPlan.components.UpdateSportType.c16':
    '说明：可上传1张封面图片，建议图片宽高比例为1:1，图片大小不超过2MB。',
  'src.pages.ContentManage.SportPlan.components.UpdateSportType.c17': '新增',
  'src.pages.ContentManage.SportPlan.components.UpdateSportType.c18': '编辑',
  'src.pages.ContentManage.SportPlan.components.UpdateSportType.c19': '复制',
  'src.pages.ContentManage.SportPlan.components.UpdateSportType.c20': '查看',
  'src.pages.ContentManage.SportPlanUpdate.index.c1': '{action}运动方案模板',
  'src.pages.ContentManage.SportPlanUpdate.index.c2': '保存成功',
  'src.pages.ContentManage.SportPlanUpdate.index.c3': '未知错误',
  'src.pages.ContentManage.SportPlanUpdate.index.c4': '方案标题',
  'src.pages.ContentManage.SportPlanUpdate.index.c5': '请输入方案标题',
  'src.pages.ContentManage.SportPlanUpdate.index.c6': '适用人群',
  'src.pages.ContentManage.SportPlanUpdate.index.c7': '简介',
  'src.pages.ContentManage.SportPlanUpdate.index.c8': '请输入简介说明',
  'src.pages.ContentManage.SportPlanUpdate.index.c9': '启用状态',
  'src.pages.ContentManage.SportPlanUpdate.index.c10': '启用',
  'src.pages.ContentManage.SportPlanUpdate.index.c11': '关闭',
  'src.pages.ContentManage.SportPlanUpdate.index.c12': '封面图片',
  'src.pages.ContentManage.SportPlanUpdate.index.c13':
    '说明：可上传1张封面图片，建议图片宽高比例为1:1，图片大小不超过2MB。',
  'src.pages.ContentManage.SportPlanUpdate.index.c14': '运动组合',
  'src.pages.ContentManage.SportPlanUpdate.index.c15': '总消耗热量(kcal)',
  'src.pages.ContentManage.SportPlanUpdate.index.c16': '请输入总消耗热量',
  'src.pages.ContentManage.SportPlanUpdate.index.c17': '重新计算',
  'src.pages.ContentManage.SportPlanUpdate.index.c18': '提交',
  'src.pages.ContentManage.SportPlanUpdate.index.c19': '取消',
  'src.pages.ContentManage.SportPlanUpdate.index.c20': '新增',
  'src.pages.ContentManage.SportPlanUpdate.index.c21': '编辑',
  'src.pages.ContentManage.SportPlanUpdate.index.c22': '复制',
  'src.pages.ContentManage.SportPlanUpdate.index.c23': '查看',
  'src.pages.ContentManage.SportPlanUpdate.EditSportGroup.c1': '分',
  'src.pages.ContentManage.SportPlanUpdate.EditSportGroup.c2': '秒',
  'src.pages.ContentManage.SportPlanUpdate.EditSportGroup.c3':
    '至少设置一个运动组合',
  'src.pages.ContentManage.SportPlanUpdate.EditSportGroup.c4':
    '第{num}行运动强度为空`',
  'src.pages.ContentManage.SportPlanUpdate.EditSportGroup.c5':
    '第{num}行运动方式为空',
  'src.pages.ContentManage.SportPlanUpdate.EditSportGroup.c6': '运动强度',
  'src.pages.ContentManage.SportPlanUpdate.EditSportGroup.c7': '运动方式',
  'src.pages.ContentManage.SportPlanUpdate.EditSportGroup.c8': '每次时长',
  'src.pages.ContentManage.SportPlanUpdate.EditSportGroup.c9': '间隔时长',
  'src.pages.ContentManage.SportPlanUpdate.EditSportGroup.c10': '循环次数',
  'src.pages.ContentManage.SportPlanUpdate.EditSportGroup.c11': '操作',
  'src.pages.ContentManage.SportPlanUpdate.EditSportGroup.c12': '删除',
  'src.pages.ContentManage.SportPlanUpdate.EditSportGroup.c13':
    '确认要删除此行吗？',
  'src.pages.ContentManage.SportPlanUpdate.EditSportGroup.c14': '新增',
  'src.pages.Customer.AddCustomer.components.AccountModal.index.c1':
    '重复用户判断',
  'src.pages.Customer.AddCustomer.components.AccountModal.index.c2':
    '点击仍然创建按钮后，重新开始创建流程，这里为了防止 setIsVerified 异步',
  'src.pages.Customer.AddCustomer.components.AccountModal.index.c4':
    '设置已校验过，使用 useEffect 防止异步，见上',
  'src.pages.Customer.AddCustomer.components.AccountModal.index.c5': '仍然创建',
  'src.pages.Customer.AddCustomer.components.AccountModal.index.c6':
    '好的，取消创建',
  'src.pages.Customer.AddCustomer.components.AccountModal.index.c7': '取消创建',
  'src.pages.Customer.AddCustomer.components.AccountModal.index.c13': '姓名',
  'src.pages.Customer.AddCustomer.components.AccountModal.index.c14': '性别',
  'src.pages.Customer.AddCustomer.components.AccountModal.index.c15': '年龄',
  'src.pages.Customer.AddCustomer.components.AccountModal.index.c16':
    '登录手机号',
  'src.pages.Customer.AddCustomer.components.AccountModal.index.c17':
    '证件号码',
  'src.pages.Customer.AddCustomer.components.AccountModal.index.c18':
    '所属部门',
  'src.pages.Customer.AddCustomer.components.AccountModal.index.c19':
    '查看权限',
  'src.pages.Customer.AddCustomer.components.AccountModal.index.c20': '可见',
  'src.pages.Customer.AddCustomer.components.AccountModal.index.c21': '不可见',
  'src.pages.Customer.AddCustomer.components.AccountModal.index.c22': '操作',
  'src.pages.Customer.AddCustomer.components.AccountModal.index.c23':
    '请联系所属部门',
  'src.pages.Customer.AddCustomer.components.AccountModal.index.c24':
    '客户详情',
  'src.pages.Customer.AddCustomer.components.TeamModal.index.c1':
    '选择服务团队',
  'src.pages.Customer.AddCustomer.components.TeamModal.index.c2':
    '表单查询项，不在表格中显示',
  'src.pages.Customer.AddCustomer.components.TeamModal.index.c3': '员工姓名',
  'src.pages.Customer.AddCustomer.components.TeamModal.index.c4': '团队名称',
  'src.pages.Customer.AddCustomer.components.TeamModal.index.c5': '所在部门',
  'src.pages.Customer.AddCustomer.components.TeamModal.index.c6': '负责人',
  'src.pages.Customer.AddCustomer.components.TeamModal.index.c7': '团队成员',
  'src.pages.Customer.AddCustomer.components.TeamModal.index.c8':
    '请选择服务团队',
  'src.pages.Customer.AddCustomer.index.c1': '姓名',
  'src.pages.Customer.AddCustomer.index.c2':
    '联系方式后缀图标，用于区分手机固话',
  'src.pages.Customer.AddCustomer.index.c3': '当前选中团队',
  'src.pages.Customer.AddCustomer.index.c4':
    '服务团队下拉框，由于要弹出表格，所以下拉框需要禁用，而且 options 需要实时更新，只放当前选中的那一个团队',
  'src.pages.Customer.AddCustomer.index.c5':
    '联系方式校验，首先校验手机格式，再校验固话',
  'src.pages.Customer.AddCustomer.index.c6': '如果验证身份证为空，则返回 true',
  'src.pages.Customer.AddCustomer.index.c7':
    '用户重复账号判断，登录手机号 -> 姓名手机号 -> 身份证，顺序依次判断',
  'src.pages.Customer.AddCustomer.index.c8': '提交',
  'src.pages.Customer.AddCustomer.index.c9': '取消',
  'src.pages.Customer.AddCustomer.index.c10':
    '如果没有填写联系方式，则将登陆手机号赋值给联系手机',
  'src.pages.Customer.AddCustomer.index.c11':
    '请输入正确的手机号码或固定电话，固定电话格式为“区号+号码”',
  'src.pages.Customer.AddCustomer.index.c12':
    '如01088888888，中间无需标点符号连接。',
  'src.pages.Customer.AddCustomer.index.c13': '根据身份证填写性别日期',
  'src.pages.Customer.AddCustomer.index.c14': '登录手机号',
  'src.pages.Customer.AddCustomer.index.c15': '请输入正确格式的紧急联系电话',
  'src.pages.Customer.AddCustomer.index.c16': '请输入登录手机号码',
  'src.pages.Customer.AddCustomer.index.c17': '请输入',
  'src.pages.Customer.AddCustomer.index.c27': '会员等级',
  'src.pages.Customer.AddCustomer.index.c40': '联系电话',
  'src.pages.Customer.AddCustomer.index.c53': '紧急联系电话',
  'src.pages.Customer.AddCustomer.index.c66':
    '请输入手机号或固定电话，多个号码用回车键分开',
  'src.pages.Customer.AddCustomer.index.c79': '档案编号',
  'src.pages.Customer.AddCustomer.index.c92': '证件号码',
  'src.pages.Customer.AddCustomer.index.c105': '证件类型',
  'src.pages.Customer.AddCustomer.index.c118': '请输入证件号码',
  'src.pages.Customer.AddCustomer.index.c131': '性别生日',
  'src.pages.Customer.AddCustomer.index.c144': '性别',
  'src.pages.Customer.AddCustomer.index.c157': '请选择生日',
  'src.pages.Customer.AddCustomer.index.c170': '客户备注',
  'src.pages.Customer.AddCustomer.index.c183': '推荐人',
  'src.pages.Customer.AddCustomer.index.c196': '服务套餐',
  'src.pages.Customer.AddCustomer.index.c209': '服务团队',
  'src.pages.Customer.AddCustomer.index.c222':
    '未设置服务团队的情况下，所创建的客户将需要去“潜在客户”页面查找',
  'src.pages.Customer.AddCustomer.index.c235': '图片上传失败，请稍后重试',
  'src.pages.Customer.AddCustomer.index.c236': '重复用户判断失败，请稍后重试',
  'src.pages.Customer.AddCustomer.index.c237': '创建成功',
  'src.pages.Customer.AddCustomer.index.c238':
    '用户创建成功，您可以选择继续创建或者关闭页面',
  'src.pages.Customer.AddCustomer.index.c239': '继续创建',
  'src.pages.Customer.AddCustomer.index.c240': '关闭页面',
  'src.pages.Customer.AddCustomer.index.c241': '请输入姓名',
  'src.pages.Customer.AddCustomer.index.c242': '最大长度为10',
  'src.pages.Customer.AddCustomer.index.c243': '个人信息',
  'src.pages.Customer.AddCustomer.index.c244': '请输入正确格式的联系电话',
  'src.pages.Customer.AddCustomer.index.c245': '请输入正确格式的手机号码',
  'src.pages.Customer.AddCustomer.index.c246': '请选择证件类型',
  'src.pages.Customer.AddCustomer.index.c247': '身份证',
  'src.pages.Customer.AddCustomer.index.c248': '其他',
  'src.pages.Customer.AddCustomer.index.c249': '请输入证件号码',
  'src.pages.Customer.AddCustomer.index.c250': '请输入正确格式的身份证',
  'src.pages.Customer.AddCustomer.index.c251': '男',
  'src.pages.Customer.AddCustomer.index.c252': '女',
  'src.pages.Customer.AddCustomer.index.c253': '请选择性别',
  'src.pages.Customer.AddCustomer.index.c254': '请选择生日',
  'src.pages.Customer.AddCustomer.index.c255': '服务配置',
  'src.pages.Customer.AddCustomer.index.c256': '请选择服务团队',
  'src.pages.Customer.AddCustomer.index.c257': '头像',
  'src.pages.Customer.CustomerDetail.components.AssessmentRecord.index.c1':
    '确认删除该问卷记录？',
  'src.pages.Customer.CustomerDetail.components.AssessmentRecord.index.c2':
    '查看答卷 reportId',
  'src.pages.Customer.CustomerDetail.components.AssessmentRecord.index.c3':
    '报告相关',
  'src.pages.Customer.CustomerDetail.components.AssessmentRecord.index.c4':
    '问卷类型：',
  'src.pages.Customer.CustomerDetail.components.AssessmentRecord.index.c5':
    '健康风险评估',
  'src.pages.Customer.CustomerDetail.components.AssessmentRecord.index.c6':
    '中医体质辨识',
  'src.pages.Customer.CustomerDetail.components.AssessmentRecord.index.c7':
    '心理健康评估',
  'src.pages.Customer.CustomerDetail.components.AssessmentRecord.index.c8':
    '处理时间',
  'src.pages.Customer.CustomerDetail.components.AssessmentRecord.index.c9':
    '选择问卷',
  'src.pages.Customer.CustomerDetail.components.AssessmentRecord.index.c10':
    '答卷',
  'src.pages.Customer.CustomerDetail.components.AssessmentRecord.index.c11':
    '健康评估',
  'src.pages.Customer.CustomerDetail.components.AssessmentRecord.index.c12':
    '查看答卷 reportId',
  'src.pages.Customer.CustomerDetail.components.AssessmentRecord.index.c13':
    '报告相关',
  'src.pages.Customer.CustomerDetail.components.AssessmentRecord.index.c14':
    '问卷类型：',
  'src.pages.Customer.CustomerDetail.components.AssessmentRecord.index.c15':
    '健康风险评估',
  'src.pages.Customer.CustomerDetail.components.AssessmentRecord.index.c16':
    '中医体质辨识',
  'src.pages.Customer.CustomerDetail.components.AssessmentRecord.index.c17':
    '心理健康评估',
  'src.pages.Customer.CustomerDetail.components.AssessmentRecord.index.c18':
    '处理时间',
  'src.pages.Customer.CustomerDetail.components.AssessmentRecord.index.c19':
    '选择问卷',
  'src.pages.Customer.CustomerDetail.components.AssessmentRecord.index.c20':
    '答卷',
  'src.pages.Customer.CustomerDetail.components.AssessmentRecord.index.c21':
    '删除成功',
  'src.pages.Customer.CustomerDetail.components.AssessmentRecord.index.c22':
    '删除失败，请稍后重试',
  'src.pages.Customer.CustomerDetail.components.AssessmentRecord.index.c23':
    '问卷名称',
  'src.pages.Customer.CustomerDetail.components.AssessmentRecord.index.c24':
    '评估客户',
  'src.pages.Customer.CustomerDetail.components.AssessmentRecord.index.c25':
    '岁',
  'src.pages.Customer.CustomerDetail.components.AssessmentRecord.index.c26':
    '开始答卷',
  'src.pages.Customer.CustomerDetail.components.AssessmentRecord.index.c27':
    '完成答卷',
  'src.pages.Customer.CustomerDetail.components.AssessmentRecord.index.c28':
    '完成时长（分）',
  'src.pages.Customer.CustomerDetail.components.AssessmentRecord.index.c29':
    '答卷状态',
  'src.pages.Customer.CustomerDetail.components.AssessmentRecord.index.c30':
    '进行中',
  'src.pages.Customer.CustomerDetail.components.AssessmentRecord.index.c31':
    '已完成',
  'src.pages.Customer.CustomerDetail.components.AssessmentRecord.index.c32':
    '操作',
  'src.pages.Customer.CustomerDetail.components.AssessmentRecord.index.c33':
    '继续答卷',
  'src.pages.Customer.CustomerDetail.components.AssessmentRecord.index.c34':
    '查看报告',
  'src.pages.Customer.CustomerDetail.components.AssessmentRecord.index.c35':
    '查看答卷',
  'src.pages.Customer.CustomerDetail.components.AssessmentRecord.index.c36':
    '删除',
  'src.pages.Customer.CustomerDetail.components.AssessmentRecord.index.c37':
    '共{total}条记录',
  'src.pages.Customer.CustomerDetail.components.AssessmentRecord.index.c38':
    '添加记录',
  'src.pages.Customer.CustomerDetail.components.AssessmentRecord.index.c39':
    '请选择问卷',
  'src.pages.Customer.CustomerDetail.components.CommonFunctionCard.index.c1':
    '常用功能编辑',
  'src.pages.Customer.CustomerDetail.components.CommonFunctionCard.index.c2':
    '保存',
  'src.pages.Customer.CustomerDetail.components.CommonFunctionCard.index.c3':
    '保存成功',
  'src.pages.Customer.CustomerDetail.components.CommonFunctionCard.index.c4':
    '保存失败',
  'src.pages.Customer.CustomerDetail.components.CommonFunctionCard.index.c5':
    '网络错误，请稍后重试',
  'src.pages.Customer.CustomerDetail.components.CommonFunctionCard.index.c6':
    '维护档案',
  'src.pages.Customer.CustomerDetail.components.CommonFunctionCard.index.c7':
    '记录体征',
  'src.pages.Customer.CustomerDetail.components.CommonFunctionCard.index.c8':
    '上传报告',
  'src.pages.Customer.CustomerDetail.components.CommonFunctionCard.index.c9':
    '用药记录',
  'src.pages.Customer.CustomerDetail.components.CommonFunctionCard.index.c10':
    '就医记录',
  'src.pages.Customer.CustomerDetail.components.CommonFunctionCard.index.c11':
    '健康评估',
  'src.pages.Customer.CustomerDetail.components.CommonFunctionCard.index.c12':
    '创建服务计划',
  'src.pages.Customer.CustomerDetail.components.CommonFunctionCard.index.c13':
    '添加服务记录',
  'src.pages.Customer.CustomerDetail.components.CommonFunctionCard.index.c14':
    '打电话',
  'src.pages.Customer.CustomerDetail.components.CommonFunctionCard.index.c15':
    '添加消费记录',
  'src.pages.Customer.CustomerDetail.components.CommonFunctionCard.index.c16':
    '添加干预方案',
  'src.pages.Customer.CustomerDetail.components.CommonFunctionCard.index.c17':
    '添加健康习惯',
  'src.pages.Customer.CustomerDetail.components.CommonFunctionCard.index.c18':
    '导出总结报告',
  'src.pages.Customer.CustomerDetail.components.CommonFunctionCard.index.c19':
    '添加饮食',
  'src.pages.Customer.CustomerDetail.components.CommonFunctionCard.index.c20':
    '开单',
  'src.pages.Customer.CustomerDetail.components.CommonFunctionCard.index.c21':
    '预约',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.index.c1':
    '消费记录',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.index.c2':
    '商城订单',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.index.c3':
    '预约订单',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.index.c4':
    '服务套餐',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.index.c5':
    '其他消费',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.index.c6':
    '检测项目订单',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.BillingRecordTable.index.c1':
    '订单类型',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.BillingRecordTable.index.c2':
    '下单时间',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.BillingRecordTable.index.c3':
    '来源店铺',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.BillingRecordTable.index.c4':
    '实付金额',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.BillingRecordTable.index.c5':
    '订单状态',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.BillingRecordTable.index.c6':
    '操作',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.BillingRecordTable.index.c7':
    '开单详情',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.BillingRecordTable.index.c8':
    '查看',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.ApptOrderTable.index.c1':
    '待付款',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.ApptOrderTable.index.c2':
    '已支付',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.ApptOrderTable.index.c3':
    '待处理',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.ApptOrderTable.index.c4':
    '处理中',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.ApptOrderTable.index.c5':
    '已完成',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.ApptOrderTable.index.c6':
    '已关闭',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.ApptOrderTable.index.c7':
    '已取消',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.ApptOrderTable.index.c8':
    '项目名称',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.ApptOrderTable.index.c9':
    '项目类目',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.ApptOrderTable.index.c10':
    '下单时间',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.ApptOrderTable.index.c11':
    '来源店铺',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.ApptOrderTable.index.c12':
    '订单金额',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.ApptOrderTable.index.c13':
    '订单状态',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.ApptOrderTable.index.c14':
    '权益抵扣',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.ApptOrderTable.index.c15':
    '是',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.ApptOrderTable.index.c16':
    '否',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.ApptOrderTable.index.c17':
    '操作',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.ApptOrderTable.index.c18':
    '详情',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.ApptOrderTable.index.c19':
    '共{total}条记录',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.CosnsumeOrderTable.index.c1':
    '待付款',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.CosnsumeOrderTable.index.c2':
    '已支付',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.CosnsumeOrderTable.index.c3':
    '免费',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.CosnsumeOrderTable.index.c4':
    '服务项目名称',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.CosnsumeOrderTable.index.c5':
    '项目类型',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.CosnsumeOrderTable.index.c6':
    '服务项目',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.CosnsumeOrderTable.index.c7':
    '自定义项目',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.CosnsumeOrderTable.index.c8':
    '消费时间',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.CosnsumeOrderTable.index.c9':
    '支付状态',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.CosnsumeOrderTable.index.c10':
    '共{total}条记录',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.CosnsumeOrderTable.index.c11':
    '添加记录',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.CosnsumeOrderTable.index.c12':
    '添加消费记录',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.CosnsumeOrderTable.index.c13':
    '应付金额',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.CosnsumeOrderTable.index.c14':
    '实付金额',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.CosnsumeOrderTable.index.c15':
    '操作',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.CosnsumeOrderTable.index.c16':
    '编辑消费记录',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.CosnsumeOrderTable.index.c17':
    '确认删除该记录？',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.CosnsumeOrderTable.UpdateCustomerOrderRecords.c1':
    '剩余',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.CosnsumeOrderTable.UpdateCustomerOrderRecords.c2':
    '套餐截止',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.CosnsumeOrderTable.UpdateCustomerOrderRecords.c3':
    '不抵扣',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.CosnsumeOrderTable.UpdateCustomerOrderRecords.c4':
    '预约订单',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.CosnsumeOrderTable.UpdateCustomerOrderRecords.c5':
    '其他消费',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.CosnsumeOrderTable.UpdateCustomerOrderRecords.c6':
    '{action}成功',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.CosnsumeOrderTable.UpdateCustomerOrderRecords.c7':
    '请求失败，请稍后重试',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.CosnsumeOrderTable.UpdateCustomerOrderRecords.c8':
    '添加方式',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.CosnsumeOrderTable.UpdateCustomerOrderRecords.c9':
    '从系统选择服务项目',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.CosnsumeOrderTable.UpdateCustomerOrderRecords.c10':
    '自定义服务项目',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.CosnsumeOrderTable.UpdateCustomerOrderRecords.c11':
    '请选择添加方式',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.CosnsumeOrderTable.UpdateCustomerOrderRecords.c12':
    '服务项目',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.CosnsumeOrderTable.UpdateCustomerOrderRecords.c13':
    '请选择服务项目',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.CosnsumeOrderTable.UpdateCustomerOrderRecords.c14':
    '请输入服务项目',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.CosnsumeOrderTable.UpdateCustomerOrderRecords.c15':
    '服务时长',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.CosnsumeOrderTable.UpdateCustomerOrderRecords.c16':
    '分钟',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.CosnsumeOrderTable.UpdateCustomerOrderRecords.c17':
    '订单编号',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.CosnsumeOrderTable.UpdateCustomerOrderRecords.c18':
    '支付类型',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.CosnsumeOrderTable.UpdateCustomerOrderRecords.c19':
    '权益抵扣',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.CosnsumeOrderTable.UpdateCustomerOrderRecords.c20':
    '请选择权益抵扣',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.CosnsumeOrderTable.UpdateCustomerOrderRecords.c21':
    '应付费用',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.CosnsumeOrderTable.UpdateCustomerOrderRecords.c22':
    '请输入应付费用',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.CosnsumeOrderTable.UpdateCustomerOrderRecords.c23':
    '实付费用',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.CosnsumeOrderTable.UpdateCustomerOrderRecords.c24':
    '请输入实付费用',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.CosnsumeOrderTable.UpdateCustomerOrderRecords.c25':
    '发生时间',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.CosnsumeOrderTable.UpdateCustomerOrderRecords.c26':
    '请选择发生时间',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.CosnsumeOrderTable.UpdateCustomerOrderRecords.c27':
    '支付状态',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.CosnsumeOrderTable.UpdateCustomerOrderRecords.c28':
    '待支付',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.CosnsumeOrderTable.UpdateCustomerOrderRecords.c29':
    '已支付',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.CosnsumeOrderTable.UpdateCustomerOrderRecords.c30':
    '免费',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.CosnsumeOrderTable.UpdateCustomerOrderRecords.c31':
    '请选择支付状态',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.CosnsumeOrderTable.UpdateCustomerOrderRecords.c32':
    '备注',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.MallOrderTable.index.c1':
    '待付款',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.MallOrderTable.index.c2':
    '待发货',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.MallOrderTable.index.c3':
    '待收货',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.MallOrderTable.index.c4':
    '已完成',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.MallOrderTable.index.c5':
    '已关闭',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.MallOrderTable.index.c6':
    '商品名称',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.MallOrderTable.index.c7':
    '商品属性',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.MallOrderTable.index.c8':
    '下单时间',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.MallOrderTable.index.c9':
    '来源店铺',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.MallOrderTable.index.c10':
    '订单金额',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.MallOrderTable.index.c11':
    '订单状态',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.MallOrderTable.index.c12':
    '操作',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.MallOrderTable.index.c13':
    '详情',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.MallOrderTable.index.c14':
    '共{total}条记录',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.MallOrderTable.index.c15':
    '实物商品',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.MallOrderTable.index.c16':
    '服务套餐',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.ServiceOrderTable.index.c1':
    '人工绑定',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.ServiceOrderTable.index.c2':
    '商城购买',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.ServiceOrderTable.index.c3':
    '服务套餐',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.ServiceOrderTable.index.c4':
    '绑定方式',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.ServiceOrderTable.index.c5':
    '下单时间',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.ServiceOrderTable.index.c6':
    '有效期',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.ServiceOrderTable.index.c7':
    '套餐价格',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.ServiceOrderTable.index.c8':
    '套餐状态',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.ServiceOrderTable.index.c9':
    '操作',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.ServiceOrderTable.index.c10':
    '详情',
  'src.pages.Customer.CustomerDetail.components.ConsumeRecordCard.components.ServiceOrderTable.index.c11':
    '共{total}条记录',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.ApptOrder.index.c1':
    '待付款',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.ApptOrder.index.c2':
    '已支付',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.ApptOrder.index.c3':
    '待处理',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.ApptOrder.index.c4':
    '处理中',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.ApptOrder.index.c5':
    '已完成',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.ApptOrder.index.c6':
    '已关闭',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.ApptOrder.index.c7':
    '已取消',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.ApptOrder.index.c8':
    '权益抵扣',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.ApptOrder.index.c9':
    '详情',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.ApptOrder.index.c10':
    '共{total}条',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.CustomerOrder.index.c1':
    '待付款',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.CustomerOrder.index.c2':
    '已支付',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.CustomerOrder.index.c3':
    '免费',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.CustomerOrder.index.c4':
    '服务项目',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.CustomerOrder.index.c5':
    '自定义项目',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.CustomerOrder.index.c6':
    '共{total}条',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.CustomerOrder.index.c7':
    '添加记录',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.CustomerOrder.UpdateCustomerOrderRecords.c1':
    '添加方式',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.CustomerOrder.UpdateCustomerOrderRecords.c2':
    '剩余',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.CustomerOrder.UpdateCustomerOrderRecords.c3':
    '增加一列不抵扣的选项，value 设为 -999',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.CustomerOrder.UpdateCustomerOrderRecords.c4':
    '监听是否抵扣套餐',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.CustomerOrder.UpdateCustomerOrderRecords.c5':
    '监听是否自定义项目名称',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.CustomerOrder.UpdateCustomerOrderRecords.c6':
    '监听选中的服务项目，获取可抵扣套餐列表',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.CustomerOrder.UpdateCustomerOrderRecords.c7':
    '服务项目',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.CustomerOrder.UpdateCustomerOrderRecords.c13':
    '权益抵扣',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.CustomerOrder.UpdateCustomerOrderRecords.c19':
    '应付费用',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.CustomerOrder.UpdateCustomerOrderRecords.c25':
    '实付费用',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.CustomerOrder.UpdateCustomerOrderRecords.c31':
    '发生时间',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.CustomerOrder.UpdateCustomerOrderRecords.c37':
    '支付状态',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.CustomerOrder.UpdateCustomerOrderRecords.c43':
    '备注',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.CustomerOrder.UpdateCustomerOrderRecords.c49':
    '套餐截止',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.CustomerOrder.UpdateCustomerOrderRecords.c50':
    '不抵扣',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.CustomerOrder.UpdateCustomerOrderRecords.c51':
    '预约订单',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.CustomerOrder.UpdateCustomerOrderRecords.c52':
    '其他消费',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.CustomerOrder.UpdateCustomerOrderRecords.c53':
    '{action}成功',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.CustomerOrder.UpdateCustomerOrderRecords.c54':
    '请求失败，请稍后重试',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.CustomerOrder.UpdateCustomerOrderRecords.c55':
    '从系统选择服务项目',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.CustomerOrder.UpdateCustomerOrderRecords.c56':
    '自定义服务项目',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.CustomerOrder.UpdateCustomerOrderRecords.c57':
    '请选择添加方式',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.CustomerOrder.UpdateCustomerOrderRecords.c58':
    '服务项目',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.CustomerOrder.UpdateCustomerOrderRecords.c59':
    '请选择服务项目',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.CustomerOrder.UpdateCustomerOrderRecords.c60':
    '请输入服务项目',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.CustomerOrder.UpdateCustomerOrderRecords.c61':
    '服务时长',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.CustomerOrder.UpdateCustomerOrderRecords.c62':
    '分钟',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.CustomerOrder.UpdateCustomerOrderRecords.c63':
    '订单编号',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.CustomerOrder.UpdateCustomerOrderRecords.c64':
    '支付类型',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.CustomerOrder.UpdateCustomerOrderRecords.c65':
    '请选择权益抵扣',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.CustomerOrder.UpdateCustomerOrderRecords.c66':
    '请输入应付费用',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.CustomerOrder.UpdateCustomerOrderRecords.c67':
    '请输入实付费用',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.CustomerOrder.UpdateCustomerOrderRecords.c68':
    '请选择发生时间',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.CustomerOrder.UpdateCustomerOrderRecords.c69':
    '待支付',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.CustomerOrder.UpdateCustomerOrderRecords.c70':
    '已支付',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.CustomerOrder.UpdateCustomerOrderRecords.c71':
    '免费',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.CustomerOrder.UpdateCustomerOrderRecords.c72':
    '请选择支付状态',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.MallOrder.index.c1':
    '待付款',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.MallOrder.index.c2':
    '待发货',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.MallOrder.index.c3':
    '待收货',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.MallOrder.index.c4':
    '已完成',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.MallOrder.index.c5':
    '已关闭',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.MallOrder.index.c6':
    '服务套餐',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.MallOrder.index.c7':
    '详情',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.MallOrder.index.c8':
    '共{total}条',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.ServiceOrder.index.c1':
    '商城购买',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.ServiceOrder.index.c2':
    '详情',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.ServiceOrder.index.c3':
    '有效期',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.ServiceOrder.index.c4':
    '共{total}条',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.index.c1':
    '消费记录',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.index.c2':
    '商城订单',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.index.c3':
    '预约订单',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.index.c4':
    '服务套餐',
  'src.pages.Customer.CustomerDetail.components.CustomerRecords.index.c5':
    '其他消费',
  'src.pages.Customer.CustomerDetail.components.HealthIntervention.components.AddHealthPunch.index.c1':
    '添加打卡习惯',
  'src.pages.Customer.CustomerDetail.components.HealthIntervention.components.AddHealthPunch.index.c2':
    '返回',
  'src.pages.Customer.CustomerDetail.components.HealthIntervention.components.AddHealthPunch.index.c3':
    '添加其他习惯',
  'src.pages.Customer.CustomerDetail.components.HealthIntervention.components.AddHealthPunch.index.c4':
    '添加成功',
  'src.pages.Customer.CustomerDetail.components.HealthIntervention.components.AddHealthPunch.index.c5':
    '分类',
  'src.pages.Customer.CustomerDetail.components.HealthIntervention.components.AddHealthPunch.index.c6':
    '选择分类',
  'src.pages.Customer.CustomerDetail.components.HealthIntervention.components.AddHealthPunch.index.c7':
    '健康习惯',
  'src.pages.Customer.CustomerDetail.components.HealthIntervention.components.AddHealthPunch.index.c8':
    '健康习惯名称',
  'src.pages.Customer.CustomerDetail.components.HealthIntervention.components.AddHealthPunch.index.c9':
    '操作',
  'src.pages.Customer.CustomerDetail.components.HealthIntervention.components.AddHealthPunch.index.c10':
    '已添加',
  'src.pages.Customer.CustomerDetail.components.HealthIntervention.components.AddHealthPunch.index.c11':
    '确认要添加该健康习惯吗？',
  'src.pages.Customer.CustomerDetail.components.HealthIntervention.components.AddHealthPunch.index.c12':
    '添加',
  'src.pages.Customer.CustomerDetail.components.HealthIntervention.components.AddOtherHealthPunch.index.c1':
    '添加其他习惯',
  'src.pages.Customer.CustomerDetail.components.HealthIntervention.components.AddOtherHealthPunch.index.c2':
    '选择分类',
  'src.pages.Customer.CustomerDetail.components.HealthIntervention.components.AddOtherHealthPunch.index.c3':
    '习惯名称',
  'src.pages.Customer.CustomerDetail.components.HealthIntervention.components.AddOtherHealthPunch.index.c4':
    '添加成功',
  'src.pages.Customer.CustomerDetail.components.HealthIntervention.components.AddOtherHealthPunch.index.c5':
    '请求失败，请稍后重试',
  'src.pages.Customer.CustomerDetail.components.HealthIntervention.components.AddOtherHealthPunch.index.c6':
    '请选择分类',
  'src.pages.Customer.CustomerDetail.components.HealthIntervention.components.HealthPunch.index.c1':
    '干预方案',
  'src.pages.Customer.CustomerDetail.components.HealthIntervention.components.HealthPunch.index.c2':
    '其他',
  'src.pages.Customer.CustomerDetail.components.HealthIntervention.components.HealthPunch.index.c3':
    '删除成功',
  'src.pages.Customer.CustomerDetail.components.HealthIntervention.components.HealthPunch.index.c4':
    '类型',
  'src.pages.Customer.CustomerDetail.components.HealthIntervention.components.HealthPunch.index.c5':
    '健康习惯',
  'src.pages.Customer.CustomerDetail.components.HealthIntervention.components.HealthPunch.index.c6':
    '任务周期',
  'src.pages.Customer.CustomerDetail.components.HealthIntervention.components.HealthPunch.index.c7':
    '开始',
  'src.pages.Customer.CustomerDetail.components.HealthIntervention.components.HealthPunch.index.c8':
    '状态',
  'src.pages.Customer.CustomerDetail.components.HealthIntervention.components.HealthPunch.index.c9':
    '已打卡天数',
  'src.pages.Customer.CustomerDetail.components.HealthIntervention.components.HealthPunch.index.c10':
    '操作',
  'src.pages.Customer.CustomerDetail.components.HealthIntervention.components.HealthPunch.index.c11':
    '确认要删除该打卡吗？',
  'src.pages.Customer.CustomerDetail.components.HealthIntervention.components.HealthPunch.index.c12':
    '删除',
  'src.pages.Customer.CustomerDetail.components.HealthIntervention.components.HealthPunch.index.c13':
    '共{total}条记录',
  'src.pages.Customer.CustomerDetail.components.HealthIntervention.components.HealthPunch.index.c14':
    '添加习惯',
  'src.pages.Customer.CustomerDetail.components.HealthIntervention.index.c1':
    '干预方案',
  'src.pages.Customer.CustomerDetail.components.HealthIntervention.index.c2':
    '健康习惯',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.index.c1':
    '健康干预',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.index.c2':
    '干预方案',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.index.c3':
    '健康习惯',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.index.c4':
    '饮食打卡',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.AddHealthPunch.index.c1':
    '添加健康习惯',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.AddHealthPunch.index.c2':
    '添加成功',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.AddHealthPunch.index.c3':
    '分类',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.AddHealthPunch.index.c4':
    '选择分类',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.AddHealthPunch.index.c5':
    '健康习惯',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.AddHealthPunch.index.c6':
    '健康习惯名称',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.AddHealthPunch.index.c7':
    '操作',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.AddHealthPunch.index.c8':
    '已添加',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.AddHealthPunch.index.c9':
    '确认要添加该健康习惯吗？',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.AddHealthPunch.index.c10':
    '添加',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.AddHealthPunch.index.c11':
    '返回',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.AddHealthPunch.index.c12':
    '添加其他习惯',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.AddOtherHealthPunch.index.c1':
    '添加其他习惯',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.AddOtherHealthPunch.index.c2':
    '添加成功',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.AddOtherHealthPunch.index.c3':
    '请求失败，请稍后重试',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.AddOtherHealthPunch.index.c4':
    '选择分类',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.AddOtherHealthPunch.index.c5':
    '请选择分类',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.AddOtherHealthPunch.index.c6':
    '习惯名称',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.AddOtherHealthPunch.index.c7':
    '请输入习惯名称',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.HealthPunch.index.c1':
    '干预方案',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.HealthPunch.index.c2':
    '其他',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.HealthPunch.index.c3':
    '删除成功',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.HealthPunch.index.c4':
    '类型',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.HealthPunch.index.c5':
    '健康习惯',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.HealthPunch.index.c6':
    '周期',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.HealthPunch.index.c7':
    '开始',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.HealthPunch.index.c8':
    '状态',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.HealthPunch.index.c9':
    '已打卡天数',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.HealthPunch.index.c10':
    '操作',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.HealthPunch.index.c11':
    '确认要删除该打卡吗？',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.HealthPunch.index.c12':
    '删除',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.HealthPunch.index.c13':
    '共{total}条记录',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.HealthPunch.index.c14':
    '添加习惯',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.InterventionPlan.index.c1':
    '删除成功',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.InterventionPlan.index.c2':
    '方案名称',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.InterventionPlan.index.c3':
    '方案周期',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.InterventionPlan.index.c4':
    '至',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.InterventionPlan.index.c5':
    '管理目标',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.InterventionPlan.index.c6':
    '状态',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.InterventionPlan.index.c7':
    '打卡天数',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.InterventionPlan.index.c8':
    '操作',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.InterventionPlan.index.c9':
    '编辑',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.InterventionPlan.index.c10':
    '确认要删除该方案？',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.InterventionPlan.index.c11':
    '删除',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.InterventionPlan.index.c12':
    '共{total}条记录',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.InterventionPlan.index.c13':
    '添加方案',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.InterventionPlanDrawer.index.c1':
    '添加',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.InterventionPlanDrawer.index.c2':
    '编辑',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.InterventionPlanDrawer.index.c3':
    '{action}干预方案',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.InterventionPlanDrawer.index.c4':
    '取消',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.InterventionPlanDrawer.index.c5':
    '保存',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.InterventionPlanDrawer.index.c6':
    '{action}成功',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.InterventionPlanDrawer.index.c7':
    '{action}失败，请稍后重试',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.InterventionPlanDrawer.index.c8':
    '标题',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.InterventionPlanDrawer.index.c9':
    '干预周期',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.InterventionPlanDrawer.index.c10':
    '针对健康问题',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.InterventionPlanDrawer.index.c11':
    '管理目标',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.InterventionPlanDrawer.index.c12':
    '封面',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.InterventionPlanDrawer.index.c13':
    '请上传封面',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.InterventionPlanDrawer.index.c14':
    '请上传一张封面图，支持png、jpg图片，建议图片高宽比例为16:9或1:1，高或宽必须大于300px。',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.InterventionPlanDrawer.index.c15':
    '推送短信通知',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.InterventionPlanDrawer.index.c16':
    '是',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.InterventionPlanDrawer.index.c17':
    '否',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.InterventionPlanDrawer.index.c18':
    '方案配置',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.InterventionPlanDrawer.index.c19':
    '从模板库选择',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.InterventionPlanDrawer.index.c20':
    '请填写方案配置',
  'src.pages.Customer.CustomerDetail.components.HealthInterventionCard.components.InterventionPlanDrawer.index.c21':
    '插入成功',
  'src.pages.Customer.CustomerDetail.components.HealthMetricsFocusCard.index.c1':
    '关注指标',
  'src.pages.Customer.CustomerDetail.components.HealthMetricsFocusCard.index.c2':
    '控制目标',
  'src.pages.Customer.CustomerDetail.components.HealthMetricsFocusCard.index.c3':
    '最近测量值',
  'src.pages.Customer.CustomerDetail.components.HealthMetricsFocusCard.index.c4':
    '偏高',
  'src.pages.Customer.CustomerDetail.components.HealthMetricsFocusCard.index.c5':
    '偏低',
  'src.pages.Customer.CustomerDetail.components.HealthMetricsFocusCard.index.c6':
    '最近测量时间',
  'src.pages.Customer.CustomerDetail.components.HealthMetricsFocusCard.index.c7':
    '操作',
  'src.pages.Customer.CustomerDetail.components.HealthMetricsFocusCard.index.c8':
    '设置',
  'src.pages.Customer.CustomerDetail.components.HealthMetricsFocusCard.index.c9':
    '重点关注',
  'src.pages.Customer.CustomerDetail.components.HealthMetricsFocusCard.index.c10':
    '关注设置',
  'src.pages.Customer.CustomerDetail.components.HealthMetricsFocusCard.index.c11':
    '共{total}条记录',
  'src.pages.Customer.CustomerDetail.components.HealthMetricsFocusCard.index.c12':
    '保存',
  'src.pages.Customer.CustomerDetail.components.HealthMetricsFocusCard.index.c13':
    '保存成功',
  'src.pages.Customer.CustomerDetail.components.HealthMetricsFocusCard.index.c14':
    '保存失败',
  'src.pages.Customer.CustomerDetail.components.HealthMetricsFocusCard.index.c15':
    '网络错误，请稍后重试',
  'src.pages.Customer.CustomerDetail.components.HealthMetricsFocusCard.index.c16':
    '设置健康目标',
  'src.pages.Customer.CustomerDetail.components.HealthMetricsFocusCard.index.c17':
    '下限值和上限值需至少填写一个',
  'src.pages.Customer.CustomerDetail.components.HealthMetricsFocusCard.index.c18':
    '设置成功',
  'src.pages.Customer.CustomerDetail.components.HealthMetricsFocusCard.index.c19':
    '设置失败，请稍后重试',
  'src.pages.Customer.CustomerDetail.components.HealthMetricsFocusCard.index.c20':
    '网络错误，请稍后重试',
  'src.pages.Customer.CustomerDetail.components.HealthMetricsFocusCard.index.c21':
    '健康指标',
  'src.pages.Customer.CustomerDetail.components.HealthMetricsFocusCard.index.c22':
    '下限',
  'src.pages.Customer.CustomerDetail.components.HealthMetricsFocusCard.index.c23':
    '上限',
  'src.pages.Customer.CustomerDetail.components.HealthMetricsFocusCard.index.c24':
    '下限值不能大于上限值',
  'src.pages.Customer.CustomerDetail.components.HealthMetricsFocusCard.index.c25':
    '注：下限值和上限值需至少填写一个，空值代表无上限或下限。',
  'src.pages.Customer.CustomerDetail.components.HealthMetricsFocusCard.index.c26':
    '异常范围',
  'src.pages.Customer.CustomerDetail.components.HealthMetricsFocusCard.index.c27':
    '注：',
  'src.pages.Customer.CustomerDetail.components.HealthMetricsFocusCard.index.c28':
    '1) 下限值和上限值需至少填写一个，空值代表无上限或下限。',
  'src.pages.Customer.CustomerDetail.components.HealthMetricsFocusCard.index.c29':
    '2）当客户超出范围时消息提醒至客户本人',
  'src.pages.Customer.CustomerDetail.components.HealthMetricsFocusCard.index.c30':
    '低危范围',
  'src.pages.Customer.CustomerDetail.components.HealthMetricsFocusCard.index.c31':
    '高危范围',
  'src.pages.Customer.CustomerDetail.components.HealthMetricsFocusCard.index.c32':
    '低危范围不能大于高危范围',
  'src.pages.Customer.CustomerDetail.components.HealthMetricsFocusCard.index.c33':
    '控制范围',
  'src.pages.Customer.CustomerDetail.components.HealthMetricsFocusCard.index.c34':
    '范围下限',
  'src.pages.Customer.CustomerDetail.components.HealthMetricsFocusCard.index.c35':
    '范围上限',
  'src.pages.Customer.CustomerDetail.components.HealthProgram.components.ServicePlan.index.c1':
    '服务方案',
  'src.pages.Customer.CustomerDetail.components.HealthProgram.components.ServicePlan.index.c2':
    '查看',
  'src.pages.Customer.CustomerDetail.components.HealthProgram.components.ServicePlan.index.c3':
    '服务方案',
  'src.pages.Customer.CustomerDetail.components.HealthProgram.components.ServicePlan.index.c4':
    '创建时间',
  'src.pages.Customer.CustomerDetail.components.HealthProgram.components.ServicePlan.index.c5':
    '操作',
  'src.pages.Customer.CustomerDetail.components.HealthProgram.components.ServicePlan.index.c6':
    '共{total}条记录',
  'src.pages.Customer.CustomerDetail.components.HealthProgram.components.ServicePlan.index.c7':
    '关闭',
  'src.pages.Customer.CustomerDetail.components.HealthProgram.components.Summary.ChooseTemplate.c1':
    '从模板库选择',
  'src.pages.Customer.CustomerDetail.components.HealthProgram.components.Summary.ChooseTemplate.c2':
    '模板分类',
  'src.pages.Customer.CustomerDetail.components.HealthProgram.components.Summary.ChooseTemplate.c3':
    '方案标题',
  'src.pages.Customer.CustomerDetail.components.HealthProgram.components.Summary.ChooseTemplate.c4':
    '方案简述',
  'src.pages.Customer.CustomerDetail.components.HealthProgram.components.Summary.ChooseTemplate.c5':
    '标签',
  'src.pages.Customer.CustomerDetail.components.HealthProgram.components.Summary.ChooseTemplate.c6':
    '适用人群',
  'src.pages.Customer.CustomerDetail.components.HealthProgram.components.Summary.ChooseTemplate.c7':
    '操作',
  'src.pages.Customer.CustomerDetail.components.HealthProgram.components.Summary.ChooseTemplate.c8':
    '插入',
  'src.pages.Customer.CustomerDetail.components.HealthProgram.components.Summary.ChooseTemplate.c9':
    '关闭',
  'src.pages.Customer.CustomerDetail.components.HealthProgram.components.Summary.SummaryDetail.c1':
    '标题',

  'src.pages.Customer.CustomerDetail.components.HealthProgram.components.Summary.SummaryDetail.c2':
    '开始日期，结束日期',
  'src.pages.Customer.CustomerDetail.components.HealthProgram.components.Summary.SummaryDetail.c3':
    '处理日期',
  'src.pages.Customer.CustomerDetail.components.HealthProgram.components.Summary.SummaryDetail.c4':
    '干预周期',
  'src.pages.Customer.CustomerDetail.components.HealthProgram.components.Summary.SummaryDetail.c7':
    '针对健康问题',
  'src.pages.Customer.CustomerDetail.components.HealthProgram.components.Summary.SummaryDetail.c10':
    '管理目标',
  'src.pages.Customer.CustomerDetail.components.HealthProgram.components.Summary.SummaryDetail.c13':
    '图片',
  'src.pages.Customer.CustomerDetail.components.HealthProgram.components.Summary.SummaryDetail.c16':
    '推送短信通知',
  'src.pages.Customer.CustomerDetail.components.HealthProgram.components.Summary.SummaryDetail.c19':
    '不推送',
  'src.pages.Customer.CustomerDetail.components.HealthProgram.components.Summary.SummaryDetail.c20':
    '推送',
  'src.pages.Customer.CustomerDetail.components.HealthProgram.components.Summary.SummaryDetail.c21':
    '{action}干预方案',
  'src.pages.Customer.CustomerDetail.components.HealthProgram.components.Summary.SummaryDetail.c22':
    '{action}成功',
  'src.pages.Customer.CustomerDetail.components.HealthProgram.components.Summary.SummaryDetail.c23':
    '{action}失败，请稍后重试',
  'src.pages.Customer.CustomerDetail.components.HealthProgram.components.Summary.SummaryDetail.c24':
    '请输入标题',
  'src.pages.Customer.CustomerDetail.components.HealthProgram.components.Summary.SummaryDetail.c25':
    '请选择干预周期',
  'src.pages.Customer.CustomerDetail.components.HealthProgram.components.Summary.SummaryDetail.c26':
    '请输入针对健康问题',
  'src.pages.Customer.CustomerDetail.components.HealthProgram.components.Summary.SummaryDetail.c27':
    '说明：请上传一张封面图，支持png、jpg图片，建议图片高宽比例为16:9或1:1，高或宽必须大于300px。',
  'src.pages.Customer.CustomerDetail.components.HealthProgram.components.Summary.SummaryDetail.c28':
    '方案配置',
  'src.pages.Customer.CustomerDetail.components.HealthProgram.components.Summary.SummaryDetail.c29':
    '从模板库选择',
  'src.pages.Customer.CustomerDetail.components.HealthProgram.components.Summary.SummaryDetail.c30':
    '插入成功',
  'src.pages.Customer.CustomerDetail.components.HealthProgram.components.Summary.index.c1':
    '删除成功',
  'src.pages.Customer.CustomerDetail.components.HealthProgram.components.Summary.index.c2':
    '方案名称',
  'src.pages.Customer.CustomerDetail.components.HealthProgram.components.Summary.index.c3':
    '方案周期',
  'src.pages.Customer.CustomerDetail.components.HealthProgram.components.Summary.index.c4':
    '管理目标',
  'src.pages.Customer.CustomerDetail.components.HealthProgram.components.Summary.index.c5':
    '状态',
  'src.pages.Customer.CustomerDetail.components.HealthProgram.components.Summary.index.c6':
    '未开始',
  'src.pages.Customer.CustomerDetail.components.HealthProgram.components.Summary.index.c7':
    '进行中',
  'src.pages.Customer.CustomerDetail.components.HealthProgram.components.Summary.index.c8':
    '已结束',
  'src.pages.Customer.CustomerDetail.components.HealthProgram.components.Summary.index.c9':
    '打卡天数',
  'src.pages.Customer.CustomerDetail.components.HealthProgram.components.Summary.index.c10':
    '操作',
  'src.pages.Customer.CustomerDetail.components.HealthProgram.components.Summary.index.c11':
    '编辑',
  'src.pages.Customer.CustomerDetail.components.HealthProgram.components.Summary.index.c12':
    '确认要删除该方案？',
  'src.pages.Customer.CustomerDetail.components.HealthProgram.components.Summary.index.c13':
    '删除',
  'src.pages.Customer.CustomerDetail.components.HealthProgram.components.Summary.index.c14':
    '共{total}条记录',
  'src.pages.Customer.CustomerDetail.components.HealthProgram.components.Summary.index.c15':
    '创建干预方案',
  'src.pages.Customer.CustomerDetail.components.HealthProgram.index.c1':
    '服务指导方案',
  'src.pages.Customer.CustomerDetail.components.HealthRecords.index.c1':
    '健康动态',
  'src.pages.Customer.CustomerDetail.components.HealthRecords.index.c2':
    '相同日期的不显示日期',
  'src.pages.Customer.CustomerDetail.components.HealthRecords.index.c3':
    '事件处理',
  'src.pages.Customer.CustomerDetail.components.HealthRecords.index.c4': '打卡',
  'src.pages.Customer.CustomerDetail.components.HealthRecords.index.c5':
    '共{total}条',
  'src.pages.Customer.CustomerDetail.components.HealthReport.CheckupReportTable.index.c1':
    '提示',
  'src.pages.Customer.CustomerDetail.components.HealthReport.CheckupReportTable.index.c2':
    '该用户暂无证件号码，是否填写？',
  'src.pages.Customer.CustomerDetail.components.HealthReport.CheckupReportTable.index.c3':
    '获取体检报告详情失败，请稍后重试',
  'src.pages.Customer.CustomerDetail.components.HealthReport.CheckupReportTable.index.c4':
    '删除成功',
  'src.pages.Customer.CustomerDetail.components.HealthReport.CheckupReportTable.index.c5':
    '删除失败，请稍后重试',
  'src.pages.Customer.CustomerDetail.components.HealthReport.CheckupReportTable.index.c6':
    '体检机构',
  'src.pages.Customer.CustomerDetail.components.HealthReport.CheckupReportTable.index.c7':
    '体检日期',
  'src.pages.Customer.CustomerDetail.components.HealthReport.CheckupReportTable.index.c8':
    '报告类型',
  'src.pages.Customer.CustomerDetail.components.HealthReport.CheckupReportTable.index.c9':
    '主要健康问题',
  'src.pages.Customer.CustomerDetail.components.HealthReport.CheckupReportTable.index.c10':
    '操作',
  'src.pages.Customer.CustomerDetail.components.HealthReport.CheckupReportTable.index.c11':
    '查看',
  'src.pages.Customer.CustomerDetail.components.HealthReport.CheckupReportTable.index.c12':
    '共{total}条记录',
  'src.pages.Customer.CustomerDetail.components.HealthReport.CheckupReportTable.index.c13':
    '上传体检报告',
  'src.pages.Customer.CustomerDetail.components.HealthReport.HutReport.index.c1':
    '结束成功',
  'src.pages.Customer.CustomerDetail.components.HealthReport.HutReport.index.c2':
    '结束失败，请稍后重试',
  'src.pages.Customer.CustomerDetail.components.HealthReport.HutReport.index.c3':
    '开检时间',
  'src.pages.Customer.CustomerDetail.components.HealthReport.HutReport.index.c4':
    '结束时间',
  'src.pages.Customer.CustomerDetail.components.HealthReport.HutReport.index.c5':
    '健康小屋',
  'src.pages.Customer.CustomerDetail.components.HealthReport.HutReport.index.c6':
    '已检项目',
  'src.pages.Customer.CustomerDetail.components.HealthReport.HutReport.index.c7':
    '操作',
  'src.pages.Customer.CustomerDetail.components.HealthReport.HutReport.index.c8':
    '查看',
  'src.pages.Customer.CustomerDetail.components.HealthReport.HutReport.index.c9':
    '结束',
  'src.pages.Customer.CustomerDetail.components.HealthReport.HutReport.index.c10':
    '共{total}条记录',
  'src.pages.Customer.CustomerDetail.components.HealthReport.ImageReportDetail.index.c1':
    '报告详情',
  'src.pages.Customer.CustomerDetail.components.HealthReport.ImageReportDetail.index.c2':
    '关闭',
  'src.pages.Customer.CustomerDetail.components.HealthReport.ImageReportDetail.index.c3':
    '暂时没有上传报告图片，请您上传！',
  'src.pages.Customer.CustomerDetail.components.HealthReport.index.c1':
    '体检报告',
  'src.pages.Customer.CustomerDetail.components.HealthReport.index.c2':
    '健康小屋报告',
  'src.pages.Customer.CustomerDetail.components.HealthReport.index.c3':
    '检测记录',
  'src.pages.Customer.CustomerDetail.components.HealthReport.UploadReportModal.index.c1':
    '上传体检报告',
  'src.pages.Customer.CustomerDetail.components.HealthReport.UploadReportModal.index.c2':
    '重新上传，已废弃',
  'src.pages.Customer.CustomerDetail.components.HealthReport.UploadReportModal.index.c3':
    '本地调试需要前面加上 domain',
  'src.pages.Customer.CustomerDetail.components.HealthReport.UploadReportModal.index.c4':
    '检测机构',
  'src.pages.Customer.CustomerDetail.components.HealthReport.UploadReportModal.index.c7':
    '检测时间',
  'src.pages.Customer.CustomerDetail.components.HealthReport.UploadReportModal.index.c10':
    '报告类型',
  'src.pages.Customer.CustomerDetail.components.HealthReport.UploadReportModal.index.c13':
    '上传成功',
  'src.pages.Customer.CustomerDetail.components.HealthReport.UploadReportModal.index.c14':
    '请选择文件',
  'src.pages.Customer.CustomerDetail.components.HealthReport.UploadReportModal.index.c15':
    '请输入检测机构',
  'src.pages.Customer.CustomerDetail.components.HealthReport.UploadReportModal.index.c16':
    '最大长度为50',
  'src.pages.Customer.CustomerDetail.components.HealthReport.UploadReportModal.index.c17':
    '请选择检测时间',
  'src.pages.Customer.CustomerDetail.components.HealthReport.UploadReportModal.index.c18':
    'PDF报告',
  'src.pages.Customer.CustomerDetail.components.HealthReport.UploadReportModal.index.c19':
    '图片报告',
  'src.pages.Customer.CustomerDetail.components.HealthReport.UploadReportModal.index.c20':
    '点击或将文件拖拽到这里上传',
  'src.pages.Customer.CustomerDetail.components.HealthReport.UploadReportModal.index.c21':
    '支持文件格式',
  'src.pages.Customer.CustomerDetail.components.HealthReport.UploadReportModal.index.c22':
    '每次最多可上传一个pdf文件，或最多99张图片',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.index.c1':
    '健康报告',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.index.c2':
    '体检报告',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.index.c3':
    '评估报告',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.index.c4':
    '健康小屋报告',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.index.c5':
    '检测报告',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.AssessmentRecordTable.index.c1':
    '删除成功',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.AssessmentRecordTable.index.c2':
    '删除失败，请稍后重试',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.AssessmentRecordTable.index.c3':
    '问卷名称',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.AssessmentRecordTable.index.c4':
    '评估客户',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.AssessmentRecordTable.index.c5':
    '岁',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.AssessmentRecordTable.index.c6':
    '开始答卷',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.AssessmentRecordTable.index.c7':
    '完成答卷',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.AssessmentRecordTable.index.c8':
    '完成时长（分）',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.AssessmentRecordTable.index.c9':
    '答卷状态',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.AssessmentRecordTable.index.c10':
    '进行中',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.AssessmentRecordTable.index.c11':
    '已完成',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.AssessmentRecordTable.index.c12':
    '操作',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.AssessmentRecordTable.index.c13':
    '继续答卷',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.AssessmentRecordTable.index.c14':
    '查看报告',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.AssessmentRecordTable.index.c15':
    '查看答卷',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.AssessmentRecordTable.index.c16':
    '确认删除该问卷记录？',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.AssessmentRecordTable.index.c17':
    '删除',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.AssessmentRecordTable.index.c18':
    '共{total}条记录',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.AssessmentRecordTable.index.c19':
    '新增评估',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.AssessmentRecordTable.index.c20':
    '请选择问卷',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.CheckupReportTable.index.c1':
    '获取体检报告详情失败，请稍后重试',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.CheckupReportTable.index.c2':
    '删除成功',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.CheckupReportTable.index.c3':
    '删除失败，请稍后重试',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.CheckupReportTable.index.c4':
    '体检日期',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.CheckupReportTable.index.c5':
    '体检机构',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.CheckupReportTable.index.c6':
    '报告类型',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.CheckupReportTable.index.c7':
    '主要健康问题',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.CheckupReportTable.index.c8':
    '操作',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.CheckupReportTable.index.c9':
    '查看',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.CheckupReportTable.index.c10':
    '共{total}条记录',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.CheckupReportTable.index.c11':
    '上传报告',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.Exam.index.c1':
    '报告名称',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.Exam.index.c2':
    '检测说明',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.Exam.index.c3':
    '报告内容',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.Exam.index.c4':
    '操作',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.Exam.index.c5':
    '编辑',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.Exam.index.c6':
    '共{total}条记录',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.Exam.index.c7':
    '上传报告',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.Exam.UpdateExamRecord.c1':
    '提示',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.Exam.UpdateExamRecord.c2':
    '该用户暂无证件号码，是否填写？',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.Exam.UpdateExamRecord.c3':
    '体检报告',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.Exam.UpdateExamRecord.c4':
    '保存',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.Exam.UpdateExamRecord.c5':
    '取消',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.Exam.UpdateExamRecord.c6':
    '上传成功',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.Exam.UpdateExamRecord.c7':
    '保存失败，请稍后重试',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.Exam.UpdateExamRecord.c8':
    '请选择文件',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.Exam.UpdateExamRecord.c9':
    '检测机构',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.Exam.UpdateExamRecord.c10':
    '请输入检测机构',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.Exam.UpdateExamRecord.c11':
    '最大长度为50',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.Exam.UpdateExamRecord.c12':
    '检测时间',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.Exam.UpdateExamRecord.c13':
    '请选择检测时间',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.Exam.UpdateExamRecord.c14':
    '报告类型',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.Exam.UpdateExamRecord.c15':
    'PDF报告',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.Exam.UpdateExamRecord.c16':
    '图片报告',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.Exam.UpdateExamRecord.c17':
    '请上传报告文件',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.Exam.UpdateExamRecord.c18':
    '点击或将文件拖拽到这里上传',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.Exam.UpdateExamRecord.c19':
    '支持文件格式',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.Exam.UpdateExamRecord.c20':
    '每次最多可上传一个pdf文件，或最多99张图片',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.Exam.UpdateExamRecord.c21':
    '检测报告',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.Exam.UpdateExamRecord.c22':
    '{action}成功',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.Exam.UpdateExamRecord.c23':
    '{action}失败，请稍后重试',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.Exam.UpdateExamRecord.c24':
    '记录名称',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.Exam.UpdateExamRecord.c25':
    '请输入记录名称',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.Exam.UpdateExamRecord.c26':
    '检测说明',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.HutReport.index.c1':
    '结束成功',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.HutReport.index.c2':
    '结束失败，请稍后重试',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.HutReport.index.c3':
    '开检时间',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.HutReport.index.c4':
    '结束时间',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.HutReport.index.c5':
    '健康小屋',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.HutReport.index.c6':
    '已检项目',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.HutReport.index.c7':
    '操作',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.HutReport.index.c8':
    '查看',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.HutReport.index.c9':
    '结束',
  'src.pages.Customer.CustomerDetail.components.HealthReportCard.components.HutReport.index.c10':
    '共{total}条记录',
  'src.pages.Customer.CustomerDetail.components.HealthTarget.index.c1':
    '健康目标设置',
  'src.pages.Customer.CustomerDetail.components.HealthTarget.index.c2': '添加',
  'src.pages.Customer.CustomerDetail.components.HealthTarget.index.c3': '身高',
  'src.pages.Customer.CustomerDetail.components.HealthTarget.index.c4':
    '步数(腕表)',
  'src.pages.Customer.CustomerDetail.components.HealthTarget.index.c5': '体重',
  'src.pages.Customer.CustomerDetail.components.HealthTarget.index.c6': '腰围',
  'src.pages.Customer.CustomerDetail.components.HealthTarget.index.c7': '臀围',
  'src.pages.Customer.CustomerDetail.components.HealthTarget.index.c8':
    '收缩压',
  'src.pages.Customer.CustomerDetail.components.HealthTarget.index.c9':
    '舒张压',
  'src.pages.Customer.CustomerDetail.components.HealthTarget.index.c10':
    '空腹血糖',
  'src.pages.Customer.CustomerDetail.components.HealthTarget.index.c11':
    '餐后2h血糖',
  'src.pages.Customer.CustomerDetail.components.HealthTarget.index.c12':
    '健康指标',
  'src.pages.Customer.CustomerDetail.components.HealthTarget.index.c13':
    '控制目标',
  'src.pages.Customer.CustomerDetail.components.HealthTarget.index.c14':
    '近7天平均值',
  'src.pages.Customer.CustomerDetail.components.HealthTarget.UpdateHealthTarget.c1':
    '健康目标设置',
  'src.pages.Customer.CustomerDetail.components.HealthTarget.UpdateHealthTarget.c2':
    '健康目标范围设置',
  'src.pages.Customer.CustomerDetail.components.HealthTarget.UpdateHealthTarget.c3':
    '肥胖',
  'src.pages.Customer.CustomerDetail.components.HealthTarget.UpdateHealthTarget.c4':
    '血压',
  'src.pages.Customer.CustomerDetail.components.HealthTarget.UpdateHealthTarget.c5':
    '血糖',
  'src.pages.Customer.CustomerDetail.components.HealthTarget.UpdateHealthTarget.c6':
    '下限',
  'src.pages.Customer.CustomerDetail.components.HealthTarget.UpdateHealthTarget.c7':
    '上限',
  'src.pages.Customer.CustomerDetail.components.HealthTarget.UpdateHealthTarget.c8':
    '下限要小于上限',
  'src.pages.Customer.CustomerDetail.components.HealthTarget.UpdateHealthTarget.c9':
    '设置成功',
  'src.pages.Customer.CustomerDetail.components.HealthTarget.UpdateHealthTarget.c10':
    '设置失败，请稍后重试',
  'src.pages.Customer.CustomerDetail.components.HealthTarget.UpdateHealthTarget.c11':
    '肥胖评估',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c1':
    '身高',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c2':
    '体重',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c3':
    '测量时间',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c4':
    '腰围',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c5':
    '臀围',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c6':
    '测量时间',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c7':
    '舒张压(低压)',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c8':
    '收缩压(高压)',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c9':
    '心率',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c10':
    '测量时间',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c11':
    '血糖值',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c12':
    '测量时间',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c13':
    '测量时段',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c14':
    '总胆固醇',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c15':
    '甘油三酯',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c16':
    '高脂蛋白胆固醇',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c17':
    '低脂蛋白胆固醇',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c18':
    '测量时间',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c19':
    '尿酸值',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c20':
    '测量时间',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c21':
    '血肌酐值',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c22':
    '测量时间',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c23':
    '谷草转氨酶',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c24':
    '谷丙转氨酶',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c25':
    '测量时间',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c26':
    '凌晨',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c27':
    '早餐前',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c28':
    '早餐后',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c29':
    '午餐前',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c30':
    '午餐后',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c31':
    '晚餐前',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c32':
    '晚餐后',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c33':
    '睡前',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c34':
    '请输入体重',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c35':
    '请选择测量时间',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c36':
    '请输入舒张压',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c37':
    '请输入收缩压',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c38':
    '次/分',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c39':
    '请输入血糖值',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c40':
    '请选择测量时段',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c41':
    '请输入尿酸值',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c42':
    '请输入血肌酐值',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c43':
    '脂肪率',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c44':
    '肌肉率',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c45':
    '骨骼肌率',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c46':
    '水分率',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c47':
    '蛋白质',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c48':
    '基础代谢量',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c49':
    '请输入基础代谢量',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c50':
    '步数',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c51':
    '步',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c52':
    '睡眠时长',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c53':
    '小时',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c54':
    '身高体重',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c55':
    '体围',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c56':
    '体成分',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c57':
    '基础代谢',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c58':
    '血压',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c59':
    '血糖',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c60':
    '血脂',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c61':
    '尿酸',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c62':
    '血肌酐',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c63':
    '肝功能',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c64':
    '步数',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c65':
    '睡眠',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c66':
    '糖化血红蛋白',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c67':
    '请输入糖化血红蛋白',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.AddMetricFormBody.c68':
    '请输入身高',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.index.c1':
    '添加测量记录',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.index.c2':
    '如果选择的项目最少必填一个指标',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.index.c3':
    '如果是有子指标的话，则校验子指标',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.index.c4':
    '如果没有子指标，则校验 value',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.index.c5':
    '如果不用输入子项的，则将 detectType 作为 name 提交',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.index.c6':
    '血糖特殊处理，需要将时段作为 name 提交',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.index.c7':
    '否则遍历子项',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.index.c8':
    '测量项目',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.index.c15':
    '最少必填一项',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.index.c16':
    '添加成功',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddCustomerMetrics.index.c17':
    '请求失败，请稍后重试',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddMetricComment.index.c1':
    '编辑',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddMetricComment.index.c2':
    '新增',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddMetricComment.index.c3':
    '备注',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddMetricComment.index.c4':
    '成功',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddMetricComment.index.c5':
    '请求失败，请稍后重试',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.AddMetricComment.index.c6':
    '请输入备注内容',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.ChartMode.index.c1':
    '收缩压',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.ChartMode.index.c2':
    '舒张压',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.ChartMode.index.c3':
    '心率',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.ChartMode.index.c4':
    '空腹血糖',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.ChartMode.index.c5':
    '餐前血糖',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.ChartMode.index.c6':
    '餐后血糖',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.ChartMode.metricOptionsConf.c1':
    '收缩压',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.ChartMode.metricOptionsConf.c2':
    '舒张压',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.TableModeBS.index.c1':
    '凌晨',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.TableModeBS.index.c2':
    '早餐前',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.TableModeBS.index.c3':
    '早餐后',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.TableModeBS.index.c4':
    '午餐前',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.TableModeBS.index.c5':
    '午餐后',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.TableModeBS.index.c6':
    '晚餐前',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.TableModeBS.index.c7':
    '晚餐后',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.TableModeBS.index.c8':
    '睡前',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.TableModeBS.index.c9':
    '周一',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.TableModeBS.index.c10':
    '周二',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.TableModeBS.index.c11':
    '周三',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.TableModeBS.index.c12':
    '周四',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.TableModeBS.index.c13':
    '周五',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.TableModeBS.index.c14':
    '周六',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.TableModeBS.index.c15':
    '周日',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.TableModeBS.index.c16':
    '月',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.TableModeBS.index.c17':
    '日',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.TableModeBS.index.c18':
    '日期',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.TableModeBS.index.c19':
    '早餐',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.TableModeBS.index.c20':
    '中餐',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.TableModeBS.index.c21':
    '晚餐',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.TableModeBS.index.c22':
    '前',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.TableModeBS.index.c23':
    '后',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.TableModeBS.index.c24':
    'MM月DD日 ddd',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.index.c1':
    '身高体重',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.index.c2':
    '需要展示子指标的',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.index.c3':
    '时间选择器',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.index.c4':
    '时间段，默认周',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.index.c5':
    '使用上与 useEffect 完全相同，只是它忽略了首次渲染，且只在依赖项更新时运行。',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.index.c6':
    '数据来源：问安设备、健康小屋设备、体检中心报告',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.index.c7':
    '添加测量记录',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.index.c8': '体围',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.index.c15':
    '体成分',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.index.c22':
    '基础代谢',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.index.c29': '血压',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.index.c36': '血糖',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.index.c43': '血脂',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.index.c50': '尿酸',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.index.c57':
    '血肌酐',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.index.c64':
    '肝功能',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.index.c71': '步数',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.index.c78': '睡眠',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.index.c85': '日',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.index.c86': '周',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.index.c87': '月',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.index.c88': '年',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.index.c89':
    '健康趋势',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.index.c90':
    '数据列表',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.index.c91':
    '切换到表格模式',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.index.c92':
    '切换到图表模式',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.TableMode.index.c1':
    '确认删除该记录？',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.TableMode.index.c2':
    '如果是要展示子项的',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.TableMode.index.c3':
    '如果是血压，则合并展示',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.TableMode.index.c4':
    '其他的子项则并排展示',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.TableMode.index.c5':
    '正常情况',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.TableMode.index.c6':
    '删除成功',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.TableMode.index.c7':
    '请求失败，请稍后重试',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.TableMode.index.c8':
    '指标',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.TableMode.index.c9':
    '结果',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.TableMode.index.c10':
    '数据来源',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.TableMode.index.c11':
    '测量时间',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.TableMode.index.c12':
    '备注',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.TableMode.index.c13':
    '操作',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.TableMode.index.c14':
    '备注',
  'src.pages.Customer.CustomerDetail.components.HealthTrend.TableMode.index.c15':
    '删除',
  'src.pages.Customer.CustomerDetail.components.HealthTrendCard.index.c1': '日',
  'src.pages.Customer.CustomerDetail.components.HealthTrendCard.index.c2': '周',
  'src.pages.Customer.CustomerDetail.components.HealthTrendCard.index.c3': '月',
  'src.pages.Customer.CustomerDetail.components.HealthTrendCard.index.c4': '年',
  'src.pages.Customer.CustomerDetail.components.HealthTrendCard.index.c5':
    '记录体征',
  'src.pages.Customer.CustomerDetail.components.HealthTrendCard.index.c6':
    '健康趋势',
  'src.pages.Customer.CustomerDetail.components.HealthTrendCard.index.c7':
    '数据列表',
  'src.pages.Customer.CustomerDetail.components.HealthTrendCard.index.c8':
    '身高体重',
  'src.pages.Customer.CustomerDetail.components.HealthTrendCard.index.c9':
    '体围',
  'src.pages.Customer.CustomerDetail.components.HealthTrendCard.index.c10':
    '体成分',
  'src.pages.Customer.CustomerDetail.components.HealthTrendCard.index.c11':
    '基础代谢',
  'src.pages.Customer.CustomerDetail.components.HealthTrendCard.index.c12':
    '血压',
  'src.pages.Customer.CustomerDetail.components.HealthTrendCard.index.c13':
    '血糖',
  'src.pages.Customer.CustomerDetail.components.HealthTrendCard.index.c14':
    '血脂',
  'src.pages.Customer.CustomerDetail.components.HealthTrendCard.index.c15':
    '尿酸',
  'src.pages.Customer.CustomerDetail.components.HealthTrendCard.index.c16':
    '血肌酐',
  'src.pages.Customer.CustomerDetail.components.HealthTrendCard.index.c17':
    '肝功能',
  'src.pages.Customer.CustomerDetail.components.HealthTrendCard.index.c18':
    '步数',
  'src.pages.Customer.CustomerDetail.components.HealthTrendCard.index.c19':
    '睡眠',
  'src.pages.Customer.CustomerDetail.components.HealthTrendCard.index.c20':
    '切换到表格模式',
  'src.pages.Customer.CustomerDetail.components.HealthTrendCard.index.c21':
    '切换到图表模式',
  'src.pages.Customer.CustomerDetail.components.HealthTrendCard.index.c22':
    '添加体征记录',
  'src.pages.Customer.CustomerDetail.components.HealthTrendCard.index.c23':
    '动态血糖',
  'src.pages.Customer.CustomerDetail.components.HealthTrendCard.index.c24':
    '糖化血红蛋白',
  'src.pages.Customer.CustomerDetail.components.HealthTrendCard.index.c25':
    '导出健康体征',
  'src.pages.Customer.CustomerDetail.components.HealthTrendCard.index.c26':
    '导出',
  'src.pages.Customer.CustomerDetail.components.HealthTrendCard.index.all':
    '全部',
  'src.pages.Customer.CustomerDetail.components.HealthTrendCard.index.breakfast':
    '早餐',
  'src.pages.Customer.CustomerDetail.components.HealthTrendCard.index.lunch':
    '午餐',
  'src.pages.Customer.CustomerDetail.components.HealthTrendCard.index.dinner':
    '晚餐',
  'src.pages.Customer.CustomerDetail.components.HealthTrendCard.index.bedtime':
    '睡前',
  'src.pages.Customer.CustomerDetail.components.HealthTrendCard.index.dawn':
    '凌晨',

  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.index.c1':
    '就医记录',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.index.c2':
    '用药记录',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.index.c3':
    '门诊记录',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.index.c4':
    '急诊记录',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.index.c5':
    '手术记录',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.EmergencyTable.index.c1':
    '记录类型',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.EmergencyTable.index.c2':
    '记录名称',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.EmergencyTable.index.c3':
    '内容',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.EmergencyTable.index.c4':
    '图片',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.EmergencyTable.index.c5':
    '操作',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.EmergencyTable.index.c6':
    '编辑',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.EmergencyTable.index.c7':
    '共{total}条记录',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.EmergencyTable.index.c8':
    '添加记录',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.Exam.index.c1':
    '检测类型',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.Exam.index.c2':
    '记录名称',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.Exam.index.c3':
    '内容',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.Exam.index.c4':
    '操作',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.Exam.index.c5':
    '共{total}条记录',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.Exam.index.c6':
    '添加记录',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.Exam.UpdateExamRecord.c1':
    '{action}检测记录',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.Exam.UpdateExamRecord.c2':
    '{action}成功',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.Exam.UpdateExamRecord.c3':
    '{action}失败，请稍后重试',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.Exam.UpdateExamRecord.c4':
    '记录名称',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.Exam.UpdateExamRecord.c5':
    '请输入记录名称',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.Exam.UpdateExamRecord.c6':
    '检测说明',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.Exam.UpdateExamRecord.c7':
    '检测报告',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.MedicationTable.index.c1':
    '药品名称',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.MedicationTable.index.c2':
    '服药周期',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.MedicationTable.index.c3':
    '至',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.MedicationTable.index.c4':
    '长期服药',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.MedicationTable.index.c5':
    '用法说明',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.MedicationTable.index.c6':
    '用药状态',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.MedicationTable.index.c7':
    '用药提醒',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.MedicationTable.index.c8':
    '已设置',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.MedicationTable.index.c9':
    '已失效',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.MedicationTable.index.c10':
    '未设置',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.MedicationTable.index.c11':
    '最近提醒',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.MedicationTable.index.c12':
    '操作',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.MedicationTable.index.c13':
    '编辑',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.MedicationTable.index.c14':
    '共{total}条记录',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.MedicationTable.index.c15':
    '添加记录',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.MedicationTable.index.c16':
    '服药中',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.MedicationTable.index.c17':
    '已停药',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.MedicationTable.index.c18':
    '未开始',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.MedicationTable.UpdateMedicationPlan.c1':
    '{action}用药记录',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.MedicationTable.UpdateMedicationPlan.c2':
    '保存',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.MedicationTable.UpdateMedicationPlan.c3':
    '{action}成功',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.MedicationTable.UpdateMedicationPlan.c4':
    '{action}失败，请稍后重试',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.MedicationTable.UpdateMedicationPlan.c5':
    '药品名称',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.MedicationTable.UpdateMedicationPlan.c6':
    '从药品库选择或输入',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.MedicationTable.UpdateMedicationPlan.c7':
    '用法说明',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.MedicationTable.UpdateMedicationPlan.c8':
    '用药周期',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.MedicationTable.UpdateMedicationPlan.c9':
    '请选择用药周期起始日期',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.MedicationTable.UpdateMedicationPlan.c10':
    '请选择用药周期结束日期',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.MedicationTable.UpdateMedicationPlan.c11':
    '结束日期不能小于当前日期',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.MedicationTable.UpdateMedicationPlan.c12':
    '长期服药',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.MedicationTable.UpdateMedicationPlan.c13':
    '设置提醒',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.MedicationTable.UpdateMedicationPlan.c14':
    '开启',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.MedicationTable.UpdateMedicationPlan.c15':
    '关闭',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.MedicationTable.UpdateMedicationPlan.c16':
    '请选择提醒频率',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.MedicationTable.UpdateMedicationPlan.c17':
    '每天用药',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.MedicationTable.UpdateMedicationPlan.c18':
    '每隔{t}天',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.MedicationTable.UpdateMedicationPlan.c19':
    '提醒时间',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.MedicationTable.UpdateMedicationPlan.c20':
    '请添加提醒时间',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.MedicationTable.UpdateMedicationPlan.c21':
    '添加',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.MedicationTable.UpdateMedicationPlan.c22':
    '晨起用药',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.MedicationTable.UpdateMedicationPlan.c23':
    '餐前用药',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.MedicationTable.UpdateMedicationPlan.c24':
    '随餐用药',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.MedicationTable.UpdateMedicationPlan.c25':
    '饭后用药',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.MedicationTable.UpdateMedicationPlan.c26':
    '睡前用药',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.OperationTable.index.c1':
    '记录类型',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.OperationTable.index.c2':
    '记录名称',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.OperationTable.index.c3':
    '内容',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.OperationTable.index.c4':
    '图片',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.OperationTable.index.c5':
    '操作',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.OperationTable.index.c6':
    '编辑',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.OperationTable.index.c7':
    '共{total}条记录',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.OperationTable.index.c8':
    '添加记录',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.OutpatientTable.index.c1':
    '记录类型',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.OutpatientTable.index.c2':
    '记录名称',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.OutpatientTable.index.c3':
    '内容',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.OutpatientTable.index.c4':
    '图片',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.OutpatientTable.index.c5':
    '操作',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.OutpatientTable.index.c6':
    '编辑',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.OutpatientTable.index.c7':
    '共{total}条记录',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.OutpatientTable.index.c8':
    '添加记录',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.OutpatientTable.UpdateMedicationRecords.c1':
    '{action}就医记录',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.OutpatientTable.UpdateMedicationRecords.c2':
    '{action}成功',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.OutpatientTable.UpdateMedicationRecords.c3':
    '{action}失败，请稍后重试',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.OutpatientTable.UpdateMedicationRecords.c4':
    '记录名称',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.OutpatientTable.UpdateMedicationRecords.c5':
    '门诊记录',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.OutpatientTable.UpdateMedicationRecords.c6':
    '急诊记录',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.OutpatientTable.UpdateMedicationRecords.c7':
    '手术记录',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.OutpatientTable.UpdateMedicationRecords.c8':
    '请输入记录名称',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.OutpatientTable.UpdateMedicationRecords.c9':
    '发生日期',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.OutpatientTable.UpdateMedicationRecords.c10':
    '病历说明',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.OutpatientTable.UpdateMedicationRecords.c11':
    '诊断报告',
  'src.pages.Customer.CustomerDetail.components.MedicalRecordCard.OutpatientTable.UpdateMedicationRecords.c12':
    '格式说明：支持图片上传',
  'src.pages.Customer.CustomerDetail.components.MedicalRecords.Diagnosis.index.c1':
    '医疗类型',
  'src.pages.Customer.CustomerDetail.components.MedicalRecords.Diagnosis.index.c2':
    '记录名称',
  'src.pages.Customer.CustomerDetail.components.MedicalRecords.Diagnosis.index.c3':
    '内容',
  'src.pages.Customer.CustomerDetail.components.MedicalRecords.Diagnosis.index.c4':
    '操作',
  'src.pages.Customer.CustomerDetail.components.MedicalRecords.Diagnosis.index.c5':
    '共{total}条记录',
  'src.pages.Customer.CustomerDetail.components.MedicalRecords.Diagnosis.index.c6':
    '添加记录',
  'src.pages.Customer.CustomerDetail.components.MedicalRecords.Diagnosis.UpdateMedicationRecords.c1':
    '记录名称',
  'src.pages.Customer.CustomerDetail.components.MedicalRecords.Diagnosis.UpdateMedicationRecords.c2':
    '发生日期',
  'src.pages.Customer.CustomerDetail.components.MedicalRecords.Diagnosis.UpdateMedicationRecords.c3':
    '病历说明',
  'src.pages.Customer.CustomerDetail.components.MedicalRecords.Diagnosis.UpdateMedicationRecords.c4':
    '诊断报告',
  'src.pages.Customer.CustomerDetail.components.MedicalRecords.Diagnosis.UpdateMedicationRecords.c5':
    '{action}医疗记录',
  'src.pages.Customer.CustomerDetail.components.MedicalRecords.Diagnosis.UpdateMedicationRecords.c6':
    '{action}成功',
  'src.pages.Customer.CustomerDetail.components.MedicalRecords.Diagnosis.UpdateMedicationRecords.c7':
    '{action}失败，请稍后重试',
  'src.pages.Customer.CustomerDetail.components.MedicalRecords.Diagnosis.UpdateMedicationRecords.c8':
    '门诊记录',
  'src.pages.Customer.CustomerDetail.components.MedicalRecords.Diagnosis.UpdateMedicationRecords.c9':
    '急诊记录',
  'src.pages.Customer.CustomerDetail.components.MedicalRecords.Diagnosis.UpdateMedicationRecords.c10':
    '手术记录',
  'src.pages.Customer.CustomerDetail.components.MedicalRecords.Diagnosis.UpdateMedicationRecords.c11':
    '请输入记录名称',
  'src.pages.Customer.CustomerDetail.components.MedicalRecords.Exam.index.c1':
    '检测类型',
  'src.pages.Customer.CustomerDetail.components.MedicalRecords.Exam.index.c2':
    '记录名称',
  'src.pages.Customer.CustomerDetail.components.MedicalRecords.Exam.index.c3':
    '内容',
  'src.pages.Customer.CustomerDetail.components.MedicalRecords.Exam.index.c4':
    '操作',
  'src.pages.Customer.CustomerDetail.components.MedicalRecords.Exam.index.c5':
    '共{total}条记录',
  'src.pages.Customer.CustomerDetail.components.MedicalRecords.Exam.index.c6':
    '添加记录',
  'src.pages.Customer.CustomerDetail.components.MedicalRecords.Exam.UpdateExamRecord.c1':
    '记录名称',
  'src.pages.Customer.CustomerDetail.components.MedicalRecords.Exam.UpdateExamRecord.c2':
    '检测说明',
  'src.pages.Customer.CustomerDetail.components.MedicalRecords.Exam.UpdateExamRecord.c3':
    '检测报告',
  'src.pages.Customer.CustomerDetail.components.MedicalRecords.Exam.UpdateExamRecord.c4':
    '{action}检测记录',
  'src.pages.Customer.CustomerDetail.components.MedicalRecords.Exam.UpdateExamRecord.c5':
    '{action}成功',
  'src.pages.Customer.CustomerDetail.components.MedicalRecords.Exam.UpdateExamRecord.c6':
    '{action}失败，请稍后重试',
  'src.pages.Customer.CustomerDetail.components.MedicalRecords.Exam.UpdateExamRecord.c7':
    '请输入记录名称',
  'src.pages.Customer.CustomerDetail.components.MedicalRecords.Medication.index.c1':
    '药品',
  'src.pages.Customer.CustomerDetail.components.MedicalRecords.Medication.index.c2':
    '服药周期',
  'src.pages.Customer.CustomerDetail.components.MedicalRecords.Medication.index.c3':
    '操作',
  'src.pages.Customer.CustomerDetail.components.MedicalRecords.Medication.index.c4':
    '共{total}条记录',
  'src.pages.Customer.CustomerDetail.components.MedicalRecords.Medication.index.c5':
    '添加记录',
  'src.pages.Customer.CustomerDetail.components.MedicalRecords.Medication.UpdateMedicationPlan.c1':
    '药品名称',
  'src.pages.Customer.CustomerDetail.components.MedicalRecords.Medication.UpdateMedicationPlan.c2':
    '开始日期，结束日期',
  'src.pages.Customer.CustomerDetail.components.MedicalRecords.Medication.UpdateMedicationPlan.c3':
    '处理日期',
  'src.pages.Customer.CustomerDetail.components.MedicalRecords.Medication.UpdateMedicationPlan.c4':
    '用法说明',
  'src.pages.Customer.CustomerDetail.components.MedicalRecords.Medication.UpdateMedicationPlan.c6':
    '处理日期',
  'src.pages.Customer.CustomerDetail.components.MedicalRecords.Medication.UpdateMedicationPlan.c7':
    '用药周期',
  'src.pages.Customer.CustomerDetail.components.MedicalRecords.Medication.UpdateMedicationPlan.c9':
    '处理日期',
  'src.pages.Customer.CustomerDetail.components.MedicalRecords.Medication.UpdateMedicationPlan.c10':
    '{action}用药记录',
  'src.pages.Customer.CustomerDetail.components.MedicalRecords.Medication.UpdateMedicationPlan.c11':
    '{action}成功',
  'src.pages.Customer.CustomerDetail.components.MedicalRecords.Medication.UpdateMedicationPlan.c12':
    '{action}失败，请稍后重试',
  'src.pages.Customer.CustomerDetail.components.MedicalRecords.Medication.UpdateMedicationPlan.c13':
    '请输入药品名称',
  'src.pages.Customer.CustomerDetail.components.MedicalRecords.index.c1':
    '用药记录',
  'src.pages.Customer.CustomerDetail.components.MedicalRecords.index.c2':
    '医疗记录',
  'src.pages.Customer.CustomerDetail.components.MedicationPlanCard.index.c1':
    '正在服药',
  'src.pages.Customer.CustomerDetail.components.MedicationPlanCard.index.c2':
    '至',
  'src.pages.Customer.CustomerDetail.components.MedicationPlanCard.index.c3':
    '长期',
  'src.pages.Customer.CustomerDetail.components.MedicationPlanCard.index.c4':
    '无',
  'src.pages.Customer.CustomerDetail.components.MeterCard.index.c1':
    '请求失败，请稍后重试',
  'src.pages.Customer.CustomerDetail.components.MeterCard.index.c2': '她',
  'src.pages.Customer.CustomerDetail.components.MeterCard.index.c3': '他',
  'src.pages.Customer.CustomerDetail.components.MeterCard.index.c4': '的设备',
  'src.pages.Customer.CustomerDetail.components.MeterCard.index.c5': '查看报告',
  'src.pages.Customer.CustomerDetail.components.MeterCard.index.c6': '无',
  'src.pages.Customer.CustomerDetail.components.Meters.index.c1': '使用的设备',
  'src.pages.Customer.CustomerDetail.components.Meters.index.c2':
    '请求失败，请稍后重试',
  'src.pages.Customer.CustomerDetail.components.Meters.index.c3': '查看报告',
  'src.pages.Customer.CustomerDetail.components.Meters.index.c4': '详情',
  'src.pages.Customer.CustomerDetail.components.Profile.components.BindTeamModal.index.c1':
    '客户有使用中的套餐时不能更改团队',
  'src.pages.Customer.CustomerDetail.components.Profile.components.BindTeamModal.index.c2':
    '选项，由参数 notSetDisabled 决定是否禁用',
  'src.pages.Customer.CustomerDetail.components.Profile.components.BindTeamModal.index.c3':
    '更换团队',
  'src.pages.Customer.CustomerDetail.components.Profile.components.BindTeamModal.index.c5':
    '服务团队',
  'src.pages.Customer.CustomerDetail.components.Profile.components.BindTeamModal.index.c7':
    '不设置',
  'src.pages.Customer.CustomerDetail.components.Profile.components.BindTeamModal.index.c8':
    '请选择客户',
  'src.pages.Customer.CustomerDetail.components.Profile.components.BindTeamModal.index.c9':
    '绑定成功',
  'src.pages.Customer.CustomerDetail.components.Profile.components.BindTeamModal.index.c10':
    '请求失败，请稍后重试',
  'src.pages.Customer.CustomerDetail.components.Profile.components.BindTeamModal.index.c11':
    '请选择服务团队',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.index.c1':
    '个人信息',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.index.c4':
    '根据身份证填写性别日期',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.index.c5':
    '请输入正确的手机号码或固定电话，固定电话格式为“区号+号码”',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.index.c6':
    '如01088888888，中间无需标点符号连接。',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.index.c7':
    '姓名',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.index.c13':
    '证件号码',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.index.c19':
    '证件类型',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.index.c25':
    '请输入证件号码',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.index.c31':
    '生日',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.index.c37':
    '性别',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.index.c43':
    '联系方式',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.index.c49':
    '登录手机号',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.index.c55':
    '现住址',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.index.c61':
    '民族',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.index.c67':
    '常住类型',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.index.c73':
    '文化程度',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.index.c79':
    '职业',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.index.c85':
    '婚姻状况',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.index.c91':
    '医保类型',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.index.c97':
    '档案编号',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.index.c103':
    '推荐人',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.index.c109':
    '身高',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.index.c115':
    '体重',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.index.c121':
    '腰围',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.index.c127':
    '臀围',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.index.c133':
    '请输入正确格式的联系方式',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.index.c134':
    '保存成功',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.index.c135':
    '保存失败，请稍后重试',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.index.c136':
    '基本信息',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.index.c137':
    '请输入姓名',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.index.c138':
    '请选择证件类型',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.index.c139':
    '身份证',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.index.c140':
    '其他',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.index.c141':
    '请输入证件号码',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.index.c142':
    '请输入正确格式的身份证',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.index.c143':
    '男',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.index.c144':
    '女',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.index.c145':
    '请选择生日',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.index.c146':
    '请选择性别',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.index.c147':
    '请输入正确格式的手机号码',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.index.c148':
    '户籍',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.index.c149':
    '非户籍',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.index.c150':
    '已婚',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.index.c151':
    '未婚',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.index.c152':
    '丧偶',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.index.c153':
    '离异',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.index.c154':
    '其他',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.index.c155':
    '健康信息',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.index.c156':
    'ABO血型',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.index.c157':
    'RH血型',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.healthFile.c0':
    'A型',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.healthFile.c1':
    'B型',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.healthFile.c2':
    'AB型',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.healthFile.c3':
    'O型',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.healthFile.c4':
    '不详',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.healthFile.c5':
    '阴性',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerInfo.healthFile.c6':
    '阳性',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerLabel.index.c1':
    '设置客户标签',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerLabel.index.c2':
    '保存成功',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerLabel.index.c3':
    '添加',
  'src.pages.Customer.CustomerDetail.components.Profile.components.CustomerLabel.index.c4':
    '移除',
  'src.pages.Customer.CustomerDetail.components.Profile.components.EditRemark.index.c1':
    '客户备注',
  'src.pages.Customer.CustomerDetail.components.Profile.components.EditRemark.index.c2':
    '确定',
  'src.pages.Customer.CustomerDetail.components.Profile.components.EditRemark.index.c3':
    '取消',
  'src.pages.Customer.CustomerDetail.components.Profile.components.EditRemark.index.c4':
    '修改成功',
  'src.pages.Customer.CustomerDetail.components.Profile.components.EditRemark.index.c5':
    '请输入',
  'src.pages.Customer.CustomerDetail.components.Profile.components.HealthFileForm.index.c1':
    '健康档案维护',
  'src.pages.Customer.CustomerDetail.components.Profile.components.HealthFileForm.index.c2':
    '获取题目',
  'src.pages.Customer.CustomerDetail.components.Profile.components.HealthFileForm.index.c3':
    '获取答案',
  'src.pages.Customer.CustomerDetail.components.Profile.components.HealthFileForm.index.c4':
    '获取问卷',
  'src.pages.Customer.CustomerDetail.components.Profile.components.HealthFileForm.index.c5':
    '获取已经回答过的问题答案',
  'src.pages.Customer.CustomerDetail.components.Profile.components.HealthFileForm.index.c6':
    '填入答案',
  'src.pages.Customer.CustomerDetail.components.Profile.components.HealthFileForm.index.c7':
    '处理后置关联题目',
  'src.pages.Customer.CustomerDetail.components.Profile.components.HealthFileForm.index.c8':
    '提交问卷',
  'src.pages.Customer.CustomerDetail.components.Profile.components.HealthFileForm.index.c9':
    '保存成功',
  'src.pages.Customer.CustomerDetail.components.Profile.components.HealthFileForm.index.c10':
    '表单验证未通过，请检查后重试',
  'src.pages.Customer.CustomerDetail.components.Profile.components.HealthFileForm.index.c11':
    '生活习惯',
  'src.pages.Customer.CustomerDetail.components.Profile.components.HealthFileForm.index.c12':
    '病史记录',
  'src.pages.Customer.CustomerDetail.components.Profile.components.PhoneCall.index.c1':
    '给客户拨打电话',
  'src.pages.Customer.CustomerDetail.components.Profile.components.PhoneCall.index.c2':
    '客户号码',
  'src.pages.Customer.CustomerDetail.components.Profile.components.PhoneCall.index.c3':
    '请选择',
  'src.pages.Customer.CustomerDetail.components.Profile.components.PhoneCall.index.c4':
    '我的号码',
  'src.pages.Customer.CustomerDetail.components.Profile.components.PhoneCall.index.c5':
    '拨打',
  'src.pages.Customer.CustomerDetail.components.Profile.components.PhoneCall.index.c6':
    '取消',
  'src.pages.Customer.CustomerDetail.components.Profile.components.PhoneCall.index.c7':
    '请选择客户号码',
  'src.pages.Customer.CustomerDetail.components.Profile.components.PhoneCall.index.c8':
    '请输入我的号码',
  'src.pages.Customer.CustomerDetail.components.Profile.components.SendMessage.index.c1':
    '给客户发送短信',
  'src.pages.Customer.CustomerDetail.components.Profile.components.SendMessage.index.c2':
    '客户号码',
  'src.pages.Customer.CustomerDetail.components.Profile.components.SendMessage.index.c3':
    '请选择',
  'src.pages.Customer.CustomerDetail.components.Profile.components.SendMessage.index.c4':
    '短信内容',
  'src.pages.Customer.CustomerDetail.components.Profile.components.SendMessage.index.c5':
    '发送',
  'src.pages.Customer.CustomerDetail.components.Profile.components.SendMessage.index.c6':
    '取消',
  'src.pages.Customer.CustomerDetail.components.Profile.components.SendMessage.index.c7':
    '请选择客户号码',
  'src.pages.Customer.CustomerDetail.components.Profile.components.SendMessage.index.c8':
    '请输入短信内容',
  'src.pages.Customer.CustomerDetail.components.Profile.index.c1': '客户号码',
  'src.pages.Customer.CustomerDetail.components.Profile.index.c2':
    '台个人设备，2个家人',
  'src.pages.Customer.CustomerDetail.components.Profile.index.c3':
    '紧急联系号码',
  'src.pages.Customer.CustomerDetail.components.Profile.index.c5': '档案编号',
  'src.pages.Customer.CustomerDetail.components.Profile.index.c6': '显示',
  'src.pages.Customer.CustomerDetail.components.Profile.index.c7': '隐藏',
  'src.pages.Customer.CustomerDetail.components.Profile.index.c8': '打电话',
  'src.pages.Customer.CustomerDetail.components.Profile.index.c9': '发短信',
  'src.pages.Customer.CustomerDetail.components.Profile.index.c10': '岁',
  'src.pages.Customer.CustomerDetail.components.Profile.index.c11': '详情',
  'src.pages.Customer.CustomerDetail.components.Profile.index.c12': '服务团队',
  'src.pages.Customer.CustomerDetail.components.Profile.index.c13':
    '暂无服务套餐及团队',
  'src.pages.Customer.CustomerDetail.components.Profile.index.c14': '绑定',
  'src.pages.Customer.CustomerDetail.components.Profile.index.c15': '客户标签',
  'src.pages.Customer.CustomerDetail.components.Profile.index.c16': '编辑',
  'src.pages.Customer.CustomerDetail.components.Profile.index.c17': '无',
  'src.pages.Customer.CustomerDetail.components.Profile.index.c18': '健康档案',
  'src.pages.Customer.CustomerDetail.components.Profile.index.c19': '客户备注',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.index.c1':
    '既往史获取失败',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.index.c2':
    '生活习惯获取失败',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.index.c3':
    '未知姓名',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.index.c4': '岁',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.index.c5': '标签',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.index.c6': '无',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.index.c7': '既往史',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.index.c8':
    '生活习惯',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c1':
    '请输入正确格式的联系电话',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c2':
    '请输入正确格式的紧急联系电话',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c3':
    '个人信息',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c4':
    '取消',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c5':
    '保存',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c6':
    '保存成功',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c7':
    '保存失败，请稍后重试',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c8':
    '基本信息',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c9':
    '姓名',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c10':
    '登录手机号',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c11':
    '证件号码',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c12':
    '请选择证件类型',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c13':
    '证件类型',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c14':
    '身份证',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c15':
    '其他',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c16':
    '请输入证件号码',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c17':
    '请输入正确格式的身份证',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c18':
    '男',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c19':
    '女',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c20':
    '生日',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c21':
    '请选择生日',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c22':
    '性别',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c23':
    '请选择性别',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c24':
    '联系电话',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c25':
    '请输入正确的手机号码或固定电话，固定电话格式为“区号+号码”',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c26':
    '如01088888888，中间无需标点符号连接。',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c27':
    '紧急联系电话',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c28':
    '可输入手机号或固定电话号码',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c29':
    '现住址',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c30':
    '民族',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c31':
    '常住类型',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c32':
    '户籍',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c33':
    '非户籍',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c34':
    '文化程度',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c35':
    '职业',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c36':
    '婚姻状况',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c37':
    '已婚',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c38':
    '未婚',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c39':
    '丧偶',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c40':
    '离异',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c41':
    '其他',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c42':
    '医保类型',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c43':
    '档案编号',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c44':
    '推荐人',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c45':
    '健康信息',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c46':
    '身高',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c47':
    '体重',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c48':
    '腰围',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c49':
    '臀围',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c50':
    'ABO血型',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c51':
    'RH血型',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c52':
    '修改登录手机号',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c53':
    '请输入正确格式的手机号码',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c54':
    '登录手机号关系到用户小程序端登录，请谨慎操作',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c55':
    '请输入详细地址',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c56':
    '删除成功',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c57':
    '已实名认证',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c58':
    '删除认证',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c59':
    '同登录手机号',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c60':
    '请输入',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c61':
    '请输入登录手机号码',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c62':
    '操作提醒',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c63':
    '请确认是否要删除该客户的实名认证？',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c64':
    '请选择',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c65':
    '请选择所在区域',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c66':
    '居住情况',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c67':
    '请输入身高',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c68':
    '请输入体重',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerInfoDrawer.index.c69':
    '身高、体重两个值，当其中一个值为非空时，另一个值就变为必填',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerLabelTransferModal.index.c1':
    '设置客户标签',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerLabelTransferModal.index.c2':
    '保存',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerLabelTransferModal.index.c3':
    '保存成功',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerLabelTransferModal.index.c4':
    '源列表',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.CustomerLabelTransferModal.index.c5':
    '目标列表',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.NewHealthFileForm.index.c6':
    '健康档案维护',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.NewHealthFileForm.index.c7':
    '保存',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.NewHealthFileForm.index.c8':
    '保存成功',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.NewHealthFileForm.index.c9':
    '表单验证未通过，请检查后重试',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.NewHealthFileForm.index.c10':
    '生活习惯',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.NewHealthFileForm.index.c11':
    '病史记录',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.NewHealthFileForm.index.c12':
    '既往史',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.NewHealthFileForm.index.c13':
    '疾病名称',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.NewHealthFileForm.index.c14':
    '从疾病库选择或输入',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.NewHealthFileForm.index.c15':
    '确诊日期',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.NewHealthFileForm.index.c16':
    '增加一条',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.NewHealthFileForm.index.c17':
    '家族史',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.NewHealthFileForm.index.c18':
    '亲属',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.NewHealthFileForm.index.c19':
    '疾病名称',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.NewHealthFileForm.index.c20':
    '从疾病库选择或输入',
  'src.pages.Customer.CustomerDetail.components.ProfileCard.components.NewHealthFileForm.index.c21':
    '增加一条',
  'src.pages.Customer.CustomerDetail.components.PunchDetailModal.index.c1':
    '详细信息',
  'src.pages.Customer.CustomerDetail.components.PunchDetailModal.index.c2':
    '返回',
  'src.pages.Customer.CustomerDetail.components.PunchDetailModal.index.c3':
    '用户备注',
  'src.pages.Customer.CustomerDetail.components.PunchDetailModal.index.c4':
    '图片',
  'src.pages.Customer.CustomerDetail.components.RelativeCard.index.c1': '她的',
  'src.pages.Customer.CustomerDetail.components.RelativeCard.index.c2': '他的',
  'src.pages.Customer.CustomerDetail.components.RelativeCard.index.c3': '亲友',
  'src.pages.Customer.CustomerDetail.components.RelativeCard.index.c4':
    '未知姓名',
  'src.pages.Customer.CustomerDetail.components.RelativeCard.index.c5': '无',
  'src/pages/Customer/CustomerDetail/components/RelativeCard/components/BindRelativeModal/index.c1':
    '绑定成功',
  'src/pages/Customer/CustomerDetail/components/RelativeCard/components/BindRelativeModal/index.c2':
    '未查到用户',
  'src/pages/Customer/CustomerDetail/components/RelativeCard/components/BindRelativeModal/index.c3':
    '绑定亲友',
  'src/pages/Customer/CustomerDetail/components/RelativeCard/components/BindRelativeModal/index.c4':
    '绑定',
  'src/pages/Customer/CustomerDetail/components/RelativeCard/components/BindRelativeModal/index.c5':
    '绑定给客户',
  'src/pages/Customer/CustomerDetail/components/RelativeCard/components/BindRelativeModal/index.c6':
    '亲友账号',
  'src/pages/Customer/CustomerDetail/components/RelativeCard/components/BindRelativeModal/index.c7':
    '年龄',
  'src/pages/Customer/CustomerDetail/components/RelativeCard/components/BindRelativeModal/index.c8':
    '请选择亲属关系',
  'src/pages/Customer/CustomerDetail/components/RelativeCard/components/BindRelativeModal/index.c9':
    '亲属关系',
  'src/pages/Customer/CustomerDetail/components/RelativeCard/components/BindRelativeModal/index.c10':
    '输入搜索的账号',

  'src.pages.Customer.CustomerDetail.components.ServiceBoardCard.index.c1':
    '查看全部',
  'src.pages.Customer.CustomerDetail.components.ServiceBoardCard.index.c2':
    '服务看板',
  'src.pages.Customer.CustomerDetail.components.ServiceBoardCard.index.c3':
    '服务概述',
  'src.pages.Customer.CustomerDetail.components.ServiceBoardCard.index.c4':
    '编辑',
  'src.pages.Customer.CustomerDetail.components.ServiceBoardCard.index.c5':
    '无',
  'src.pages.Customer.CustomerDetail.components.ServiceBoardCard.index.c6':
    '健管动态',
  'src.pages.Customer.CustomerDetail.components.ServiceBoardCard.index.c7':
    '客户动态',
  'src.pages.Customer.CustomerDetail.components.ServiceBoardCard.index.c8':
    '周',
  'src.pages.Customer.CustomerDetail.components.ServiceBoardCard.index.c9':
    '月',
  'src.pages.Customer.CustomerDetail.components.ServiceBoardCard.index.c10':
    '待处理',
  'src.pages.Customer.CustomerDetail.components.ServiceBoardCard.index.c11':
    '处理中',
  'src.pages.Customer.CustomerDetail.components.ServiceBoardCard.index.c12':
    '已完成',
  'src.pages.Customer.CustomerDetail.components.ServiceBoardCard.index.c13':
    '已关闭',
  'src.pages.Customer.CustomerDetail.components.ServiceBoardCard.index.c14':
    '健康习惯打卡',
  'src.pages.Customer.CustomerDetail.components.ServiceBoardCard.index.c15':
    '干预方案打卡',
  'src.pages.Customer.CustomerDetail.components.ServiceBoardCard.index.c16':
    '健康评估',
  'src.pages.Customer.CustomerDetail.components.ServiceBoardCard.index.c17':
    '日期',
  'src.pages.Customer.CustomerDetail.components.ServiceBoardCard.index.c18':
    '任务名称',
  'src.pages.Customer.CustomerDetail.components.ServiceBoardCard.index.c19':
    '状态',
  'src.pages.Customer.CustomerDetail.components.ServiceBoardCard.index.c20':
    '操作',
  'src.pages.Customer.CustomerDetail.components.ServiceBoardCard.index.c21':
    '详情',
  'src.pages.Customer.CustomerDetail.components.ServiceBoardCard.index.c22':
    '去处理',
  'src.pages.Customer.CustomerDetail.components.ServiceBoardCard.index.c23':
    '类型',
  'src.pages.Customer.CustomerDetail.components.ServiceConfigCard.index.c1':
    '服务配置',
  'src.pages.Customer.CustomerDetail.components.ServiceConfigCard.index.c2':
    '配置',
  'src.pages.Customer.CustomerDetail.components.ServiceConfigCard.index.c3':
    '套餐',
  'src.pages.Customer.CustomerDetail.components.ServiceConfigCard.index.c4':
    '团队',
  'src.pages.Customer.CustomerDetail.components.ServiceTask.index.c1':
    '确认关闭该任务？',
  'src.pages.Customer.CustomerDetail.components.ServiceTask.index.c2':
    '给任务处理弹出页使用，点击“提交”，”保存“时刷新这个页面',
  'src.pages.Customer.CustomerDetail.components.ServiceTask.index.c3':
    '服务任务',
  'src.pages.Customer.CustomerDetail.components.ServiceTask.index.c5':
    '任务详情',
  'src.pages.Customer.CustomerDetail.components.ServiceTask.index.c7': '待处理',
  'src.pages.Customer.CustomerDetail.components.ServiceTask.index.c8': '处理中',
  'src.pages.Customer.CustomerDetail.components.ServiceTask.index.c9': '已完成',
  'src.pages.Customer.CustomerDetail.components.ServiceTask.index.c10':
    '已关闭',
  'src.pages.Customer.CustomerDetail.components.ServiceTask.index.c11':
    '确认开始处理',
  'src.pages.Customer.CustomerDetail.components.ServiceTask.index.c12':
    '您确认开始处理该任务吗？',
  'src.pages.Customer.CustomerDetail.components.ServiceTask.index.c13':
    '关闭成功',
  'src.pages.Customer.CustomerDetail.components.ServiceTask.index.c14':
    '关闭失败，请稍后重试',
  'src.pages.Customer.CustomerDetail.components.ServiceTask.index.c15': '处理',
  'src.pages.Customer.CustomerDetail.components.ServiceTask.index.c16': '关闭',
  'src.pages.Customer.CustomerDetail.components.ServiceTask.index.c17':
    '计划时间',
  'src.pages.Customer.CustomerDetail.components.ServiceTask.index.c18':
    '执行时间',
  'src.pages.Customer.CustomerDetail.components.ServiceTask.index.c19':
    '执行时间',
  'src.pages.Customer.CustomerDetail.components.ServiceTask.index.c20':
    '关闭时间',
  'src.pages.Customer.CustomerDetail.components.ServiceTask.index.c21':
    '待结束',
  'src.pages.Customer.CustomerDetail.components.ServiceTask.index.c22':
    '服务项目',
  'src.pages.Customer.CustomerDetail.components.ServiceTask.index.c23':
    '执行者',
  'src.pages.Customer.CustomerDetail.components.ServiceTask.index.c24': '操作',
  'src.pages.Customer.CustomerDetail.components.ServiceTask.index.c25': '详情',
  'src.pages.Customer.CustomerDetail.components.ServiceTask.index.c26':
    '共{total}条记录',
  'src.pages.Customer.CustomerDetail.components.ServiceTask.index.c27':
    '创建任务',
  'src.pages.Customer.CustomerDetail.index.c1': '客户详情 - ',
  'src.pages.Customer.CustomerPackage.components.Appointment.index.c1':
    '编辑服务次数',
  'src.pages.Customer.CustomerPackage.components.Appointment.index.c2':
    '服务项目',
  'src.pages.Customer.CustomerPackage.components.Appointment.index.c3':
    '服务类型',
  'src.pages.Customer.CustomerPackage.components.Appointment.index.c4':
    '服务条件',
  'src.pages.Customer.CustomerPackage.components.Appointment.index.c5':
    '服务次数',
  'src.pages.Customer.CustomerPackage.components.Appointment.index.c8': '序号',
  'src.pages.Customer.CustomerPackage.components.Appointment.index.c9':
    '服务项目',
  'src.pages.Customer.CustomerPackage.components.Appointment.index.c10':
    '服务类型',
  'src.pages.Customer.CustomerPackage.components.Appointment.index.c11':
    '服务条件',
  'src.pages.Customer.CustomerPackage.components.Appointment.index.c12':
    '服务次数',
  'src.pages.Customer.CustomerPackage.components.Appointment.index.c13': '次',
  'src.pages.Customer.CustomerPackage.components.Appointment.index.c14':
    '剩余次数',
  'src.pages.Customer.CustomerPackage.components.Appointment.index.c15':
    '可用状态',
  'src.pages.Customer.CustomerPackage.components.Appointment.index.c16': '操作',
  'src.pages.Customer.CustomerPackage.components.Appointment.index.c17':
    '请确认是否关闭客户的该服务项目?',
  'src.pages.Customer.CustomerPackage.components.Appointment.index.c18': '关闭',
  'src.pages.Customer.CustomerPackage.components.Appointment.index.c19':
    '请确认是否开启客户的该服务项目?',
  'src.pages.Customer.CustomerPackage.components.Appointment.index.c20': '开启',
  'src.pages.Customer.CustomerPackage.components.Appointment.index.c21':
    '专项服务',
  'src.pages.Customer.CustomerPackage.components.Appointment.index.c22':
    '修改成功',
  'src.pages.Customer.CustomerPackage.components.Appointment.index.c23':
    '修改失败，请稍后重试',
  'src.pages.Customer.CustomerPackage.components.Appointment.index.c24':
    '请输入服务次数',
  'src.pages.Customer.CustomerPackage.components.Appointment.index.c25':
    '注：当前已使用{num}次，服务次数不能低于使用次数',
  'src.pages.Customer.CustomerPackage.components.CustomerPackageBoard.index.c1':
    '开启',
  'src.pages.Customer.CustomerPackage.components.CustomerPackageBoard.index.c2':
    '关闭',
  'src.pages.Customer.CustomerPackage.components.CustomerPackageBoard.index.c3':
    '成功',
  'src.pages.Customer.CustomerPackage.components.CustomerPackageBoard.index.c4':
    '失败，请稍后重试',
  'src.pages.Customer.CustomerPackage.components.Intelligent.index.c1':
    '编辑服务频率',
  'src.pages.Customer.CustomerPackage.components.Intelligent.index.c2':
    '服务项目',
  'src.pages.Customer.CustomerPackage.components.Intelligent.index.c3':
    '服务类型',
  'src.pages.Customer.CustomerPackage.components.Intelligent.index.c4':
    '服务条件',
  'src.pages.Customer.CustomerPackage.components.Intelligent.index.c5':
    '服务频率',
  'src.pages.Customer.CustomerPackage.components.Intelligent.index.c13': '号',
  'src.pages.Customer.CustomerPackage.components.Intelligent.index.c14': '序号',
  'src.pages.Customer.CustomerPackage.components.Intelligent.index.c15':
    '服务项目',
  'src.pages.Customer.CustomerPackage.components.Intelligent.index.c16':
    '服务类型',
  'src.pages.Customer.CustomerPackage.components.Intelligent.index.c17':
    '服务条件',
  'src.pages.Customer.CustomerPackage.components.Intelligent.index.c18':
    '服务频率',
  'src.pages.Customer.CustomerPackage.components.Intelligent.index.c19':
    '可用状态',
  'src.pages.Customer.CustomerPackage.components.Intelligent.index.c20': '操作',
  'src.pages.Customer.CustomerPackage.components.Intelligent.index.c21':
    '请确认是否关闭客户的该服务项目?',
  'src.pages.Customer.CustomerPackage.components.Intelligent.index.c22': '关闭',
  'src.pages.Customer.CustomerPackage.components.Intelligent.index.c23':
    '请确认是否开启客户的该服务项目?',
  'src.pages.Customer.CustomerPackage.components.Intelligent.index.c24': '开启',
  'src.pages.Customer.CustomerPackage.components.Intelligent.index.c25':
    '智能服务',
  'src.pages.Customer.CustomerPackage.components.Intelligent.index.c26': '天',
  'src.pages.Customer.CustomerPackage.components.Intelligent.index.c27': '周',
  'src.pages.Customer.CustomerPackage.components.Intelligent.index.c28': '月',
  'src.pages.Customer.CustomerPackage.components.Intelligent.index.c29':
    '修改成功',
  'src.pages.Customer.CustomerPackage.components.Intelligent.index.c30':
    '修改失败，请稍后重试',
  'src.pages.Customer.CustomerPackage.components.Intelligent.index.c31':
    '请选择服务频率',
  'src.pages.Customer.CustomerPackage.components.Intelligent.index.c32': '每',
  'src.pages.Customer.CustomerPackage.components.Periodical.index.c1': '序号',
  'src.pages.Customer.CustomerPackage.components.Periodical.index.c2':
    '第{num}次',
  'src.pages.Customer.CustomerPackage.components.Periodical.index.c3':
    '服务项目',
  'src.pages.Customer.CustomerPackage.components.Periodical.index.c4':
    '服务类型',
  'src.pages.Customer.CustomerPackage.components.Periodical.index.c5':
    '服务条件',
  'src.pages.Customer.CustomerPackage.components.Periodical.index.c6':
    '服务时间',
  'src.pages.Customer.CustomerPackage.components.Periodical.index.c7':
    '任务状态',
  'src.pages.Customer.CustomerPackage.components.Periodical.index.c8':
    '定期干预',
  'src.pages.Customer.CustomerPackage.components.Periodical.index.c9': '待处理',
  'src.pages.Customer.CustomerPackage.components.Periodical.index.c10':
    '处理中',
  'src.pages.Customer.CustomerPackage.components.Periodical.index.c11':
    '已完成',
  'src.pages.Customer.CustomerPackage.components.Periodical.index.c12':
    '已关闭',
  'src.pages.Customer.CustomerPackage.components.Results.index.c1': '序号',
  'src.pages.Customer.CustomerPackage.components.Results.index.c2': '服务项目',
  'src.pages.Customer.CustomerPackage.components.Results.index.c3': '服务类型',
  'src.pages.Customer.CustomerPackage.components.Results.index.c4': '服务条件',
  'src.pages.Customer.CustomerPackage.components.Results.index.c5': '可用状态',
  'src.pages.Customer.CustomerPackage.components.Results.index.c6': '操作',
  'src.pages.Customer.CustomerPackage.components.Results.index.c7':
    '请确认是否关闭客户的该服务项目?',
  'src.pages.Customer.CustomerPackage.components.Results.index.c8': '关闭',
  'src.pages.Customer.CustomerPackage.components.Results.index.c9':
    '请确认是否开启客户的该服务项目?',
  'src.pages.Customer.CustomerPackage.components.Results.index.c10': '开启',
  'src.pages.Customer.CustomerPackage.components.Results.index.c11': '结果干预',
  'src.pages.Customer.CustomerPackage.components.Results.index.c12': '结果触发',
  'src.pages.Customer.CustomerPackage.components.Results.index.c13': '系统自发',
  'src.pages.Customer.CustomerPackage.components.Results.index.c14': '人工触发',
  'src.pages.Customer.CustomerPackage.components.Results.index.c15': '主动服务',
  'src.pages.Customer.CustomerPackage.components.Results.index.c16': '服务预约',
  'src.pages.Customer.CustomerPackage.components.Results.index.c17': '正常',
  'src.pages.Customer.CustomerPackage.components.Results.index.c18': '关闭',
  'src.pages.Customer.CustomerPackage.index.c1': '是否终止当前套餐？',
  'src.pages.Customer.CustomerPackage.index.c2': '服务套餐配置',
  'src.pages.Customer.CustomerPackage.index.c3': '确认',
  'src.pages.Customer.CustomerPackage.index.c4': '服务套餐配置',
  'src.pages.Customer.CustomerPackage.index.c5': '取消',
  'src.pages.Customer.CustomerPackage.index.c6': '服务套餐配置',
  'src.pages.Customer.CustomerPackage.index.c7': '请求失败，请稍后重试',
  'src.pages.Customer.CustomerPackage.index.c8': '终止成功',
  'src.pages.Customer.CustomerPackage.index.c9': '终止套餐失败，请稍后重试',
  'src.pages.Customer.CustomerPackage.index.c10': '负责人',
  'src.pages.Customer.CustomerPackage.index.c11': '有效期',
  'src.pages.Customer.CustomerPackage.index.c12': '截止至',
  'src.pages.Customer.CustomerPackage.index.c13': '终止套餐',
  'src.pages.Customer.CustomerPackage.index.c14': '服务团队',
  'src.pages.Customer.CustomerPackage.index.c15': '无',
  'src.pages.Customer.CustomerPackage.index.c16': '更换团队',
  'src.pages.Customer.CustomerPackage.index.c17': '服务套餐',
  'src.pages.Customer.CustomerPackage.index.c18': '使用中',
  'src.pages.Customer.CustomerPackage.index.c19': '已失效',
  'src.pages.Customer.CustomerPackage.index.c20': '添加套餐',
  'src.pages.Customer.CustomerPackage.index.c21': '正常',
  'src.pages.Customer.CustomerPackage.index.c22': '即将过期',
  'src.pages.Customer.CustomerPackage.index.c23': '已过期',
  'src.pages.Customer.CustomerPackage.index.c24': '已取消',
  'src.pages.Customer.CustomerPackage.SignleBindPackageModal.index.c1':
    '绑定套餐',
  'src.pages.Customer.CustomerPackage.SignleBindPackageModal.index.c2':
    '服务套餐',
  'src.pages.Customer.CustomerPackage.SignleBindPackageModal.index.c3':
    '请选择客户',
  'src.pages.Customer.CustomerPackage.SignleBindPackageModal.index.c4':
    '客户暂无服务团队，请先绑定服务团队',
  'src.pages.Customer.CustomerPackage.SignleBindPackageModal.index.c5':
    '绑定成功',
  'src.pages.Customer.CustomerPackage.SignleBindPackageModal.index.c6':
    '请求失败，请稍后重试',
  'src.pages.Customer.CustomerPackage.SignleBindPackageModal.index.c7':
    '请选择服务套',
  'src.pages.Customer.LabelManage.components.AddLabelForm.c1': '标签名称',
  'src.pages.Customer.LabelManage.components.AddLabelForm.c3':
    '每次打开弹框的时候更新表单，避免 initialValue 不更新',
  'src.pages.Customer.LabelManage.components.AddLabelForm.c4': '简称',
  'src.pages.Customer.LabelManage.components.AddLabelForm.c7': '备注',
  'src.pages.Customer.LabelManage.components.AddLabelForm.c10': '状态',
  'src.pages.Customer.LabelManage.components.AddLabelForm.c13': '操作成功',
  'src.pages.Customer.LabelManage.components.AddLabelForm.c14':
    '操作失败，请稍后重试',
  'src.pages.Customer.LabelManage.components.AddLabelForm.c15': '编辑标签',
  'src.pages.Customer.LabelManage.components.AddLabelForm.c16': '新增标签',
  'src.pages.Customer.LabelManage.components.AddLabelForm.c17':
    '请输入标签名称',
  'src.pages.Customer.LabelManage.components.AddLabelForm.c18': '最大长度为50',
  'src.pages.Customer.LabelManage.components.AddLabelForm.c19': '请输入简称',
  'src.pages.Customer.LabelManage.components.AddLabelForm.c20': '最大长度为200',
  'src.pages.Customer.LabelManage.components.AddLabelForm.c21': '启用',
  'src.pages.Customer.LabelManage.components.AddLabelForm.c22': '关闭',
  'src.pages.Customer.LabelManage.components.AddLabelForm.c23': '请选择状态',
  'src.pages.Customer.LabelManage.components.AddLabelForm.c24':
    '请完整填写条件组',
  'src.pages.Customer.LabelManage.components.AddLabelForm.c25': '标签类型',
  'src.pages.Customer.LabelManage.components.AddLabelForm.c26': '人工标签',
  'src.pages.Customer.LabelManage.components.AddLabelForm.c27': '智能标签',
  'src.pages.Customer.LabelManage.components.AddLabelForm.c28':
    '请选择标签类型',
  'src.pages.Customer.LabelManage.components.AddLabelForm.c29': '条件组',
  'src.pages.Customer.LabelManage.components.AddLabelForm.c30': '添加条件组',
  'src.pages.Customer.LabelManage.components.AddLabelForm.c31':
    '请添加最少一个判断条件',
  'src.pages.Customer.LabelManage.components.EditableProTableGroup.c0': '包含',
  'src.pages.Customer.LabelManage.components.EditableProTableGroup.c1': '包含',
  'src.pages.Customer.LabelManage.components.EditableProTableGroup.c2': '数值',
  'src.pages.Customer.LabelManage.components.EditableProTableGroup.c3': '结论',
  'src.pages.Customer.LabelManage.components.EditableProTableGroup.c4':
    '判断条件',
  'src.pages.Customer.LabelManage.components.EditableProTableGroup.c5':
    '此项为必填项',
  'src.pages.Customer.LabelManage.components.EditableProTableGroup.c6':
    '取值方式',
  'src.pages.Customer.LabelManage.components.EditableProTableGroup.c7':
    '此项为必填项',
  'src.pages.Customer.LabelManage.components.EditableProTableGroup.c8':
    '取值条件',
  'src.pages.Customer.LabelManage.components.EditableProTableGroup.c9':
    '此项为必填项',
  'src.pages.Customer.LabelManage.components.EditableProTableGroup.c10':
    '取值设置',
  'src.pages.Customer.LabelManage.components.EditableProTableGroup.c11':
    '此项为必填项',
  'src.pages.Customer.LabelManage.components.EditableProTableGroup.c12':
    '组合关系',
  'src.pages.Customer.LabelManage.components.EditableProTableGroup.c13':
    '此项为必填项',
  'src.pages.Customer.LabelManage.components.EditableProTableGroup.c14': '并且',
  'src.pages.Customer.LabelManage.components.EditableProTableGroup.c15': '或者',
  'src.pages.Customer.LabelManage.components.EditableProTableGroup.c16': '操作',
  'src.pages.Customer.LabelManage.components.EditableProTableGroup.c17': '编辑',
  'src.pages.Customer.LabelManage.components.EditableProTableGroup.c18': '删除',
  'src.pages.Customer.LabelManage.components.EditableProTableGroup.c19':
    '删除此行？',
  'src.pages.Customer.LabelManage.components.EditableProTableGroup.c20':
    '添加一行数据',
  'src.pages.Customer.LabelManage.components.EditableProTableGroup.c21':
    '请选择',
  'src.pages.Customer.LabelManage.components.EditableProTableGroup.c22':
    '请输入',
  'src.pages.Customer.LabelManage.index.c1': '操作',
  'src.pages.Customer.LabelManage.index.c2': '开启关闭 PopConfirm',
  'src.pages.Customer.LabelManage.index.c3': '项',
  'src.pages.Customer.LabelManage.index.c4': '确认删除该标签？',
  'src.pages.Customer.LabelManage.index.c7': '确认批量开启选择的标签？',
  'src.pages.Customer.LabelManage.index.c16': '删除成功',
  'src.pages.Customer.LabelManage.index.c17': '启用',
  'src.pages.Customer.LabelManage.index.c18': '关闭',
  'src.pages.Customer.LabelManage.index.c19': '成功',
  'src.pages.Customer.LabelManage.index.c20': '确认要{targetText}该标签？',
  'src.pages.Customer.LabelManage.index.c21': '标签ID',
  'src.pages.Customer.LabelManage.index.c22': '标签名称',
  'src.pages.Customer.LabelManage.index.c23': '简称',
  'src.pages.Customer.LabelManage.index.c24': '备注',
  'src.pages.Customer.LabelManage.index.c25': '可用状态',
  'src.pages.Customer.LabelManage.index.c26': '最近更新时间',
  'src.pages.Customer.LabelManage.index.c27': '编辑',
  'src.pages.Customer.LabelManage.index.c28': '已选',
  'src.pages.Customer.LabelManage.index.c29': '批量启用',
  'src.pages.Customer.LabelManage.index.c30': '批量关闭',
  'src.pages.Customer.LabelManage.index.c31': '新增标签',
  'src.pages.Customer.LabelManage.index.c32': '客户标签',
  'src.pages.Customer.LabelManage.index.c33': '设备标签',
  'src.pages.Customer.LabelManage.index.c34': '智能标签',
  'src.pages.Customer.LabelManage.index.c35': '是',
  'src.pages.Customer.LabelManage.index.c36': '否',
  'src.pages.Customer.LevelManage.components.AddLevelForm.c1': '等级名称',
  'src.pages.Customer.LevelManage.components.AddLevelForm.c2':
    '根据类型调用新增或编辑接口',
  'src.pages.Customer.LevelManage.components.AddLevelForm.c3':
    '组件会自动给 values 注入 iconTempFile',
  'src.pages.Customer.LevelManage.components.AddLevelForm.c4': '图标',
  'src.pages.Customer.LevelManage.components.AddLevelForm.c5': '背景',
  'src.pages.Customer.LevelManage.components.AddLevelForm.c6': '文字颜色',
  'src.pages.Customer.LevelManage.components.AddLevelForm.c7':
    '每次打开弹框的时候更新表单，避免 initialValue 不更新',
  'src.pages.Customer.LevelManage.components.AddLevelForm.c8': '选择系统图片',
  'src.pages.Customer.LevelManage.components.AddLevelForm.c9': '排序',
  'src.pages.Customer.LevelManage.components.AddLevelForm.c17': '备注',
  'src.pages.Customer.LevelManage.components.AddLevelForm.c25': '等级图标',
  'src.pages.Customer.LevelManage.components.AddLevelForm.c33': '会员卡背景',
  'src.pages.Customer.LevelManage.components.AddLevelForm.c41':
    '会员卡文字颜色',
  'src.pages.Customer.LevelManage.components.AddLevelForm.c49': '状态',
  'src.pages.Customer.LevelManage.components.AddLevelForm.c57': '操作成功',
  'src.pages.Customer.LevelManage.components.AddLevelForm.c58':
    '操作失败，请稍后重试',
  'src.pages.Customer.LevelManage.components.AddLevelForm.c59': '编辑等级',
  'src.pages.Customer.LevelManage.components.AddLevelForm.c60': '新增等级',
  'src.pages.Customer.LevelManage.components.AddLevelForm.c61':
    '请输入等级名称',
  'src.pages.Customer.LevelManage.components.AddLevelForm.c62': '最大长度为50',
  'src.pages.Customer.LevelManage.components.AddLevelForm.c63': '请输入排序',
  'src.pages.Customer.LevelManage.components.AddLevelForm.c64': '最大长度为200',
  'src.pages.Customer.LevelManage.components.AddLevelForm.c65':
    '请选择等级图标',
  'src.pages.Customer.LevelManage.components.AddLevelForm.c66': '从本地上传',
  'src.pages.Customer.LevelManage.components.AddLevelForm.c67': '选择系统图片',
  'src.pages.Customer.LevelManage.components.AddLevelForm.c68': '启用',
  'src.pages.Customer.LevelManage.components.AddLevelForm.c69': '关闭',
  'src.pages.Customer.LevelManage.components.AddLevelForm.c70': '请选择状态',
  'src.pages.Customer.LevelManage.index.c1': '等级图标',
  'src.pages.Customer.LevelManage.index.c2': '开启关闭 PopConfirm',
  'src.pages.Customer.LevelManage.index.c3': '项',
  'src.pages.Customer.LevelManage.index.c4': '操作',
  'src.pages.Customer.LevelManage.index.c7': '确认删除该等级？',
  'src.pages.Customer.LevelManage.index.c10': '确认批量开启选择的等级？',
  'src.pages.Customer.LevelManage.index.c13': '确认批量关闭选择的等级？',
  'src.pages.Customer.LevelManage.index.c16': '确认批量删除选择的等级？',
  'src.pages.Customer.LevelManage.index.c19': '删除成功',
  'src.pages.Customer.LevelManage.index.c20': '启用',
  'src.pages.Customer.LevelManage.index.c21': '关闭',
  'src.pages.Customer.LevelManage.index.c22': '成功',
  'src.pages.Customer.LevelManage.index.c23': '确认要{targetText}该标签？',
  'src.pages.Customer.LevelManage.index.c24': '等级ID',
  'src.pages.Customer.LevelManage.index.c25': '等级名称',
  'src.pages.Customer.LevelManage.index.c26': '图标',
  'src.pages.Customer.LevelManage.index.c27': '排序',
  'src.pages.Customer.LevelManage.index.c28': '备注',
  'src.pages.Customer.LevelManage.index.c29': '可用状态',
  'src.pages.Customer.LevelManage.index.c30': '最近更新时间',
  'src.pages.Customer.LevelManage.index.c31': '使用人数',
  'src.pages.Customer.LevelManage.index.c32': '编辑',
  'src.pages.Customer.LevelManage.index.c33': '删除',
  'src.pages.Customer.LevelManage.index.c34': '已选',
  'src.pages.Customer.LevelManage.index.c35': '新增等级',
  'src.pages.Customer.LevelManage.index.c36': '批量启用',
  'src.pages.Customer.LevelManage.index.c37': '批量关闭',
  'src.pages.Customer.LevelManage.index.c38': '批量删除',
  'src.pages.Customer.MessageBoard.index.c1': '姓名',
  'src.pages.Customer.MessageBoard.index.c2': '联系方式',
  'src.pages.Customer.MessageBoard.index.c3': '留言内容',
  'src.pages.Customer.MessageBoard.index.c4': '留言时间',
  'src.pages.Customer.MyCustomer.components.AddAddressModal.index.c1': '收货人',
  'src.pages.Customer.MyCustomer.components.AddAddressModal.index.c2': '编辑',
  'src.pages.Customer.MyCustomer.components.AddAddressModal.index.c3':
    '手机号码',
  'src.pages.Customer.MyCustomer.components.AddAddressModal.index.c4': '编辑',
  'src.pages.Customer.MyCustomer.components.AddAddressModal.index.c5': '现住址',
  'src.pages.Customer.MyCustomer.components.AddAddressModal.index.c6': '编辑',
  'src.pages.Customer.MyCustomer.components.AddAddressModal.index.c7':
    '详细地址',
  'src.pages.Customer.MyCustomer.components.AddAddressModal.index.c8': '编辑',
  'src.pages.Customer.MyCustomer.components.AddAddressModal.index.c9':
    '设为默认地址',
  'src.pages.Customer.MyCustomer.components.AddAddressModal.index.c10': '编辑',
  'src.pages.Customer.MyCustomer.components.AddAddressModal.index.c11':
    '{action}地址',
  'src.pages.Customer.MyCustomer.components.AddAddressModal.index.c12':
    '{action}成功',
  'src.pages.Customer.MyCustomer.components.AddAddressModal.index.c13':
    '{action}失败，请稍后重试',
  'src.pages.Customer.MyCustomer.components.AddAddressModal.index.c14':
    '请输入收货人',
  'src.pages.Customer.MyCustomer.components.AddAddressModal.index.c15':
    '请输入手机号码',
  'src.pages.Customer.MyCustomer.components.AddAddressModal.index.c16':
    '请选择住址',
  'src.pages.Customer.MyCustomer.components.AddAddressModal.index.c17':
    '请输入详细地址',
  'src.pages.Customer.MyCustomer.components.BindLevelModal.index.c1':
    '绑定会员等级',
  'src.pages.Customer.MyCustomer.components.BindLevelModal.index.c2':
    '会员等级',
  'src.pages.Customer.MyCustomer.components.BindLevelModal.index.c3':
    '请选择客户',
  'src.pages.Customer.MyCustomer.components.BindLevelModal.index.c4':
    '绑定成功',
  'src.pages.Customer.MyCustomer.components.BindLevelModal.index.c5':
    '绑定失败，请稍后重试',
  'src.pages.Customer.MyCustomer.components.BindLevelModal.index.c6':
    '请选择会员等级',
  'src.pages.Customer.MyCustomer.components.BindPackageModal.index.c1':
    '绑定套餐',
  'src.pages.Customer.MyCustomer.components.BindPackageModal.index.c2':
    '服务套餐',
  'src.pages.Customer.MyCustomer.components.BindPackageModal.index.c3':
    '服务团队',
  'src.pages.Customer.MyCustomer.components.BindPackageModal.index.c4':
    '会员等级',
  'src.pages.Customer.MyCustomer.components.BindPackageModal.index.c5':
    '请选择客户',
  'src.pages.Customer.MyCustomer.components.BindPackageModal.index.c6':
    '绑定成功',
  'src.pages.Customer.MyCustomer.components.BindPackageModal.index.c7':
    '绑定失败，请稍后重试',
  'src.pages.Customer.MyCustomer.components.BindPackageModal.index.c8':
    '请选择服务套餐',
  'src.pages.Customer.MyCustomer.components.BindPackageModal.index.c9':
    '请选择服务团队',
  'src.pages.Customer.MyCustomer.components.BatchCreateModal.t0': '导入客户',
  'src.pages.Customer.MyCustomer.components.BatchCreateModal.t1':
    '请先选择文件',
  'src.pages.Customer.MyCustomer.components.BatchCreateModal.t2':
    '点击或将文件拖拽到这里上传，仅支持单个excel文件上传。',
  'src.pages.Customer.MyCustomer.components.BatchCreateModal.t3':
    '下载导入模板',
  'src.pages.Customer.MyCustomer.components.BatchCreateModal.t4':
    '已成功导入{total}条，失败{errNum}条',
  'src.pages.Customer.MyCustomer.components.BatchCreateModal.t5': '失败原因',
  'src.pages.Customer.MyCustomer.components.BatchCreateModal.t6':
    '第{errorRow}行：',
  'src.pages.Customer.MyCustomer.components.BatchCreateModal.t7': '本次共创建 ',
  'src.pages.Customer.MyCustomer.components.BatchCreateModal.t8':
    ' 人，创建失败 ',
  'src.pages.Customer.MyCustomer.components.BatchCreateModal.t9': ' 人。',
  'src.pages.Customer.MyCustomer.index.c1': '请选择',
  'src.pages.Customer.MyCustomer.index.c2':
    '显示的套餐按以下条件筛选进行显示：',
  'src.pages.Customer.MyCustomer.index.c3': '筛选正常套餐',
  'src.pages.Customer.MyCustomer.index.c4': '最近到期的一个套餐',
  'src.pages.Customer.MyCustomer.index.c5': '这里将多选的 array 处理成 string',
  'src.pages.Customer.MyCustomer.index.c6': '排序处理',
  'src.pages.Customer.MyCustomer.index.c7':
    '被选中项的 customerPackages 中是否有使用中的套餐',
  'src.pages.Customer.MyCustomer.index.c8': '项',
  'src.pages.Customer.MyCustomer.index.c9': '操作',
  'src.pages.Customer.MyCustomer.index.c17': '绑定团队',
  'src.pages.Customer.MyCustomer.index.c25': '客户信息',
  'src.pages.Customer.MyCustomer.index.c26': '请输入姓名、手机号、身份证',
  'src.pages.Customer.MyCustomer.index.c27': '岁',
  'src.pages.Customer.MyCustomer.index.c28': '客户等级',
  'src.pages.Customer.MyCustomer.index.c29': '客户标签',
  'src.pages.Customer.MyCustomer.index.c30': '服务套餐',
  'src.pages.Customer.MyCustomer.index.c31': '服务状态',
  'src.pages.Customer.MyCustomer.index.c32': '所属部门',
  'src.pages.Customer.MyCustomer.index.c33': '服务团队',
  'src.pages.Customer.MyCustomer.index.c34': '推荐人',
  'src.pages.Customer.MyCustomer.index.c35': '关联客户端',
  'src.pages.Customer.MyCustomer.index.c36': '建档日期',
  'src.pages.Customer.MyCustomer.index.c37': '最近服务',
  'src.pages.Customer.MyCustomer.index.c38': '详情',
  'src.pages.Customer.MyCustomer.index.c39': '创建任务',
  'src.pages.Customer.MyCustomer.index.c40': '创建客户',
  'src.pages.Customer.MyCustomer.index.c41': '已选',
  'src.pages.Customer.MyCustomer.index.c42': '设置客户等级',
  'src.pages.Customer.MyCustomer.index.c43': '绑定团队',
  'src.pages.Customer.MyCustomer.index.c44': '绑定套餐',
  'src.pages.Customer.MyCustomer.index.c45':
    '填写客户相关信息，为客户建档，绑定服务团队即为服务客户',
  'src.pages.Customer.MyCustomer.index.c46': '点击',
  'src.pages.Customer.MyCustomer.index.c47': '第1步，共3步',
  'src.pages.Customer.MyCustomer.index.c48': '为该客户创建专属服务项目',
  'src.pages.Customer.MyCustomer.index.c49': '点击',
  'src.pages.Customer.MyCustomer.index.c50': '第2步，共3步',
  'src.pages.Customer.MyCustomer.index.c51':
    '点击查看客户详情，了解客户个人情况',
  'src.pages.Customer.MyCustomer.index.c52': '点击',
  'src.pages.Customer.MyCustomer.index.c53': '第3步，共3步',
  'src.pages.Customer.MyCustomer.index.c54': '最近体检',
  'src.pages.Customer.MyCustomer.index.c55': '沟通',
  'src.pages.Customer.MyCustomer.index.c56': '团队',
  'src.pages.Customer.MyCustomer.index.c57': '中心',
  'src.pages.Customer.MyCustomer.index.c58': '姓名',
  'src.pages.Customer.MyCustomer.index.c59': '登录账号',
  'src.pages.Customer.MyCustomer.index.c60': '性别',
  'src.pages.Customer.MyCustomer.index.c61': '出生日期',
  'src.pages.Customer.MyCustomer.index.c62': '证件类型',
  'src.pages.Customer.MyCustomer.index.c63': '证件号码',
  'src.pages.Customer.MyCustomer.index.c64': '合并账号',
  'src.pages.Customer.MyCustomer.index.c65': '合并客户账号',
  'src.pages.Customer.MyCustomer.index.c66':
    '请选择保留账号， 其他账号将会做删除处理，但所属个人信息将会转移给选择保留的账号。',
  'src.pages.Customer.MyCustomer.index.c67': '删除账号',
  'src.pages.Customer.MyCustomer.index.c68': '删除客户账号',
  'src.pages.Customer.MyCustomer.index.c69':
    '请确认是否删除所选择的客户账号，继续操作将会清空账号所关联的全部个人信息。',
  'src.pages.Customer.MyCustomer.index.c70': '至少需要选择两个账号',
  'src.pages.Customer.MyCustomer.index.c71': '设置标签',

  'src.pages.Customer.OrgCustomer.index.c1': '请选择团队',
  'src.pages.Customer.OrgCustomer.index.c2': '这里将多选的 array 处理成 string',
  'src.pages.Customer.OrgCustomer.index.c3': '排序处理',
  'src.pages.Customer.OrgCustomer.index.c4':
    '被选中项的 customerPackages 中是否有使用中的套餐',
  'src.pages.Customer.OrgCustomer.index.c5': '项',
  'src.pages.Customer.OrgCustomer.index.c6': '操作',
  'src.pages.Customer.OrgCustomer.index.c11': '绑定团队',
  'src.pages.Customer.OrgCustomer.index.c16': '客户',
  'src.pages.Customer.OrgCustomer.index.c17': '请输入姓名、手机号、身份证',
  'src.pages.Customer.OrgCustomer.index.c18': '岁',
  'src.pages.Customer.OrgCustomer.index.c19': '客户等级',
  'src.pages.Customer.OrgCustomer.index.c20': '客户标签',
  'src.pages.Customer.OrgCustomer.index.c21': '服务套餐',
  'src.pages.Customer.OrgCustomer.index.c22': '服务状态',
  'src.pages.Customer.OrgCustomer.index.c23': '所属部门',
  'src.pages.Customer.OrgCustomer.index.c24': '服务团队',
  'src.pages.Customer.OrgCustomer.index.c25': '推荐人',
  'src.pages.Customer.OrgCustomer.index.c26': '关联平台',
  'src.pages.Customer.OrgCustomer.index.c27': '建档日期',
  'src.pages.Customer.OrgCustomer.index.c28': '最近回访',
  'src.pages.Customer.OrgCustomer.index.c29': '详情',
  'src.pages.Customer.OrgCustomer.index.c30': '创建任务',
  'src.pages.Customer.OrgCustomer.index.c31': '创建客户',
  'src.pages.Customer.OrgCustomer.index.c32': '已选',
  'src.pages.Customer.OrgCustomer.index.c33': '设置客户等级',
  'src.pages.Customer.OrgCustomer.index.c34': '绑定团队',
  'src.pages.Customer.OrgCustomer.index.c35': '绑定套餐',
  'src.pages.Customer.PersonalHealthReport.index.c1': '名称',
  'src.pages.Customer.PersonalHealthReport.index.c2': '报告模板',
  'src.pages.Customer.PersonalHealthReport.index.c3': '报告时间段',
  'src.pages.Customer.PersonalHealthReport.index.c4': '报告状态',
  'src.pages.Customer.PersonalHealthReport.index.c5': '生成时间',
  'src.pages.Customer.PersonalHealthReport.index.c6': '操作人',

  'src.pages.Customer.PublicCustomer.index.c1': '操作',
  'src.pages.Customer.PublicCustomer.index.c2':
    '这里将多选的 array 处理成 string',
  'src.pages.Customer.PublicCustomer.index.c3': '排序处理',
  'src.pages.Customer.PublicCustomer.index.c4': '项',
  'src.pages.Customer.PublicCustomer.index.c5': '绑定团队',
  'src.pages.Customer.PublicCustomer.index.c9': '提示',
  'src.pages.Customer.PublicCustomer.index.c10':
    '该客户缺少基本信息，是否跳转到详情页面编辑客户信息',
  'src.pages.Customer.PublicCustomer.index.c11': '跳转',
  'src.pages.Customer.PublicCustomer.index.c12':
    '所选客户中有客户缺少基本信息，请先完善客户基本信息',
  'src.pages.Customer.PublicCustomer.index.c13': '客户',
  'src.pages.Customer.PublicCustomer.index.c14': '请输入姓名、手机号、身份证',
  'src.pages.Customer.PublicCustomer.index.c15': '岁',
  'src.pages.Customer.PublicCustomer.index.c16': '登录手机号',
  'src.pages.Customer.PublicCustomer.index.c17': '客户等级',
  'src.pages.Customer.PublicCustomer.index.c18': '客户标签',
  'src.pages.Customer.PublicCustomer.index.c19': '推荐人',
  'src.pages.Customer.PublicCustomer.index.c20': '关联平台',
  'src.pages.Customer.PublicCustomer.index.c21': '建档日期',
  'src.pages.Customer.PublicCustomer.index.c22': '最近回访',
  'src.pages.Customer.PublicCustomer.index.c23': '详情',
  'src.pages.Customer.PublicCustomer.index.c24': '创建任务',
  'src.pages.Customer.PublicCustomer.index.c25': '创建客户',
  'src.pages.Customer.PublicCustomer.index.c26': '已选',
  'src.pages.Customer.PublicCustomer.index.c27': '设置客户等级',
  'src.pages.Customer.PublicCustomer.index.c28': '绑定团队',
  'src.pages.Customer.PublicCustomer.index.c29': '绑定套餐',
  'src.pages.Customer.ReportDetail.components.ConclusionCard.index.c1':
    '专家建议',
  'src.pages.Customer.ReportDetail.components.ConclusionCard.index.c2':
    '健康指导',
  'src.pages.Customer.ReportDetail.components.ConclusionCard.index.c3':
    '总检建议',
  'src.pages.Customer.ReportDetail.components.ConstrastBox.index.c1':
    '获取历年数据失败',
  'src.pages.Customer.ReportDetail.components.ConstrastBox.index.c2':
    '无历年数据',
  'src.pages.Customer.ReportDetail.components.ConstrastBox.index.c3': '本次',
  'src.pages.Customer.ReportDetail.components.ConstrastBox.index.c4':
    '正常范围',
  'src.pages.Customer.ReportDetail.components.DeptCard.index.c1': '科室小结',
  'src.pages.Customer.ReportDetail.components.DeptCard.index.c2': '图片',
  'src.pages.Customer.ReportDetail.components.DeptCard.index.c3': '检查描述',
  'src.pages.Customer.ReportDetail.components.DeptCard.index.c4': '结论',
  'src.pages.Customer.ReportDetail.components.DeptCard.index.c5': '正常范围',
  'src.pages.Customer.ReportDetail.components.DeptCard.index.c6': '历年对比',
  'src.pages.Customer.ReportDetail.index.c1': '岁',
  'src.pages.Customer.ReportDetail.index.c2': '体检日期',
  'src.pages.Customer.ReportDetail.index.c3': '总检结论',
  'src.pages.Customer.ReportDetail.index.c4': '正在生成',
  'src.pages.Customer.ReportDetail.index.c5': '生成成功',
  'src.pages.Customer.ReportDetail.index.c6': '生成失败',
  'src.pages.Customer.Satisfaction.components.SatisfactionQuestionnaire.index.c1':
    '细项评分',
  'src.pages.Customer.Satisfaction.components.SatisfactionQuestionnaire.index.c2':
    '评价描述',
  'src.pages.Customer.Satisfaction.components.SatisfactionQuestionnaireModal.index.c1':
    '查看评价',
  'src.pages.Customer.Satisfaction.components.SatisfactionQuestionnaireModal.index.c2':
    '关闭',
  'src.pages.Customer.Satisfaction.index.c1': '操作',
  'src.pages.Customer.Satisfaction.index.c2': '查看评价',
  'src.pages.Customer.Satisfaction.index.c3': '客户详情',
  'src.pages.Customer.Satisfaction.index.c4':
    '【说明】5分 - 非常满意、4分 - 满意、3分 - 一般、2分 - 不满意 、1分 - 非常不满意',
  'src.pages.Customer.Satisfaction.index.c5': '选择问卷',
  'src.pages.Customer.Satisfaction.index.c6': '问卷名称',
  'src.pages.Customer.Satisfaction.index.c7': '服务人员',
  'src.pages.Customer.Satisfaction.index.c8': '答卷客户',
  'src.pages.Customer.Satisfaction.index.c9': '评估时间',
  'src.pages.Customer.Satisfaction.index.c10': '来源',
  'src.pages.Customer.Satisfaction.index.c11': '整体满意度',
  'src.pages.Customer.Satisfaction.index.c12': '细项评价',
  'src.pages.Customer.Satisfaction.index.c13': '完成答卷',
  'src.pages.Customer.ServiceCustomer.index.c1': '我的客户',
  'src.pages.Customer.ServiceCustomer.index.c2': '部门客户',
  'src.pages.Customer.TeamManage.components.AddCodeModal.c1': '生成团队二维码',
  'src.pages.Customer.TeamManage.components.AddCodeModal.c2': '选择客户端',
  'src.pages.Customer.TeamManage.components.AddCodeModal.c3':
    '请求失败，请稍后重试',
  'src.pages.Customer.TeamManage.components.AddCodeModal.c4': '请选择客户端',
  'src.pages.Customer.TeamManage.components.AddCodeModal.c5': '选择扫码平台',
  'src.pages.Customer.TeamManage.components.AddCodeModal.c6': '请选择扫码平台',
  'src.pages.Customer.TeamManage.components.AddCodeModal.c7': '微信小程序',
  'src.pages.Customer.TeamManage.components.AddTeamModal.c1': '团队名称',
  'src.pages.Customer.TeamManage.components.AddTeamModal.c2':
    '获取下拉列表数据，用户详细数据',
  'src.pages.Customer.TeamManage.components.AddTeamModal.c3':
    '处理负责人id， 成员id，表格数据由这些 id 控制',
  'src.pages.Customer.TeamManage.components.AddTeamModal.c4': '处理表格数据',
  'src.pages.Customer.TeamManage.components.AddTeamModal.c5':
    '通过负责人和成员 id 和用户详细数据进行匹配，生成表格数据，并加上负责人tag标识',
  'src.pages.Customer.TeamManage.components.AddTeamModal.c6':
    '将成员和负责人进行去重',
  'src.pages.Customer.TeamManage.components.AddTeamModal.c7':
    '已经是负责人的不能加入成员中',
  'src.pages.Customer.TeamManage.components.AddTeamModal.c8':
    '负责人还需要去重，不能重复添加',
  'src.pages.Customer.TeamManage.components.AddTeamModal.c9': '确认添加',
  'src.pages.Customer.TeamManage.components.AddTeamModal.c10': '移除',
  'src.pages.Customer.TeamManage.components.AddTeamModal.c11': '团队负责人',
  'src.pages.Customer.TeamManage.components.AddTeamModal.c21': '添加成员',
  'src.pages.Customer.TeamManage.components.AddTeamModal.c31': '编辑团队',
  'src.pages.Customer.TeamManage.components.AddTeamModal.c32': '新增团队',
  'src.pages.Customer.TeamManage.components.AddTeamModal.c33': '编辑',
  'src.pages.Customer.TeamManage.components.AddTeamModal.c34': '新增',
  'src.pages.Customer.TeamManage.components.AddTeamModal.c35': '成功',
  'src.pages.Customer.TeamManage.components.AddTeamModal.c36':
    '操作失败，请稍后重试',
  'src.pages.Customer.TeamManage.components.AddTeamModal.c37': '请输入团队名称',
  'src.pages.Customer.TeamManage.components.AddTeamModal.c38':
    '请选择团队负责人',
  'src.pages.Customer.TeamManage.components.AddTeamModal.c39': '姓名',
  'src.pages.Customer.TeamManage.components.AddTeamModal.c40': '负责人',
  'src.pages.Customer.TeamManage.components.AddTeamModal.c41': '角色',
  'src.pages.Customer.TeamManage.components.AddTeamModal.c42': '部门',
  'src.pages.Customer.TeamManage.components.AddTeamModal.c43': '操作',
  'src.pages.Customer.TeamManage.components.SearchCodeModal.c1': '下载文件',
  'src.pages.Customer.TeamManage.components.SearchCodeModal.c2': '下载',
  'src.pages.Customer.TeamManage.components.SearchCodeModal.c3': '团队二维码',
  'src.pages.Customer.TeamManage.components.SearchCodeModal.c4': '返回',
  'src.pages.Customer.TeamManage.components.SearchCodeModal.c5': '确认',
  'src.pages.Customer.TeamManage.index.c1': '操作',
  'src.pages.Customer.TeamManage.index.c2': '开启关闭 PopConfirm',
  'src.pages.Customer.TeamManage.index.c3': '表单查询项，不在表格中显示',
  'src.pages.Customer.TeamManage.index.c4': '查看团队码',
  'src.pages.Customer.TeamManage.index.c5.1': '生成小程序团队码',
  'src.pages.Customer.TeamManage.index.c5.2': '生成App团队码',
  'src.pages.Customer.TeamManage.index.c5.3': '生成',
  'src.pages.Customer.TeamManage.index.c5.4': '团队码',
  'src.pages.Customer.TeamManage.index.c6': '隐藏删除按钮',
  'src.pages.Customer.TeamManage.index.c7': '项',
  'src.pages.Customer.TeamManage.index.c8': '确认删除该团队？',
  'src.pages.Customer.TeamManage.index.c15': '确认批量开启选择的团队？',
  'src.pages.Customer.TeamManage.index.c22': '确认批量关闭选择的团队？',
  'src.pages.Customer.TeamManage.index.c29': '确认批量删除选择的团队？',
  'src.pages.Customer.TeamManage.index.c36': '启用',
  'src.pages.Customer.TeamManage.index.c37': '关闭',
  'src.pages.Customer.TeamManage.index.c38': '成功',
  'src.pages.Customer.TeamManage.index.c39': '确认要{targetText}该团队？',
  'src.pages.Customer.TeamManage.index.c40': '团队名称',
  'src.pages.Customer.TeamManage.index.c41': '所在部门',
  'src.pages.Customer.TeamManage.index.c42': '负责人',
  'src.pages.Customer.TeamManage.index.c43': '员工姓名',
  'src.pages.Customer.TeamManage.index.c44': '团队成员',
  'src.pages.Customer.TeamManage.index.c45': '启用状态',
  'src.pages.Customer.TeamManage.index.c46': '服务人数',
  'src.pages.Customer.TeamManage.index.c47': '创建时间',
  'src.pages.Customer.TeamManage.index.c48': '编辑',
  'src.pages.Customer.TeamManage.index.c49': '新增团队',
  'src.pages.Customer.TeamManage.index.c50': '已选',
  'src.pages.Customer.TeamManage.index.c51': '批量启用',
  'src.pages.Customer.TeamManage.index.c52': '批量关闭',
  'src.pages.Customer.TeamManage.index.c53': '批量删除',
  'src.pages.Customer.TeamManage.index.c54': '启用',
  'src.pages.Customer.TeamManage.index.c55': '关闭',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Details.index.c1':
    '剩余{percent}%',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Details.index.c2':
    '设备号',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Details.index.c3':
    'SIM卡号',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Details.index.c4':
    '设备用途',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Details.index.c5':
    '绑定状态',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Details.index.c6':
    '未绑定',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Details.index.c7':
    '已绑定',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Details.index.c8':
    '检测状态',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Details.index.c9':
    '未检测',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Details.index.c10':
    '已检测',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Details.index.c11':
    '首次检测',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Details.index.c12':
    '当前设备使用者',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Details.index.c13':
    '更改',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Details.index.c14':
    '首次检测',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Details.index.c15':
    '检测次数',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Details.index.c16':
    '设备标签',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Details.index.c17':
    '暂无标签',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Details.index.c18':
    '管理套餐',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Details.index.c19':
    '服务套餐',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Details.index.c20':
    '服务团队',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Details.index.c21':
    '正常',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Details.index.c22':
    '注销',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Details.index.c23':
    '设备二维码',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Details.index.c24':
    '二维码',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Measurement.index.c1':
    '检测记录',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Measurement.index.c2':
    '设备动态',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Measurement.MeterLog.index.c1':
    '操作时间',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Measurement.MeterLog.index.c2':
    '类型',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Measurement.MeterLog.index.c3':
    '内容',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Measurement.MeterLog.index.c4':
    '操作人',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Measurement.MeterMeasurement.index.c1':
    '确定删除吗？',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Measurement.MeterMeasurement.index.c2':
    '时间差的秒数',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Measurement.MeterMeasurement.index.c3':
    '延迟',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Measurement.MeterMeasurement.index.c4':
    '修改',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Measurement.MeterMeasurement.index.c5':
    '认领',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Measurement.MeterMeasurement.index.c6':
    '删除',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Measurement.MeterMeasurement.index.c7':
    '表单搜索项会从 params 传入，传递给后端接口。',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Measurement.MeterMeasurement.index.c8':
    '确定',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Measurement.MeterMeasurement.index.c15':
    '取消',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Measurement.MeterMeasurement.index.c22':
    '删除成功',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Measurement.MeterMeasurement.index.c23':
    '请求出错',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Measurement.MeterMeasurement.index.c24':
    '按钮号',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Measurement.MeterMeasurement.index.c25':
    '使用者',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Measurement.MeterMeasurement.index.c26':
    '检测人',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Measurement.MeterMeasurement.index.c27':
    '测量id',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Measurement.MeterMeasurement.index.c28':
    '检测时间',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Measurement.MeterMeasurement.index.c29':
    '检测日期',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Measurement.MeterMeasurement.index.c30':
    '上传时间',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Measurement.MeterMeasurement.index.c31':
    '检测项目',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Measurement.MeterMeasurement.index.c32':
    '检测结果',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Measurement.MeterMeasurement.index.c33':
    '身高',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Measurement.MeterMeasurement.index.c34':
    '体重',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Measurement.MeterMeasurement.index.c35':
    '体脂率',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Measurement.MeterMeasurement.index.c36':
    '次/分',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Measurement.MeterMeasurement.index.c37':
    '备注',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Measurement.MeterMeasurement.index.c38':
    '操作',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Measurement.MeterMeasurement.UpdateModal.index.c1':
    '使用者',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Measurement.MeterMeasurement.UpdateModal.index.c2':
    '管理员选项',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Measurement.MeterMeasurement.UpdateModal.index.c3':
    '体脂秤备注',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Measurement.MeterMeasurement.UpdateModal.index.c4':
    '设备管理员',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Measurement.MeterMeasurement.UpdateModal.index.c5':
    '这里将默认人员填入',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Measurement.MeterMeasurement.UpdateModal.index.c6':
    '备注',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Measurement.MeterMeasurement.UpdateModal.index.c11':
    '检测时间',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Measurement.MeterMeasurement.UpdateModal.index.c16':
    '修改检测记录',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Measurement.MeterMeasurement.UpdateModal.index.c17':
    '认领检测记录',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Measurement.MeterMeasurement.UpdateModal.index.c18':
    '修改成功',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Measurement.MeterMeasurement.UpdateModal.index.c19':
    '认领成功',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Measurement.MeterMeasurement.UpdateModal.index.c20':
    '请求失败，请稍后重试',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Measurement.MeterMeasurement.UpdateModal.index.c21':
    '请选择使用者',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Measurement.MeterMeasurement.UpdateModal.index.c22':
    '未选中客户',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.Measurement.MeterMeasurement.UpdateModal.index.c23':
    '请先完善个人信息',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.AlarmLog.index.c1':
    '确定删除吗？',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.AlarmLog.index.c2':
    '查看地图',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.AlarmLog.index.c3':
    '表单搜索项会从 params 传入，传递给后端接口。',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.AlarmLog.index.c4':
    '确定',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.AlarmLog.index.c7':
    '取消',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.AlarmLog.index.c10':
    '告警类型',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.AlarmLog.index.c11':
    '姿态异常',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.AlarmLog.index.c12':
    '安全围栏',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.AlarmLog.index.c13':
    '使用者',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.AlarmLog.index.c14':
    '检测人',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.AlarmLog.index.c15':
    '告警时间',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.AlarmLog.index.c16':
    '定位日期',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.AlarmLog.index.c17':
    '城市',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.AlarmLog.index.c18':
    '位置',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.AlarmLog.index.c19':
    '操作',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.AlarmLog.index.c20':
    '删除成功',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.AlarmLog.index.c21':
    '删除',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.AlarmLog.index.c22':
    '腕表绑定电话',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.index.c1':
    '检测记录',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.index.c2':
    '活动轨迹',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.index.c3':
    '告警记录',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.index.c4':
    '设备动态',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.Map.index.c1':
    '查看地图',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.Map.index.c2':
    '返回',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.MeterMeasurement.index.c1':
    '确定删除吗？',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.MeterMeasurement.index.c2':
    '天  24*60*60*1000',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.MeterMeasurement.index.c3':
    '小时 60*60 总小时数-过去的小时数=现在的小时数',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.MeterMeasurement.index.c4':
    '分钟 -(day*24) 以60秒为一整份 取余 剩下秒数 秒数/60 就是分钟数',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.MeterMeasurement.index.c5':
    '以60秒为一整份 取余 剩下秒数',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.MeterMeasurement.index.c6':
    '删除',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.MeterMeasurement.index.c7':
    '表单搜索项会从 params 传入，传递给后端接口。',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.MeterMeasurement.index.c8':
    '确定',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.MeterMeasurement.index.c15':
    '取消',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.MeterMeasurement.index.c22':
    '小时',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.MeterMeasurement.index.c23':
    '分',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.MeterMeasurement.index.c24':
    '血压',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.MeterMeasurement.index.c25':
    '使用者',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.MeterMeasurement.index.c26':
    '检测人',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.MeterMeasurement.index.c27':
    '测量id',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.MeterMeasurement.index.c28':
    '检测时间',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.MeterMeasurement.index.c29':
    '检测日期',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.MeterMeasurement.index.c30':
    '上传时间',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.MeterMeasurement.index.c31':
    '检测项目',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.MeterMeasurement.index.c32':
    '血压',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.MeterMeasurement.index.c33':
    '心率',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.MeterMeasurement.index.c34':
    '步数',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.MeterMeasurement.index.c35':
    '睡眠',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.MeterMeasurement.index.c36':
    '检测结果',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.MeterMeasurement.index.c37':
    '次/分',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.MeterMeasurement.index.c38':
    '步数',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.MeterMeasurement.index.c39':
    '操作',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.MeterMeasurement.index.c40':
    '删除成功',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.MeterMeasurement.index.c41':
    '请求出错',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.PositionTrack.index.c1':
    '确定删除吗？',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.PositionTrack.index.c2':
    '查看地图',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.PositionTrack.index.c3':
    '删除',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.PositionTrack.index.c4':
    '更新定位',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.PositionTrack.index.c5':
    '表单搜索项会从 params 传入，传递给后端接口。',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.PositionTrack.index.c6':
    '确定',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.PositionTrack.index.c11':
    '取消',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.PositionTrack.index.c16':
    '使用者',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.PositionTrack.index.c17':
    '检测人',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.PositionTrack.index.c18':
    '定位时间',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.PositionTrack.index.c19':
    '检测日期',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.PositionTrack.index.c20':
    '城市',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.PositionTrack.index.c21':
    '位置',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.PositionTrack.index.c22':
    '操作',
  'src.pages.EquipmentManagement.EquipmentDetail.conponents.WristWatch.PositionTrack.index.c23':
    '删除成功',
  'src.pages.EquipmentManagement.EquipmentRegister.components.MeterDetailModal.index.c1':
    '提交',
  'src.pages.EquipmentManagement.EquipmentRegister.components.MeterDetailModal.index.c2':
    '可上传1张封面图片，建议图片宽高比例为1:1，图片大小不超过2MB。',
  'src.pages.EquipmentManagement.EquipmentRegister.components.MeterDetailModal.index.c3':
    '设备类型',
  'src.pages.EquipmentManagement.EquipmentRegister.components.MeterDetailModal.index.c5':
    '产品线',
  'src.pages.EquipmentManagement.EquipmentRegister.components.MeterDetailModal.index.c7':
    '设备名称',
  'src.pages.EquipmentManagement.EquipmentRegister.components.MeterDetailModal.index.c9':
    '所属厂家',
  'src.pages.EquipmentManagement.EquipmentRegister.components.MeterDetailModal.index.c11':
    '设备型号',
  'src.pages.EquipmentManagement.EquipmentRegister.components.MeterDetailModal.index.c13':
    '按钮数量',
  'src.pages.EquipmentManagement.EquipmentRegister.components.MeterDetailModal.index.c15':
    '设备描述',
  'src.pages.EquipmentManagement.EquipmentRegister.components.MeterDetailModal.index.c17':
    '封面图片',
  'src.pages.EquipmentManagement.EquipmentRegister.components.MeterDetailModal.index.c18':
    '编辑设备',
  'src.pages.EquipmentManagement.EquipmentRegister.components.MeterDetailModal.index.c19':
    '新增设备',
  'src.pages.EquipmentManagement.EquipmentRegister.components.MeterDetailModal.index.c20':
    '请求出错，请稍后重试',
  'src.pages.EquipmentManagement.EquipmentRegister.components.MeterDetailModal.index.c21':
    '请选择设备类型',
  'src.pages.EquipmentManagement.EquipmentRegister.components.MeterDetailModal.index.c22':
    '请选择产品线',
  'src.pages.EquipmentManagement.EquipmentRegister.components.MeterDetailModal.index.c23':
    '请输入设备名称',
  'src.pages.EquipmentManagement.EquipmentRegister.components.MeterDetailModal.index.c24':
    '请选择所属厂家',
  'src.pages.EquipmentManagement.EquipmentRegister.components.MeterDetailModal.index.c25':
    '请输入设备型号',
  'src.pages.EquipmentManagement.EquipmentRegister.components.MeterDetailModal.index.c26':
    '请输入按钮数量',
  'src.pages.EquipmentManagement.EquipmentRegister.components.MeterDetailModal.index.c27':
    '请选择封面图片',
  'src.pages.EquipmentManagement.EquipmentRegister.components.RegisterModal.index.c1':
    '登记版本',
  'src.pages.EquipmentManagement.EquipmentRegister.components.RegisterModal.index.c2':
    '验证设备号',
  'src.pages.EquipmentManagement.EquipmentRegister.components.RegisterModal.index.c3':
    '导入设备号',
  'src.pages.EquipmentManagement.EquipmentRegister.components.RegisterModal.index.c4':
    '下载模板',
  'src.pages.EquipmentManagement.EquipmentRegister.components.RegisterModal.index.c5':
    '上一步',
  'src.pages.EquipmentManagement.EquipmentRegister.components.RegisterModal.index.c6':
    '取消',
  'src.pages.EquipmentManagement.EquipmentRegister.components.RegisterModal.index.c7':
    '提交',
  'src.pages.EquipmentManagement.EquipmentRegister.components.RegisterModal.index.c8':
    '下一步',
  'src.pages.EquipmentManagement.EquipmentRegister.components.RegisterModal.index.c9':
    '设备名称/型号',
  'src.pages.EquipmentManagement.EquipmentRegister.components.RegisterModal.index.c10':
    '选择集群',
  'src.pages.EquipmentManagement.EquipmentRegister.components.RegisterModal.index.c11':
    '选择租户',
  'src.pages.EquipmentManagement.EquipmentRegister.components.RegisterModal.index.c12':
    '使用客户端',
  'src.pages.EquipmentManagement.EquipmentRegister.components.RegisterModal.index.c13':
    '通知客户端',
  'src.pages.EquipmentManagement.EquipmentRegister.components.RegisterModal.index.c14':
    '输入设备号',
  'src.pages.EquipmentManagement.EquipmentRegister.components.RegisterModal.index.c15':
    '请输入设备编号，多个编号请用回车键分行',
  'src.pages.EquipmentManagement.EquipmentRegister.components.RegisterModal.index.c16':
    '绑定服务套餐',
  'src.pages.EquipmentManagement.EquipmentRegister.components.RegisterModal.index.c17':
    '绑定服务团队',
  'src.pages.EquipmentManagement.EquipmentRegister.components.RegisterModal.index.c18':
    '登记类型',
  'src.pages.EquipmentManagement.EquipmentRegister.components.RegisterModal.index.c19':
    '申请人',
  'src.pages.EquipmentManagement.EquipmentRegister.components.RegisterModal.index.c20':
    '收货单位',
  'src.pages.EquipmentManagement.EquipmentRegister.components.RegisterModal.index.c21':
    '设置标签',
  'src.pages.EquipmentManagement.EquipmentRegister.components.RegisterModal.index.c22':
    '备注',
  'src.pages.EquipmentManagement.EquipmentRegister.components.RegisterModal.index.c23':
    '登记新设备',
  'src.pages.EquipmentManagement.EquipmentRegister.components.RegisterModal.index.c24':
    '必填信息',
  'src.pages.EquipmentManagement.EquipmentRegister.components.RegisterModal.index.c25':
    '选填信息',
  'src.pages.EquipmentManagement.EquipmentRegister.components.RegisterModal.index.c26':
    '请求出错，请稍后重试！',
  'src.pages.EquipmentManagement.EquipmentRegister.components.RegisterModal.index.c27':
    '小程序',
  'src.pages.EquipmentManagement.EquipmentRegister.components.RegisterModal.index.c28':
    '公众号',
  'src.pages.EquipmentManagement.EquipmentRegister.components.RegisterModal.index.c29':
    '上传中',
  'src.pages.EquipmentManagement.EquipmentRegister.components.RegisterModal.index.c30':
    '上传成功',
  'src.pages.EquipmentManagement.EquipmentRegister.components.RegisterModal.index.c31':
    '上传失败，请稍后重试',
  'src.pages.EquipmentManagement.EquipmentRegister.components.RegisterModal.index.c32':
    '登记成功',
  'src.pages.EquipmentManagement.EquipmentRegister.components.RegisterModal.index.c33':
    '文件格式错误，请下载模板！',
  'src.pages.EquipmentManagement.EquipmentRegister.components.RegisterModal.index.c34':
    '文件类型不正确',
  'src.pages.EquipmentManagement.EquipmentRegister.components.RegisterModal.index.c35':
    '请输入设备号',
  'src.pages.EquipmentManagement.EquipmentRegister.components.RegisterModal.index.c36':
    '请选择集群！',
  'src.pages.EquipmentManagement.EquipmentRegister.components.RegisterModal.index.c37':
    '请选择租户！',
  'src.pages.EquipmentManagement.EquipmentRegister.components.RegisterModal.index.c38':
    '请选择使用客户端！',
  'src.pages.EquipmentManagement.EquipmentRegister.components.RegisterModal.index.c39':
    '请选择通知客户端！',
  'src.pages.EquipmentManagement.EquipmentRegister.components.RegisterModal.index.c40':
    '共输入{n}个设备号',
  'src.pages.EquipmentManagement.EquipmentRegister.components.RegisterModal.index.c41':
    '取消',
  'src.pages.EquipmentManagement.EquipmentRegister.components.RegisterModal.index.c42':
    '产品线',
  'src.pages.EquipmentManagement.EquipmentRegister.index.c1': '设备一览',
  'src.pages.EquipmentManagement.EquipmentRegister.index.c2': '登记记录',
  'src.pages.EquipmentManagement.EquipmentRegister.Meters.index.c1':
    '确认停用状态？',
  'src.pages.EquipmentManagement.EquipmentRegister.Meters.index.c2': '登记',
  'src.pages.EquipmentManagement.EquipmentRegister.Meters.index.c3': '记录',
  'src.pages.EquipmentManagement.EquipmentRegister.Meters.index.c4': '编辑',
  'src.pages.EquipmentManagement.EquipmentRegister.Meters.index.c5': '新增设备',
  'src.pages.EquipmentManagement.EquipmentRegister.Meters.index.c6':
    '确认启用状态？',
  'src.pages.EquipmentManagement.EquipmentRegister.Meters.index.c7':
    '请求出错，请稍后重试！',
  'src.pages.EquipmentManagement.EquipmentRegister.Meters.index.c8': '设备名称',
  'src.pages.EquipmentManagement.EquipmentRegister.Meters.index.c9': '产品线',
  'src.pages.EquipmentManagement.EquipmentRegister.Meters.index.c10':
    '设备类型',
  'src.pages.EquipmentManagement.EquipmentRegister.Meters.index.c11': '厂家',
  'src.pages.EquipmentManagement.EquipmentRegister.Meters.index.c12':
    '设备型号',
  'src.pages.EquipmentManagement.EquipmentRegister.Meters.index.c13':
    '按钮数量',
  'src.pages.EquipmentManagement.EquipmentRegister.Meters.index.c14': '无限',
  'src.pages.EquipmentManagement.EquipmentRegister.Meters.index.c15':
    '登记数量（台）',
  'src.pages.EquipmentManagement.EquipmentRegister.Meters.index.c16':
    '最近登记时间',
  'src.pages.EquipmentManagement.EquipmentRegister.Meters.index.c17':
    '启用状态',
  'src.pages.EquipmentManagement.EquipmentRegister.Meters.index.c18': '启用',
  'src.pages.EquipmentManagement.EquipmentRegister.Meters.index.c19': '停用',
  'src.pages.EquipmentManagement.EquipmentRegister.Meters.index.c20': '操作',
  'src.pages.EquipmentManagement.EquipmentRegister.Meters.index.c21': '已停用',
  'src.pages.EquipmentManagement.EquipmentRegister.Meters.index.c22': '已启用',
  'src.pages.EquipmentManagement.EquipmentRegister.Meters.index.c23':
    '共{total}条记录',
  'src.pages.EquipmentManagement.EquipmentRegister.Registration.index.c1':
    '请求出错，请稍后重试！',
  'src.pages.EquipmentManagement.EquipmentRegister.Registration.index.c2':
    '批次号',
  'src.pages.EquipmentManagement.EquipmentRegister.Registration.index.c3':
    '设备编号',
  'src.pages.EquipmentManagement.EquipmentRegister.Registration.index.c4':
    '设备名称',
  'src.pages.EquipmentManagement.EquipmentRegister.Registration.index.c5':
    '登记租户',
  'src.pages.EquipmentManagement.EquipmentRegister.Registration.index.c6':
    '申请人',
  'src.pages.EquipmentManagement.EquipmentRegister.Registration.index.c7':
    '收货单位',
  'src.pages.EquipmentManagement.EquipmentRegister.Registration.index.c8':
    '操作人',
  'src.pages.EquipmentManagement.EquipmentRegister.Registration.index.c9':
    '登记数量（台）',
  'src.pages.EquipmentManagement.EquipmentRegister.Registration.index.c10':
    '登记时间',
  'src.pages.EquipmentManagement.EquipmentRegister.Registration.index.c11':
    '操作',
  'src.pages.EquipmentManagement.EquipmentRegister.Registration.index.c12':
    '设备清单',
  'src.pages.EquipmentManagement.EquipmentRegister.Registration.index.c13':
    '共{total} 条记录，{count}台设备',
  'src.pages.EquipmentManagement.EquipmentRegister.Registration.index.c14':
    '已选 {num} 项',
  'src.pages.EquipmentManagement.EquipmentRegister.RegistrationList.index.c1':
    '确认注销设备？',
  'src.pages.EquipmentManagement.EquipmentRegister.RegistrationList.index.c2':
    '重新登记',
  'src.pages.EquipmentManagement.EquipmentRegister.RegistrationList.index.c3':
    '返回',
  'src.pages.EquipmentManagement.EquipmentRegister.RegistrationList.index.c4':
    '被选中项的 customerPackages 中是否有使用中的套餐',
  'src.pages.EquipmentManagement.EquipmentRegister.RegistrationList.index.c5':
    '批次号',
  'src.pages.EquipmentManagement.EquipmentRegister.RegistrationList.index.c6':
    '设备号',
  'src.pages.EquipmentManagement.EquipmentRegister.RegistrationList.index.c7':
    '设备状态',
  'src.pages.EquipmentManagement.EquipmentRegister.RegistrationList.index.c8':
    '启用',
  'src.pages.EquipmentManagement.EquipmentRegister.RegistrationList.index.c9':
    '停用',
  'src.pages.EquipmentManagement.EquipmentRegister.RegistrationList.index.c10':
    '当前租户',
  'src.pages.EquipmentManagement.EquipmentRegister.RegistrationList.index.c11':
    '产品线/版本',
  'src.pages.EquipmentManagement.EquipmentRegister.RegistrationList.index.c12':
    '个人版',
  'src.pages.EquipmentManagement.EquipmentRegister.RegistrationList.index.c13':
    '机构版',
  'src.pages.EquipmentManagement.EquipmentRegister.RegistrationList.index.c14':
    '使用客户端',
  'src.pages.EquipmentManagement.EquipmentRegister.RegistrationList.index.c15':
    '通知客户端',
  'src.pages.EquipmentManagement.EquipmentRegister.RegistrationList.index.c16':
    '登记时间',
  'src.pages.EquipmentManagement.EquipmentRegister.RegistrationList.index.c17':
    '更新时间',
  'src.pages.EquipmentManagement.EquipmentRegister.RegistrationList.index.c18':
    '操作',
  'src.pages.EquipmentManagement.EquipmentRegister.RegistrationList.index.c19':
    '已注销',
  'src.pages.EquipmentManagement.EquipmentRegister.RegistrationList.index.c20':
    '请求出错，请稍后重试！',
  'src.pages.EquipmentManagement.EquipmentRegister.RegistrationList.index.c21':
    '注销设备',
  'src.pages.EquipmentManagement.EquipmentRegister.RegistrationList.index.c22':
    '查询批次',
  'src.pages.EquipmentManagement.EquipmentView.components.BindPackageModal.index.c1':
    '绑定套餐',
  'src.pages.EquipmentManagement.EquipmentView.components.BindPackageModal.index.c2':
    '下拉列表默认数据',
  'src.pages.EquipmentManagement.EquipmentView.components.BindPackageModal.index.c3':
    '获取服务套餐下拉列表数据',
  'src.pages.EquipmentManagement.EquipmentView.components.BindPackageModal.index.c4':
    '获取服务团队下拉列表数据',
  'src.pages.EquipmentManagement.EquipmentView.components.BindPackageModal.index.c5':
    '服务套餐',
  'src.pages.EquipmentManagement.EquipmentView.components.BindPackageModal.index.c6':
    '服务团队',
  'src.pages.EquipmentManagement.EquipmentView.components.BindPackageModal.index.c7':
    '请选择设备',
  'src.pages.EquipmentManagement.EquipmentView.components.BindPackageModal.index.c8':
    '绑定成功',
  'src.pages.EquipmentManagement.EquipmentView.components.BindPackageModal.index.c9':
    '请求失败，请稍后重试',
  'src.pages.EquipmentManagement.EquipmentView.components.BindPackageModal.index.c10':
    '请选择服务团队',
  'src.pages.EquipmentManagement.EquipmentView.components.LabelSetModal.index.c1':
    '设置标签',
  'src.pages.EquipmentManagement.EquipmentView.components.LabelSetModal.index.c2':
    '请选择标签：',
  'src.pages.EquipmentManagement.EquipmentView.components.LabelSetModal.index.c3':
    '请选择标签',
  'src.pages.EquipmentManagement.EquipmentView.components.LabelSetModal.index.c4':
    '请选择标签：',
  'src.pages.EquipmentManagement.EquipmentView.components.LabelSetModal.index.c5':
    '请选择客户',
  'src.pages.EquipmentManagement.EquipmentView.components.LabelSetModal.index.c6':
    '绑定成功',
  'src.pages.EquipmentManagement.EquipmentView.components.LabelSetModal.index.c7':
    '请求失败，请稍后重试',
  'src.pages.EquipmentManagement.EquipmentView.components.PackageConfirm.index.c1':
    '操作提示',
  'src.pages.EquipmentManagement.EquipmentView.components.PackageConfirm.index.c2':
    '返回',
  'src.pages.EquipmentManagement.EquipmentView.components.PackageConfirm.index.c3':
    '您所选择的设备不符合关联套餐设置条件，请重新选择设备。',
  'src.pages.EquipmentManagement.EquipmentView.components.PersonSettingModal.index.c1':
    '人员设置',
  'src.pages.EquipmentManagement.EquipmentView.components.PersonSettingModal.index.c2':
    '当前点击的是哪个选择框， -1 为管理员',
  'src.pages.EquipmentManagement.EquipmentView.components.PersonSettingModal.index.c3':
    '管理员选项',
  'src.pages.EquipmentManagement.EquipmentView.components.PersonSettingModal.index.c4':
    '这里将默认人员填入',
  'src.pages.EquipmentManagement.EquipmentView.components.PersonSettingModal.index.c5':
    '设备管理员',
  'src.pages.EquipmentManagement.EquipmentView.components.PersonSettingModal.index.c6':
    '设备使用者',
  'src.pages.EquipmentManagement.EquipmentView.components.PersonSettingModal.index.c7':
    '添加使用者',
  'src.pages.EquipmentManagement.EquipmentView.components.PersonSettingModal.index.c8':
    '按钮',
  'src.pages.EquipmentManagement.EquipmentView.components.PersonSettingModal.index.c9':
    '设置成功',
  'src.pages.EquipmentManagement.EquipmentView.components.PersonSettingModal.index.c10':
    '请求失败，请稍后重试',
  'src.pages.EquipmentManagement.EquipmentView.components.PersonSettingModal.index.c11':
    '未选中客户',
  'src.pages.EquipmentManagement.EquipmentView.components.PersonSettingModal.index.c12':
    '请先完善个人信息',
  'src.pages.EquipmentManagement.EquipmentView.index.c1': '设备编号',
  'src.pages.EquipmentManagement.EquipmentView.index.c2': '设备号',
  'src.pages.EquipmentManagement.EquipmentView.index.c3': '设备名称/型号',
  'src.pages.EquipmentManagement.EquipmentView.index.c4': '设备类型',
  'src.pages.EquipmentManagement.EquipmentView.index.c5': '设备版本',
  'src.pages.EquipmentManagement.EquipmentView.index.c6': '全部',
  'src.pages.EquipmentManagement.EquipmentView.index.c7': '个人版',
  'src.pages.EquipmentManagement.EquipmentView.index.c8': '机构版',
  'src.pages.EquipmentManagement.EquipmentView.index.c9': '登记批次',
  'src.pages.EquipmentManagement.EquipmentView.index.c10': '绑定客户端',
  'src.pages.EquipmentManagement.EquipmentView.index.c11': '无',
  'src.pages.EquipmentManagement.EquipmentView.index.c12': '绑定套餐',
  'src.pages.EquipmentManagement.EquipmentView.index.c13': '服务团队',
  'src.pages.EquipmentManagement.EquipmentView.index.c14': '服务人员',
  'src.pages.EquipmentManagement.EquipmentView.index.c15': '当前使用者',
  'src.pages.EquipmentManagement.EquipmentView.index.c16': '使用者',
  'src.pages.EquipmentManagement.EquipmentView.index.c17': '设备标签',
  'src.pages.EquipmentManagement.EquipmentView.index.c18': '标签',
  'src.pages.EquipmentManagement.EquipmentView.index.c19': '绑定状态',
  'src.pages.EquipmentManagement.EquipmentView.index.c20': '未绑定',
  'src.pages.EquipmentManagement.EquipmentView.index.c21': '已绑定',
  'src.pages.EquipmentManagement.EquipmentView.index.c22': '检测状态',
  'src.pages.EquipmentManagement.EquipmentView.index.c23': '未检测',
  'src.pages.EquipmentManagement.EquipmentView.index.c24': '已检测',
  'src.pages.EquipmentManagement.EquipmentView.index.c25': '首次检测',
  'src.pages.EquipmentManagement.EquipmentView.index.c26': '最近检测',
  'src.pages.EquipmentManagement.EquipmentView.index.c27': '操作',
  'src.pages.EquipmentManagement.EquipmentView.index.c28': '详情',
  'src.pages.EquipmentManagement.EquipmentView.index.c29': '人员设置',
  'src.pages.EquipmentManagement.EquipmentView.index.c30': '操作提示',
  'src.pages.EquipmentManagement.EquipmentView.index.c31':
    '重置设备将会做以下操作，请确认后再继续',
  'src.pages.EquipmentManagement.EquipmentView.index.c32':
    '清除设备使用者、设备管理员',
  'src.pages.EquipmentManagement.EquipmentView.index.c33':
    '清空设备的绑定状态、检测状态',
  'src.pages.EquipmentManagement.EquipmentView.index.c34':
    '清除设备已绑定的套餐、服务人员',
  'src.pages.EquipmentManagement.EquipmentView.index.c35':
    '设备已生成的检测记录及客户的检测记录将会保留',
  'src.pages.EquipmentManagement.EquipmentView.index.c36': '提交',
  'src.pages.EquipmentManagement.EquipmentView.index.c37': '取消',
  'src.pages.EquipmentManagement.EquipmentView.index.c38': '提交成功',
  'src.pages.EquipmentManagement.EquipmentView.index.c39': '设置标签',
  'src.pages.EquipmentManagement.EquipmentView.index.c40': '关联套餐',
  'src.pages.EquipmentManagement.EquipmentView.index.c41': '重置设备',
  'src.pages.EquipmentManagement.EquipmentView.index.c42': '设备状态',
  'src.pages.EquipmentManagement.EquipmentView.index.c43': '正常',
  'src.pages.EquipmentManagement.EquipmentView.index.c44': '注销',
  'src.pages.EquipmentManagement.EquipmentView.index.c45': '请选择',
  'src.pages.HutManage.AddHut.index.c1': '小屋基本信息',
  'src.pages.HutManage.AddHut.index.c2': '请输入详细地址',
  'src.pages.HutManage.AddHut.index.c3': '请选择',
  'src.pages.HutManage.AddHut.index.c6': '取消',
  'src.pages.HutManage.AddHut.index.c7': '下一步',
  'src.pages.HutManage.AddHut.index.c9': '上一步',
  'src.pages.HutManage.AddHut.index.c11': '保存设置',
  'src.pages.HutManage.AddHut.index.c15': '小屋名称',
  'src.pages.HutManage.AddHut.index.c29': '所属部门',
  'src.pages.HutManage.AddHut.index.c43': '小屋地址',
  'src.pages.HutManage.AddHut.index.c13':
    '请输入正确的手机号码或固定电话，固定电话格式为“区号+号码”',
  'src.pages.HutManage.AddHut.index.c14':
    '如01088888888，中间无需标点符号连接。',
  'src.pages.HutManage.AddHut.index.c57': '负责人姓名',
  'src.pages.HutManage.AddHut.index.c71': '联系电话',
  'src.pages.HutManage.AddHut.index.c85': '签约时间',
  'src.pages.HutManage.AddHut.index.c99': '小屋描述',
  'src.pages.HutManage.AddHut.index.c113': '小屋设置',
  'src.pages.HutManage.AddHut.index.c127': '选择扫码平台',
  'src.pages.HutManage.AddHut.index.c141': '绑定客户端',
  'src.pages.HutManage.AddHut.index.c155': '绑定公众号',
  'src.pages.HutManage.AddHut.index.c169': '营业状态',
  'src.pages.HutManage.AddHut.index.c170': '智能推送',
  'src.pages.HutManage.AddHut.index.c183': '报告封面logo',
  'src.pages.HutManage.AddHut.index.c197': '完成',
  'src.pages.HutManage.ExamRecords.DataModal.index.c1': '查看指标数据',
  'src.pages.HutManage.ExamRecords.DataModal.index.c2': '状态',
  'src.pages.HutManage.ExamRecords.DataModal.index.c3': '酸碱度：',
  'src.pages.HutManage.ExamRecords.DataModal.index.c4': '亚硝酸盐：',
  'src.pages.HutManage.ExamRecords.DataModal.index.c5': '葡萄糖：',
  'src.pages.HutManage.ExamRecords.DataModal.index.c6': '尿蛋白：',
  'src.pages.HutManage.ExamRecords.DataModal.index.c7': '维生素 C：',
  'src.pages.HutManage.ExamRecords.DataModal.index.c8': '尿比重：',
  'src.pages.HutManage.ExamRecords.DataModal.index.c9': '尿胆原：',
  'src.pages.HutManage.ExamRecords.DataModal.index.c10': '胆红素：',
  'src.pages.HutManage.ExamRecords.DataModal.index.c11': '酮体：',
  'src.pages.HutManage.ExamRecords.DataModal.index.c12': '尿隐血：',
  'src.pages.HutManage.ExamRecords.DataModal.index.c13': '返回',
  'src.pages.HutManage.ExamRecords.DataModal.index.c14': '性别/年龄：',
  'src.pages.HutManage.ExamRecords.DataModal.index.c15':
    '嘉乐(嘉乐JSON数组或对象)',
  'src.pages.HutManage.ExamRecords.DataModal.index.c16': '双佳',
  'src.pages.HutManage.ExamRecords.DataModal.index.c17': '康泰一体机',
  'src.pages.HutManage.ExamRecords.LookHHData.index.c1': '查看检测数据',
  'src.pages.HutManage.ExamRecords.LookHHData.index.c2': '返回',
  'src.pages.HutManage.ExamRecords.LookHHReport.index.c1': '查看报告列表',
  'src.pages.HutManage.ExamRecords.LookHHReport.index.c2': '返回',
  'src.pages.HutManage.Manage.index.c1': '确认关闭营业状态？',
  'src.pages.HutManage.Manage.index.c2': '编辑',
  'src.pages.HutManage.Manage.index.c3': '账号设置',
  'src.pages.HutManage.Manage.index.c4': '新增小屋',
  'src.pages.HutManage.Manage.index.c5': '确认开放营业状态？',
  'src.pages.HutManage.Manage.index.c6': '编辑',
  'src.pages.HutManage.Manage.index.c7': '账号设置',
  'src.pages.HutManage.Manage.index.c8': '新增小屋',
  'src.pages.HutManage.TestReport.BloodPressure.index.c1': '血压测量结果分布',
  'src.pages.HutManage.TestReport.BloodPressure.index.c2': '和（或）',
  'src.pages.HutManage.TestReport.BloodPressure.index.c3': '和（或）',
  'src.pages.HutManage.TestReport.BloodPressure.index.c4': '和',
  'src.pages.HutManage.TestReport.BloodPressure.index.c5':
    '注：判断标准参考《中国高血压防治指南2018年修订版》，当收缩压和舒张压分属于不同级别时，以较高的分级为准。',
  'src.pages.HutManage.TestReport.BloodPressure.index.c6': '血压等级判断标准',
  'src.pages.HutManage.TestReport.BMI.index.c1': '血氧',
  'src.pages.HutManage.TestReport.BMI.index.c2': '身高体重',
  'src.pages.HutManage.TestReport.BMI.index.c3': '血氧',
  'src.pages.HutManage.TestReport.BMI.index.c4': '体温',
  'src.pages.HutManage.TestReport.BMI.index.c5': '体温',
  'src.pages.HutManage.TestReport.BMI.index.c6': '身高体重',
  'src.pages.HutManage.TestReport.BMI.index.c7': '血氧',
  'src.pages.HutManage.TestReport.BMI.index.c8': '体温',
  'src.pages.HutManage.TestReport.BodyComposition.index.c1': '肌肉综合检测',
  'src.pages.HutManage.TestReport.BodyComposition.index.c6': '体重(kg)',
  'src.pages.HutManage.TestReport.BodyComposition.index.c7':
    '水分 + 蛋白质 + 脂肪 + 骨量',
  'src.pages.HutManage.TestReport.BodyComposition.index.c8': '脂肪综合评价',
  'src.pages.HutManage.TestReport.BoneDensity.index.c1': '全部指标',
  'src.pages.HutManage.TestReport.Glu.index.c1': '血糖测量结果分布',
  'src.pages.HutManage.TestReport.index.c1': '健康检查报告',
  'src.pages.HutManage.TestReport.index.c2': '打印',
  'src.pages.Inquiry.InquiryHistory.components.DrawerInquiry.index.c1':
    '咨询记录',
  'src.pages.Inquiry.InquiryHistory.components.DrawerInquiry.index.c2':
    '预留高度',
  'src.pages.Inquiry.InquiryHistory.components.DrawerInquiry.index.c3':
    '本次高度',
  'src.pages.Inquiry.InquiryHistory.components.DrawerInquiry.index.c4':
    '如果上次高度为0，则直接滚到最底部',
  'src.pages.Inquiry.InquiryHistory.components.DrawerInquiry.index.c5':
    '再把本次高度保存',
  'src.pages.Inquiry.InquiryHistory.components.DrawerInquiry.index.c6':
    '监听内容，实现滚动',
  'src.pages.Inquiry.InquiryHistory.components.DrawerInquiry.index.c7':
    '第一次获取记录',
  'src.pages.Inquiry.InquiryHistory.components.DrawerInquiry.index.c8':
    '监听打开关闭',
  'src.pages.Inquiry.InquiryHistory.index.c1': '图文问诊',
  'src.pages.Inquiry.InquiryHistory.index.c2': '服务咨询',
  'src.pages.Inquiry.Schedule.components.BatchScheduleSetting.index.c1':
    '批量排班',
  'src.pages.Inquiry.Schedule.components.BatchScheduleSetting.index.c2':
    '排班日期',
  'src.pages.Inquiry.Schedule.components.BatchScheduleSetting.index.c3':
    '坐诊医生',
  'src.pages.Inquiry.Schedule.components.BatchScheduleSetting.index.c4':
    '排除休息日',
  'src.pages.Inquiry.Schedule.components.InquirySetting.index.c1': '咨询设置',
  'src.pages.Inquiry.Schedule.components.InquirySetting.index.c2':
    '可咨询时长（分）',
  'src.pages.Inquiry.Schedule.components.InquirySetting.index.c3':
    '每次咨询费用',
  'src.pages.Inquiry.Schedule.components.OffdaySetting.index.c1': '休息日设置',
  'src.pages.Inquiry.Schedule.components.OffdaySetting.index.c2': '休息日期',
  'src.pages.Inquiry.Schedule.components.OffdaySetting.index.c3':
    '注：设为休息日后，该时间段内如已设置有医生值班的情况下，则会同时移除医生排班的设置，请谨慎操作。',
  'src.pages.Inquiry.Schedule.components.ScheduleSetting.index.c1': '排班设置',
  'src.pages.Inquiry.Schedule.components.ScheduleSetting.index.c2':
    '设为休息日',
  'src.pages.Inquiry.Schedule.components.ScheduleSetting.index.c3': '坐诊医生',
  'src.pages.Inquiry.Schedule.components.WorkdaySetting.index.c1': '工作日设置',
  'src.pages.Inquiry.Schedule.components.WorkdaySetting.index.c2': '每周工作日',
  'src.pages.Inquiry.Schedule.components.WorkdaySetting.index.c3':
    '每日工作时间',
  'src.pages.Inquiry.Schedule.index.c1': '在线问诊',
  'src.pages.Inquiry.Schedule.index.c2': '设置',
  'src.pages.Inquiry.Schedule.index.c3': '没有 setting 就不显示灰色背景',
  'src.pages.Inquiry.Schedule.index.c4': '将 0-6 转成 1-7',
  'src.pages.Inquiry.Schedule.index.c5': '服务咨询',
  'src.pages.Inquiry.Schedule.index.c6': '设置',
  'src.pages.Inquiry.Schedule.index.c7': '没有 setting 就不显示灰色背景',
  'src.pages.Inquiry.Schedule.index.c8': '将 0-6 转成 1-7',
  'src.pages.Inquiry.Online.index.c1': '图文问诊',
  'src.pages.Inquiry.Online.index.c2': '语音问诊',
  'src.pages.Inquiry.Online.index.c3': '视频问诊',
  'src.pages.Inquiry.Online.index.c4': '服务咨询',
  'src.pages.noAccess.c1': '抱歉，你无页面访问权限，请联系管理员',
  'src.pages.OperationManage.Information.index.c1': '操作',
  'src.pages.OperationManage.InformationUpdate.AudioUploadTable.index.c1':
    '请输入关键词',
  'src.pages.OperationManage.InformationUpdate.AudioUploadTable.index.c2':
    '用 ref 做锚',
  'src.pages.OperationManage.InformationUpdate.AudioUploadTable.index.c3':
    '决定何时重新 render 拖拽表格的内容',
  'src.pages.OperationManage.InformationUpdate.AudioUploadTable.index.c4':
    '实际数据',
  'src.pages.OperationManage.InformationUpdate.AudioUploadTable.index.c5':
    '新增',
  'src.pages.OperationManage.InformationUpdate.AudioUploadTable.index.c6':
    '更新锚',
  'src.pages.OperationManage.InformationUpdate.AudioUploadTable.index.c7':
    '无视第一次更新，然后每次触发 onChange',
  'src.pages.OperationManage.InformationUpdate.AudioUploadTable.index.c8':
    '更新时间戳',
  'src.pages.OperationManage.InformationUpdate.AudioUploadTable.index.c9':
    '新增',
  'src.pages.OperationManage.InformationUpdate.AudioUploadTable.index.c10':
    '确认要删除该行吗？',
  'src.pages.OperationManage.InformationUpdate.index.c1': '标题',
  'src.pages.OperationManage.InformationUpdate.index.c11': '所属频道',
  'src.pages.OperationManage.InformationUpdate.index.c21': '标签',
  'src.pages.OperationManage.InformationUpdate.index.c31': '简介',
  'src.pages.OperationManage.InformationUpdate.index.c41': '请输入简介',
  'src.pages.OperationManage.InformationUpdate.index.c51': '封面',
  'src.pages.OperationManage.InformationUpdate.index.c61': '首页推荐',
  'src.pages.OperationManage.InformationUpdate.index.c71': '发表状态',
  'src.pages.OperationManage.InformationUpdate.index.c81': '上传音频',
  'src.pages.OperationManage.InformationUpdate.index.c91': '上传视频',
  'src.pages.OperationManage.SmartPush.index.c1': '查询条件',
  'src.pages.OperationManage.SmartPush.index.c2': '状态',
  'src.pages.OperationManage.SmartPush.index.c3': '规则名称',
  'src.pages.OperationManage.SmartPush.index.c4': '共 {total} 条记录',
  'src.pages.OperationManage.SmartPush.index.c5': '新增规则',
  'src.pages.OperationManage.SmartPush.index.c6': '客户标签',
  'src.pages.OperationManage.SmartPush.index.c7': '健康资讯',
  'src.pages.OperationManage.SmartPush.index.c8': '干预方案',
  'src.pages.OperationManage.SmartPush.index.c9': '健康习惯',
  'src.pages.OperationManage.SmartPush.index.c10': '健康商品',
  'src.pages.OperationManage.SmartPush.index.c11': '操作人',
  'src.pages.OperationManage.SmartPush.index.c12': '操作',
  'src.pages.OperationManage.SmartPush.index.c13': '正常',
  'src.pages.OperationManage.SmartPush.index.c14': '关闭',
  'src.pages.OperationManage.SmartPush.index.c15': '输入关键词',
  'src.pages.OperationManage.SmartPush.index.c16': '设置',
  'src.pages.OperationManage.SmartPush.RuleSetting.index.c1': '新增',
  'src.pages.OperationManage.SmartPush.RuleSetting.index.c2': '设置',
  'src.pages.OperationManage.SmartPush.RuleSetting.index.c3': '{action}规则',
  'src.pages.OperationManage.SmartPush.RuleSetting.index.c4': '规则名称',
  'src.pages.OperationManage.SmartPush.RuleSetting.index.c5': '请输入规则名称',
  'src.pages.OperationManage.SmartPush.RuleSetting.index.c6': '设置客户标签',
  'src.pages.OperationManage.SmartPush.RuleSetting.index.c7': '请选择客户标签',
  'src.pages.OperationManage.SmartPush.RuleSetting.index.c8':
    '客户标签用于查找匹配该规则的客户；',
  'src.pages.OperationManage.SmartPush.RuleSetting.index.c9': '添加标签',
  'src.pages.OperationManage.SmartPush.RuleSetting.index.c10': '关联设置',
  'src.pages.OperationManage.SmartPush.RuleSetting.index.c11': '健康资讯',
  'src.pages.OperationManage.SmartPush.RuleSetting.index.c12': '干预方案',
  'src.pages.OperationManage.SmartPush.RuleSetting.index.c13': '健康习惯',
  'src.pages.OperationManage.SmartPush.RuleSetting.index.c14': '健康商品',
  'src.pages.OperationManage.SmartPush.RuleSetting.index.c15': '预约项目',
  'src.pages.OperationManage.SmartPush.RuleSetting.index.c16': '名称',
  'src.pages.OperationManage.SmartPush.RuleSetting.index.c17': '操作',
  'src.pages.OperationManage.SmartPush.RuleSetting.index.c18': '删除',
  'src.pages.OperationManage.SmartPush.RuleSetting.index.c19': '请确认是否删除',
  'src.pages.OperationManage.SmartPush.RuleSetting.index.c20': '已选择',
  'src.pages.OperationManage.SmartPush.RuleSetting.index.c21': '项',
  'src.pages.OperationManage.SmartPush.RuleSetting.index.c22': '已添加',
  'src.pages.OperationManage.SmartPush.RuleSetting.index.c23': '条记录',
  'src.pages.OperationManage.SmartPush.RuleSetting.index.c24': '添加',
  'src.pages.OperationManage.SmartPush.RuleSetting.index.c25': '请选择健康资讯',
  'src.pages.OperationManage.SmartPush.RuleSetting.index.c26': '请选择干预方案',
  'src.pages.OperationManage.SmartPush.RuleSetting.index.c27': '请选择健康习惯',
  'src.pages.OperationManage.SmartPush.RuleSetting.index.c28': '请选择健康商品',
  'src.pages.OperationManage.SmartPush.RuleSetting.index.c29': '请选择预约项目',
  'src.pages.OperationManage.SmartPush.RuleSetting.index.c30': '保存成功',
  'src.pages.OperationManage.SmartPush.RuleSetting.index.c31':
    '保存失败，请稍后重试',
  'src.pages.OperationManage.SmartPush.RuleSetting.components.HealthInformation.index.c1':
    '添加健康资讯',
  'src.pages.OperationManage.SmartPush.RuleSetting.components.HealthInformation.index.c2':
    '资讯标题',
  'src.pages.OperationManage.SmartPush.RuleSetting.components.HealthInformation.index.c3':
    '提交选择',
  'src.pages.OperationManage.SmartPush.RuleSetting.components.HealthInformation.index.c4':
    '输入关键词',
  'src.pages.OperationManage.SmartPush.RuleSetting.components.HealthInformation.index.c5':
    '名称',
  'src.pages.OperationManage.SmartPush.RuleSetting.components.HealthInformation.index.c6':
    '选择',
  'src.pages.OperationManage.SmartPush.RuleSetting.components.InterventionProgram.index.c1':
    '添加干预方案',
  'src.pages.OperationManage.SmartPush.RuleSetting.components.InterventionProgram.index.c2':
    '方案标题',
  'src.pages.OperationManage.SmartPush.RuleSetting.components.InterventionProgram.index.c3':
    '提交选择',
  'src.pages.OperationManage.SmartPush.RuleSetting.components.InterventionProgram.index.c4':
    '输入关键词',
  'src.pages.OperationManage.SmartPush.RuleSetting.components.InterventionProgram.index.c5':
    '名称',
  'src.pages.OperationManage.SmartPush.RuleSetting.components.InterventionProgram.index.c6':
    '选择',
  'src.pages.OperationManage.SmartPush.RuleSetting.components.HealthyHabits.index.c1':
    '添加健康习惯',
  'src.pages.OperationManage.SmartPush.RuleSetting.components.HealthyHabits.index.c2':
    '习惯标题',
  'src.pages.OperationManage.SmartPush.RuleSetting.components.HealthyHabits.index.c3':
    '提交选择',
  'src.pages.OperationManage.SmartPush.RuleSetting.components.HealthyHabits.index.c4':
    '输入关键词',
  'src.pages.OperationManage.SmartPush.RuleSetting.components.HealthyHabits.index.c5':
    '名称',
  'src.pages.OperationManage.SmartPush.RuleSetting.components.HealthyHabits.index.c6':
    '选择',
  'src.pages.OperationManage.SmartPush.RuleSetting.components.HealthGoods.index.c1':
    '添加健康商品',
  'src.pages.OperationManage.SmartPush.RuleSetting.components.HealthGoods.index.c2':
    '商品标题',
  'src.pages.OperationManage.SmartPush.RuleSetting.components.HealthGoods.index.c3':
    '提交选择',
  'src.pages.OperationManage.SmartPush.RuleSetting.components.HealthGoods.index.c4':
    '输入关键词',
  'src.pages.OperationManage.SmartPush.RuleSetting.components.HealthGoods.index.c5':
    '名称',
  'src.pages.OperationManage.SmartPush.RuleSetting.components.HealthGoods.index.c6':
    '选择',
  'src.pages.OperationManage.SmartPush.RuleSetting.components.ReservationItem.index.c1':
    '添加预约项目',
  'src.pages.OperationManage.SmartPush.RuleSetting.components.ReservationItem.index.c2':
    '项目标题',
  'src.pages.OperationManage.SmartPush.RuleSetting.components.ReservationItem.index.c3':
    '提交选择',
  'src.pages.OperationManage.SmartPush.RuleSetting.components.ReservationItem.index.c4':
    '输入关键词',
  'src.pages.OperationManage.SmartPush.RuleSetting.components.ReservationItem.index.c5':
    '名称',
  'src.pages.OperationManage.SmartPush.RuleSetting.components.ReservationItem.index.c6':
    '选择',
  'src.pages.OrderAdministrate.CategoryAddEdit.components.AddWaiterModal.index.c1':
    '添加成员',
  'src.pages.OrderAdministrate.CategoryAddEdit.components.AddWaiterModal.index.c2':
    '获取下拉列表数据，用户详细数据',
  'src.pages.OrderAdministrate.CategoryAddEdit.components.AddWaiterModal.index.c3':
    '处理成员id，表格数据由这些 id 控制',
  'src.pages.OrderAdministrate.CategoryAddEdit.components.AddWaiterModal.index.c4':
    '处理表格数据',
  'src.pages.OrderAdministrate.CategoryAddEdit.components.AddWaiterModal.index.c5':
    '通过成员 id 和用户详细数据进行匹配，生成表格数据',
  'src.pages.OrderAdministrate.CategoryAddEdit.components.AddWaiterModal.index.c6':
    '移除',
  'src.pages.OrderAdministrate.CategoryAddEdit.components.ServiceModal.index.c1':
    '每周预约日',

  'src.pages.OrderAdministrate.CategoryAddEdit.index.c1': '休息日',
  'src.pages.OrderAdministrate.CategoryAddEdit.index.c14': '取消',
  'src.pages.OrderAdministrate.CategoryAddEdit.index.c15': '下一步 ',
  'src.pages.OrderAdministrate.CategoryAddEdit.index.c19': '保存设置',
  'src.pages.OrderAdministrate.CategoryAddEdit.index.c26':
    '说明：图片宽高比例建议为1:1，宽高尺寸需大于300px；',
  'src.pages.OrderAdministrate.CategoryAddEdit.index.c28':
    '说明：如需设置上架，则请至少上传一张图片。支持png、jpg图片，最多上传9张，第一张默认为主图',
  'src.pages.OrderAdministrate.CategoryAddEdit.index.c41':
    '以下单当天计算可预约范围，如设置为“0~7”，意思是可预约当天至第7天范围内的日期； 如设置为“1~3”，意思是可预约次日至第3天范围内的日期。',
  'src.pages.OrderAdministrate.CategoryAddEdit.index.c43': '可用状态',
  'src.pages.OrderAdministrate.CategoryAddEdit.index.c85': '列表封面图',
  'src.pages.OrderAdministrate.CategoryAddEdit.index.c127': '详情页头图',
  'src.pages.OrderAdministrate.CategoryAddEdit.index.c169': '项目简述',
  'src.pages.OrderAdministrate.CategoryAddEdit.index.c211': '项目排序',
  'src.pages.OrderAdministrate.CategoryAddEdit.index.c253': '编辑项目详情',
  'src.pages.OrderAdministrate.CategoryAddEdit.index.c295': '预约设置',
  'src.pages.OrderAdministrate.CategoryAddEdit.index.c337': '审核类型',
  'src.pages.OrderAdministrate.CategoryAddEdit.index.c379': '支付类型',
  'src.pages.OrderAdministrate.CategoryAddEdit.index.c421': '服务形式',
  'src.pages.OrderAdministrate.CategoryAddEdit.index.c463': '价格设置：',
  'src.pages.OrderAdministrate.CategoryAddEdit.index.c505': '请输入销售价格',
  'src.pages.OrderAdministrate.CategoryAddEdit.index.c547': '服务时长：',
  'src.pages.OrderAdministrate.CategoryAddEdit.index.c589': '设置服务人员',
  'src.pages.OrderAdministrate.CategoryAddEdit.index.c631':
    '同一时间最多可服务',
  'src.pages.OrderAdministrate.CategoryAddEdit.index.c673': '预约排期：',
  'src.pages.OrderAdministrate.CategoryAddEdit.index.c715': '可预约范围:',
  'src.pages.OrderAdministrate.CategoryAddEdit.index.c757': '预约须知:',
  'src.pages.OrderAdministrate.CategoryAddEdit.index.c758': '客户信息:',
  'src.pages.OrderAdministrate.CategoryController.components.ApptCategoryControllerModal.index.c1':
    '类目名称：',
  'src.pages.OrderAdministrate.CategoryController.components.ApptCategoryControllerModal.index.c2':
    '该字段为必填',
  'src.pages.OrderAdministrate.CategoryController.components.ApptCategoryControllerModal.index.c3':
    '类目排序：',
  'src.pages.OrderAdministrate.CategoryController.components.ApptCategoryControllerModal.index.c4':
    '数字越大越靠前显示',
  'src.pages.OrderAdministrate.CategoryController.components.ApptCategoryControllerModal.index.c5':
    '适用店铺',
  'src.pages.OrderAdministrate.CategoryController.components.ApptCategoryControllerModal.index.c6':
    '选择店铺，可多选，不设置则默认为所有店铺通用。',
  'src.pages.OrderAdministrate.CategoryController.components.ApptCategoryControllerModal.index.c7':
    '描述：',
  'src.pages.OrderAdministrate.CategoryController.components.ApptCategoryControllerModal.index.c8':
    '请输入类目描述文字',
  'src.pages.OrderAdministrate.CategoryController.index.c1': '正常',
  'src.pages.OrderAdministrate.CategoryController.index.c2': '新增  2 编辑',
  'src.pages.OrderAdministrate.CategoryController.index.c3':
    '表单搜索项会从 params 传入，传递给后端接口。',
  'src.pages.OrderAdministrate.CategoryController.index.c4': '确定',
  'src.pages.OrderAdministrate.CategoryController.index.c7': '取消',
  'src.pages.OrderAdministrate.ItemController.index.c1': '确认要删除吗?',
  'src.pages.OrderAdministrate.ItemController.index.c2':
    '表单搜索项会从 params 传入，传递给后端接口。',
  'src.pages.OrderAdministrate.ItemController.index.c3': '确认',
  'src.pages.OrderAdministrate.ItemController.index.c5': '取消',
  'src.pages.OrderAdministrate.ItemController.index.c7': '选择客户端',
  'src.pages.OrderAdministrate.ItemController.index.c9': '选择客户端',
  'src.pages.OrderAdministrate.ItemController.index.c11': '分享好物',
  'src.pages.OrderAdministrate.OrderForm.components.OrderAddModal.index.c1':
    '新增预约订单',
  'src.pages.OrderAdministrate.OrderForm.components.OrderAddModal.index.c105':
    '选择店铺',
  'src.pages.OrderAdministrate.OrderForm.components.OrderAddModal.index.c157':
    '选择预约项目',
  'src.pages.OrderAdministrate.OrderForm.components.OrderAddModal.index.c209':
    '全部分类',
  'src.pages.OrderAdministrate.OrderForm.components.OrderAddModal.index.c261':
    '选择服务项目',
  'src.pages.OrderAdministrate.OrderForm.components.OrderAddModal.index.c313':
    '选择客户',
  'src.pages.OrderAdministrate.OrderForm.components.OrderAddModal.index.c365':
    '选择到店日期',
  'src.pages.OrderAdministrate.OrderForm.components.OrderAddModal.index.c417':
    '选择日期',
  'src.pages.OrderAdministrate.OrderForm.components.OrderAddModal.index.c469':
    '选择到店时间',
  'src.pages.OrderAdministrate.OrderForm.components.OrderAddModal.index.c521':
    '服务人员',
  'src.pages.OrderAdministrate.OrderForm.components.OrderAddModal.index.c573':
    '服务地址',
  'src.pages.OrderAdministrate.OrderForm.components.OrderAddModal.index.c625':
    '使用服务权益',
  'src.pages.OrderAdministrate.OrderForm.components.OrderAddModal.index.c677':
    '选择服务权益',
  'src.pages.OrderAdministrate.OrderForm.components.OrderAddModal.index.c729':
    '订单金额',
  'src.pages.OrderAdministrate.OrderForm.components.OrderAddModal.index.c781':
    '支付类型',
  'src.pages.OrderAdministrate.OrderForm.components.OrderCancelModal.index.c1':
    '取消订单',
  'src.pages.OrderAdministrate.OrderForm.components.OrderCancelModal.index.c2':
    '确认',
  'src.pages.OrderAdministrate.OrderForm.components.OrderCancelModal.index.c3':
    '取消',
  'src.pages.OrderAdministrate.OrderForm.components.OrderConfirmDetailModal.index.c1':
    '任务执行者',
  'src.pages.OrderAdministrate.OrderForm.components.OrderConfirmDetailModal.index.c2':
    '时间文案',
  'src.pages.OrderAdministrate.OrderForm.components.OrderConfirmDetailModal.index.c3':
    '设置任务执行者，finally 中会调用 resetFields 进行清理，所以使用定时器中进行设置',
  'src.pages.OrderAdministrate.OrderForm.components.OrderConfirmDetailModal.index.c4':
    '当前执行者',
  'src.pages.OrderAdministrate.OrderForm.components.OrderConfirmDetailModal.index.c5':
    '处理时间',
  'src.pages.OrderAdministrate.OrderForm.components.OrderConfirmDetailModal.index.c6':
    '处理执行者',
  'src.pages.OrderAdministrate.OrderForm.components.OrderConfirmDetailModal.index.c7':
    '说明：订单确认后，即预约成功，将同步生成任务，指派给执行者',
  'src.pages.OrderAdministrate.OrderForm.components.OrderConfirmDetailModal.index.c13':
    '任务描述',
  'src.pages.OrderAdministrate.OrderForm.components.OrderConfirmDetailModal.index.c19':
    '发送短信通知',
  'src.pages.OrderAdministrate.OrderForm.components.OrderConfirmDetailModal.index.c25':
    '将客户绑定给服务团队',
  'src.pages.OrderAdministrate.OrderForm.components.OrderDetailModal.index.c1':
    '订单详情',
  'src.pages.OrderAdministrate.OrderForm.components.OrderDetailModal.index.c2':
    '映射数据',
  'src.pages.OrderAdministrate.OrderForm.components.OrderDetailModal.index.c3':
    '关闭',
  'src.pages.OrderAdministrate.OrderForm.components.OrderDetailModal.index.c4':
    '客户备注：',
  'src.pages.OrderAdministrate.OrderForm.components.OrderDetailModal.index.c5':
    '服务地址：',
  'src.pages.OrderAdministrate.OrderForm.components.OrderDetailModal.index.c6':
    '项目名称',
  'src.pages.OrderAdministrate.OrderForm.components.OrderDetailModal.index.c11':
    '订单编号',
  'src.pages.OrderAdministrate.OrderForm.components.OrderDetailModal.index.c16':
    '预约者',
  'src.pages.OrderAdministrate.OrderForm.components.OrderDetailModal.index.c21':
    '任务编号',
  'src.pages.OrderAdministrate.OrderForm.components.OrderDetailModal.index.c26':
    '预约时间',
  'src.pages.OrderAdministrate.OrderForm.components.OrderDetailModal.index.c31':
    '项目类别',
  'src.pages.OrderAdministrate.OrderForm.components.OrderDetailModal.index.c36':
    '服务时长',
  'src.pages.OrderAdministrate.OrderForm.components.OrderDetailModal.index.c41':
    '预约店铺',
  'src.pages.OrderAdministrate.OrderForm.components.OrderDetailModal.index.c46':
    '服务者',
  'src.pages.OrderAdministrate.OrderForm.components.OrderDetailModal.index.c51':
    '支付类型',
  'src.pages.OrderAdministrate.OrderForm.components.OrderDetailModal.index.c56':
    '下单时间',
  'src.pages.OrderAdministrate.OrderForm.components.OrderDetailModal.index.c61':
    '支付状态',
  'src.pages.OrderAdministrate.OrderForm.components.OrderDetailModal.index.c66':
    '支付时间',
  'src.pages.OrderAdministrate.OrderForm.components.OrderDetailModal.index.c71':
    '权益抵扣',
  'src.pages.OrderAdministrate.OrderForm.components.OrderDetailModal.index.c76':
    '审核时间',
  'src.pages.OrderAdministrate.OrderForm.components.OrderDetailModal.index.c81':
    '抵扣套餐',
  'src.pages.OrderAdministrate.OrderForm.components.OrderDetailModal.index.c86':
    '完成时间',
  'src.pages.PhysicalManage.ReportList.index.c1': '确认发布该报告？',
  'src.pages.PhysicalManage.ReportList.index.c2': '体检进度废弃',
  'src.pages.PhysicalManage.ReportList.index.c3':
    '时不查询 data-数据类型 体检报告',
  'src.pages.PhysicalManage.ReportList.index.c4': '图片报告',
  'src.pages.PhysicalManage.ReportList.index.c5': '确认删除该报告？',
  'src.pages.PhysicalManage.ReportUpload.index.c1': '下载体检报告模板',
  'src.pages.PhysicalManage.ReportUpload.index.c2':
    '导入状态：init-初始化、extracting-解析中、extractSuccess-解析成功、',
  'src.pages.PhysicalManage.ReportUpload.index.c3': '导入进度，暂废弃',
  'src.pages.PhysicalManage.ReportUpload.index.c4':
    '点击或将文件拖拽到这里上传，支持上传单个excel文件或多个excel文件打包为zip格式上传。',
  'src.pages.PhysicalManage.ReportUpload.index.c5': '下载体检报告模板',
  'src.pages.PhysicalManage.ReportUpload.index.c6': '导入成功',
  'src.pages.PhysicalManage.ReportUpload.index.c7': '导入错误',
  'src.pages.PhysicalManage.ReportUpload.index.c8': '选择模板',
  'src.pages.PublicAccount.PublicAccountMessage.index.c1': '推送对象',
  'src.pages.PublicAccount.PublicAccountMessage.index.c2': '搜索姓名或手机号',
  'src.pages.PublicAccount.PublicAccountMessage.index.c3': '公告标题',
  'src.pages.PublicAccount.PublicAccountMessage.index.c4': '内容',
  'src.pages.PublicAccount.PublicAccountMessage.index.c5': '消息内容',
  'src.pages.PublicAccount.PublicAccountMessage.index.c6': '搜索标题和内容',
  'src.pages.PublicAccount.PublicAccountMessage.index.c7': '推送状态',
  'src.pages.PublicAccount.PublicAccountMessage.index.c8': '待推送',
  'src.pages.PublicAccount.PublicAccountMessage.index.c9': '已推送',
  'src.pages.PublicAccount.PublicAccountMessage.index.c10': '失败',
  'src.pages.PublicAccount.PublicAccountMessage.index.c11': '推送人',
  'src.pages.PublicAccount.PublicAccountMessage.index.c12': '系统',
  'src.pages.PublicAccount.PublicAccountMessage.index.c13': '推送时间',
  'src.pages.PublicAccount.PublicAccountMessage.index.c14': '共 {total} 条记录',
  'src.pages.Service.BindRecords.components.BindDetailModal.index.c1':
    '绑定套餐详情',
  'src.pages.Service.BindRecords.index.c1': '操作',
  'src.pages.Service.BindRecords.index.c2': '详情',
  'src.pages.Service.PackageAdd.components.BasisForm.index.c1': '套餐名称',
  'src.pages.Service.PackageAdd.components.BasisForm.index.c2': '可用状态',
  'src.pages.Service.PackageAdd.components.BasisForm.index.c3': '套餐期限',
  'src.pages.Service.PackageAdd.components.BasisForm.index.c4': '套餐价格',
  'src.pages.Service.PackageAdd.components.BasisForm.index.c5': '套餐描述',
  'src.pages.Service.PackageAdd.components.BasisForm.index.c6': '套餐详情',
  'src.pages.Service.PackageAdd.components.ServiceRights.components.Appointment.index.c1':
    '专项服务：',
  'src.pages.Service.PackageAdd.components.ServiceRights.components.Appointment.index.c2':
    '是根据业务需要自定义的专项服务，有服务次数的限制，需提前预约的人工服务。',
  'src.pages.Service.PackageAdd.components.ServiceRights.components.Appointment.UpdateModal.c1':
    '创建专项服务',
  'src.pages.Service.PackageAdd.components.ServiceRights.components.Appointment.UpdateModal.c2':
    '服务类型',
  'src.pages.Service.PackageAdd.components.ServiceRights.components.Appointment.UpdateModal.c3':
    '服务条件',
  'src.pages.Service.PackageAdd.components.ServiceRights.components.Appointment.UpdateModal.c4':
    '服务项目',
  'src.pages.Service.PackageAdd.components.ServiceRights.components.Appointment.UpdateModal.c5':
    '服务次数',
  'src.pages.Service.PackageAdd.components.ServiceRights.components.Appointment.UpdateModal.c6':
    '服务描述',
  'src.pages.Service.PackageAdd.components.ServiceRights.components.Intelligent.index.c1':
    '智能服务：',
  'src.pages.Service.PackageAdd.components.ServiceRights.components.Intelligent.index.c2':
    '是无需人工参与，系统根据系统预设的服务条件，提供相应的智能服务。',
  'src.pages.Service.PackageAdd.components.ServiceRights.components.Intelligent.UpdateModal.c1':
    '创建智能服务',
  'src.pages.Service.PackageAdd.components.ServiceRights.components.Intelligent.UpdateModal.c2':
    '服务类型',
  'src.pages.Service.PackageAdd.components.ServiceRights.components.Intelligent.UpdateModal.c3':
    '服务条件',
  'src.pages.Service.PackageAdd.components.ServiceRights.components.Intelligent.UpdateModal.c4':
    '服务项目',
  'src.pages.Service.PackageAdd.components.ServiceRights.components.Intelligent.UpdateModal.c5':
    '服务描述',
  'src.pages.Service.PackageAdd.components.ServiceRights.components.Periodical.BatchAddModal.c1':
    '创建定期干预',
  'src.pages.Service.PackageAdd.components.ServiceRights.components.Periodical.BatchAddModal.c2':
    '服务类型',
  'src.pages.Service.PackageAdd.components.ServiceRights.components.Periodical.BatchAddModal.c3':
    '服务条件',
  'src.pages.Service.PackageAdd.components.ServiceRights.components.Periodical.BatchAddModal.c4':
    '服务项目',
  'src.pages.Service.PackageAdd.components.ServiceRights.components.Periodical.BatchAddModal.c5':
    '处理时间',
  'src.pages.Service.PackageAdd.components.ServiceRights.components.Periodical.BatchAddModal.c6':
    '请输入正整数',
  'src.pages.Service.PackageAdd.components.ServiceRights.components.Periodical.BatchAddModal.c7':
    '服务描述',
  'src.pages.Service.PackageAdd.components.ServiceRights.components.Periodical.BatchAddModal.c8':
    '处理时长',
  'src.pages.Service.PackageAdd.components.ServiceRights.components.Periodical.BatchAddModal.c9':
    '请输入',
  'src.pages.Service.PackageAdd.components.ServiceRights.components.Periodical.BatchAddModal.c10':
    '处理时长',
  'src.pages.Service.PackageAdd.components.ServiceRights.components.Periodical.BatchAddModal.c11':
    '请输入正整数',
  'src.pages.Service.PackageAdd.components.ServiceRights.components.Periodical.BatchAddModal.c12':
    '删除',
  'src.pages.Service.PackageAdd.components.ServiceRights.components.Periodical.index.c1':
    '定期干预：',
  'src.pages.Service.PackageAdd.components.ServiceRights.components.Periodical.index.c2':
    '编辑',
  'src.pages.Service.PackageAdd.components.ServiceRights.components.Periodical.index.c3':
    '创建',
  'src.pages.Service.PackageAdd.components.ServiceRights.components.Periodical.index.c4':
    '是服务人员主动提供的服务，根据自定义的服务周期，系统自动创建相关的服务任务。',
  'src.pages.Service.PackageAdd.components.ServiceRights.components.Periodical.index.c5':
    '编辑',
  'src.pages.Service.PackageAdd.components.ServiceRights.components.Periodical.index.c6':
    '创建',
  'src.pages.Service.PackageAdd.components.ServiceRights.components.Periodical.UpdateModal.c1':
    '服务类型',
  'src.pages.Service.PackageAdd.components.ServiceRights.components.Periodical.UpdateModal.c2':
    '服务条件',
  'src.pages.Service.PackageAdd.components.ServiceRights.components.Periodical.UpdateModal.c3':
    '服务项目',
  'src.pages.Service.PackageAdd.components.ServiceRights.components.Periodical.UpdateModal.c4':
    '处理时间',
  'src.pages.Service.PackageAdd.components.ServiceRights.components.Periodical.UpdateModal.c5':
    '请输入正整数',
  'src.pages.Service.PackageAdd.components.ServiceRights.components.Periodical.UpdateModal.c6':
    '服务描述',
  'src.pages.Service.PackageAdd.components.ServiceRights.components.Periodical.UpdateModal.c7':
    '处理时长',
  'src.pages.Service.PackageAdd.components.ServiceRights.components.Periodical.UpdateModal.c8':
    '请输入正整数',
  'src.pages.Service.PackageAdd.components.ServiceRights.components.Results.index.c1':
    '结果干预：',
  'src.pages.Service.PackageAdd.components.ServiceRights.components.Results.index.c2':
    '是基于客户的检测结果、检测习惯，系统自动创建任务，指派给客户服务团队的服务权益。',
  'src.pages.Service.PackageAdd.components.ServiceRights.components.Results.UpdateModal.c1':
    '创建结果干预',
  'src.pages.Service.PackageAdd.components.ServiceRights.components.Results.UpdateModal.c2':
    '服务类型',
  'src.pages.Service.PackageAdd.components.ServiceRights.components.Results.UpdateModal.c3':
    '服务条件',
  'src.pages.Service.PackageAdd.components.ServiceRights.components.Results.UpdateModal.c4':
    '服务项目',
  'src.pages.Service.PackageAdd.components.ServiceRights.components.Results.UpdateModal.c5':
    '服务描述',
  'src.pages.Service.PackageManage.components.UpdateModal.c1': '套餐名称',
  'src.pages.Service.PackageManage.components.UpdateModal.c2': '可用状态',
  'src.pages.Service.PackageManage.components.UpdateModal.c3': '套餐期限',
  'src.pages.Service.PackageManage.components.UpdateModal.c4': '套餐价格',
  'src.pages.Service.PackageManage.components.UpdateModal.c5': '套餐描述',
  'src.pages.Service.PackageManage.components.UpdateModal.c6': '套餐详情',
  'src.pages.Service.PackageManage.index.c1': '操作',
  'src.pages.Service.PackageManage.index.c2': '开启关闭 PopConfirm',
  'src.pages.Service.PackageManage.index.c3': '确认删除该服务套餐？',
  'src.pages.Service.PackageManage.index.c4': '开启关闭 PopConfirm',
  'src.pages.Service.Services.components.ServiceItem.components.UpdateModal.index.c1':
    '服务类型',
  'src.pages.Service.Services.components.ServiceItem.components.UpdateModal.index.c2':
    '如果是新增，或者不是特定系统预设项，则隐藏',
  'src.pages.Service.Services.components.ServiceItem.components.UpdateModal.index.c3':
    '如果是新增，或者不是特定系统预设项，则不验证',
  'src.pages.Service.Services.components.ServiceItem.components.UpdateModal.index.c4':
    '服务条件',
  'src.pages.Service.Services.components.ServiceItem.components.UpdateModal.index.c7':
    '服务项目',
  'src.pages.Service.Services.components.ServiceItem.components.UpdateModal.index.c10':
    '服务频率',
  'src.pages.Service.Services.components.ServiceItem.components.UpdateModal.index.c13':
    '服务描述',
  'src.pages.Service.Services.components.ServiceItem.components.UpdateModal.index.c16':
    '可用状态',
  'src.pages.Service.Services.components.ServiceItem.index.c1': '操作',
  'src.pages.Service.Services.components.ServiceItem.index.c2':
    '确认删除该服务项目？',
  'src.pages.Service.Services.components.ServiceType.components.UpdateModal.index.c1':
    '服务类型名称',
  'src.pages.Service.Services.components.ServiceType.components.UpdateModal.index.c2':
    '服务类型描述',
  'src.pages.Service.Services.components.ServiceType.index.c1': '操作',
  'src.pages.Service.Services.components.ServiceType.index.c2':
    '确认删除该服务类型？',
  'src.pages.Service.Services.index.c1': '服务项目',
  'src.pages.Service.Services.index.c2': '服务类型',
  'src.pages.Service.ServiceUpdate.components.ServiceRecordTable.index.c1':
    '字段名称为必填项',
  'src.pages.Service.ServiceUpdate.components.ServiceRecordTable.index.c2':
    '获取问卷详情信息',
  'src.pages.Service.ServiceUpdate.components.ServiceRecordTable.index.c3':
    '监听 dataSource 变化，通过 updateData 函数将新数据传递到外层组件中',
  'src.pages.Service.ServiceUpdate.components.ServiceRecordTable.index.c4':
    '字段类型为必填项',
  'src.pages.Service.ServiceUpdate.components.ServiceRecordTable.index.c7':
    '字段类型为单选框、多选框、下拉选择时，字段配置为必填项，选项使用逗号进行分隔',
  'src.pages.Service.ServiceUpdate.components.ServiceRecordTable.index.c10':
    '删除此行？',
  'src.pages.Service.ServiceUpdate.index.c1': '服务类型',
  'src.pages.Service.ServiceUpdate.index.c2':
    '如果是支持二次编辑，则不传 editNum',
  'src.pages.Service.ServiceUpdate.index.c3': '保存设置',
  'src.pages.Service.ServiceUpdate.index.c4': '取消',
  'src.pages.Service.ServiceUpdate.index.c5':
    '如果是新增，或者不是特定系统预设项，则隐藏',
  'src.pages.Service.ServiceUpdate.index.c6':
    '如果是新增，或者不是特定系统预设项，则不验证',
  'src.pages.Service.ServiceUpdate.index.c7': '服务条件',
  'src.pages.Service.ServiceUpdate.index.c13': '项目名称',
  'src.pages.Service.ServiceUpdate.index.c19': '服务频率',
  'src.pages.Service.ServiceUpdate.index.c25': '服务描述',
  'src.pages.Service.ServiceUpdate.index.c31': '可用状态',
  'src.pages.ShoppingManage.CategoryManger.components.CategoryModal.index.c1':
    '编辑类目',
  'src.pages.ShoppingManage.CategoryManger.components.CategoryModal.index.c2':
    '商品属性：',
  'src.pages.ShoppingManage.CategoryManger.components.CategoryModal.index.c3':
    '请输入类型名称',
  'src.pages.ShoppingManage.CategoryManger.components.CategoryModal.index.c4':
    '数字越大显示越靠前',
  'src.pages.ShoppingManage.CategoryManger.components.CategoryModal.index.c5':
    '适用店铺',
  'src.pages.ShoppingManage.CategoryManger.components.CategoryModal.index.c6':
    '选择店铺，可多选，不设置则默认为所有店铺通用。',
  'src.pages.ShoppingManage.CategoryManger.components.CategoryModal.index.c7':
    '描述',
  'src.pages.ShoppingManage.CategoryManger.index.c1': '正常',
  'src.pages.ShoppingManage.CommodityManger.index.c1': '出售中',
  'src.pages.ShoppingManage.CommodityManger.index.c4': '已下架',
  'src.pages.ShoppingManage.CommodityManger.index.c7': '确认',
  'src.pages.ShoppingManage.CommodityManger.index.c10': '取消',
  'src.pages.ShoppingManage.CommodityManger.index.c13': '是否确认删除?',
  'src.pages.ShoppingManage.CommodityManger.index.c16': '选择客户端',
  'src.pages.ShoppingManage.CommodityManger.index.c22': '分享好物',
  'src.pages.ShoppingManage.CommodityOptions.index.c1': '商品基本信息设置',
  'src.pages.ShoppingManage.CommodityOptions.index.c5': '下一步 ',
  'src.pages.ShoppingManage.CommodityOptions.index.c7': '保存设置',
  'src.pages.ShoppingManage.CommodityOptions.index.c8':
    '说明：如需设置上架，则请至少上传一张图片。支持png、jpg图片，建议尺寸：100*100',
  'src.pages.ShoppingManage.CommodityOptions.index.c9':
    '说明：如需设置上架，则请至少上传一张图片。支持png、jpg图片，建议尺寸：750*360，最多上传9张，第一张默认为主图。',
  'src.pages.ShoppingManage.CommodityOptions.index.c12': '所属店铺',
  'src.pages.ShoppingManage.CommodityOptions.index.c23': '商品属性/类目：',
  'src.pages.ShoppingManage.CommodityOptions.index.c34': '请选择商品属性',
  'src.pages.ShoppingManage.CommodityOptions.index.c45': '选择对应服务套餐：',
  'src.pages.ShoppingManage.CommodityOptions.index.c56': '请选择',
  'src.pages.ShoppingManage.CommodityOptions.index.c67': '此项为必填项',
  'src.pages.ShoppingManage.CommodityOptions.index.c78': '商品标题',
  'src.pages.ShoppingManage.CommodityOptions.index.c89': '请输入商品标题',
  'src.pages.ShoppingManage.CommodityOptions.index.c100': '商品描述',
  'src.pages.ShoppingManage.CommodityOptions.index.c111':
    '说明：微信分享给好友时会显示，建议32个字以内',
  'src.pages.ShoppingManage.CommodityOptions.index.c122': '请输入一段分享描述',
  'src.pages.ShoppingManage.CommodityOptions.index.c133': '其他说明',
  'src.pages.ShoppingManage.CommodityOptions.index.c144': '请输入',
  'src.pages.ShoppingManage.CommodityOptions.index.c155': '编辑商品详情',
  'src.pages.ShoppingManage.CommodityOptions.index.c166': '上架设置',
  'src.pages.ShoppingManage.CommodityOptions.index.c177': '商品列表图：',
  'src.pages.ShoppingManage.CommodityOptions.index.c188': '商品图片：',
  'src.pages.ShoppingManage.CommodityOptions.index.c199': '上架设置：',
  'src.pages.ShoppingManage.CommodityOptions.index.c210': '商品排序：',
  'src.pages.ShoppingManage.CommodityOptions.index.c221': '数字越大越靠前显示',
  'src.pages.ShoppingManage.CommodityOptions.index.c232': '商品规格：',
  'src.pages.ShoppingManage.CommodityOptions.index.c243': '请输入商品价格',
  'src.pages.ShoppingManage.CommodityOptions.index.c254': '是否包邮',
  'src.pages.ShoppingManage.CommodityOptions.index.c265': '选择运费模板',
  'src.pages.ShoppingManage.CommodityOptions.index.c276': '运费设置:',
  'src.pages.ShoppingManage.DetailListOrder.index.c1': '订单信息',
  'src.pages.ShoppingManage.DetailListOrder.index.c3': '收货地址：',
  'src.pages.ShoppingManage.DetailListOrder.index.c4': '快递单号：',
  'src.pages.ShoppingManage.DetailListOrder.index.c7': '发货信息',
  'src.pages.ShoppingManage.DetailListOrder.index.c13': '商品信息',
  'src.pages.ShoppingManage.DetailListOrder.index.c19': '商家备注：',
  'src.pages.ShoppingManage.DetailListOrder.index.c24': '查看物流信息',
  'src.pages.ShoppingManage.DetailListOrder.index.c31': '物流动态',
  'src.pages.ShoppingManage.MallCreate.index.c1': '基础设置',
  'src.pages.ShoppingManage.MallCreate.index.c2': '请输入',
  'src.pages.ShoppingManage.MallCreate.index.c9': '提交',
  'src.pages.ShoppingManage.MallCreate.index.c14':
    '请输入正确的手机号码或固定电话，固定电话格式为“区号+号码”',
  'src.pages.ShoppingManage.MallCreate.index.c15':
    '如01088888888，中间无需标点符号连接。',
  'src.pages.ShoppingManage.MallCreate.index.c22': '店铺名称：',
  'src.pages.ShoppingManage.MallCreate.index.c43': '请输入店铺名称',
  'src.pages.ShoppingManage.MallCreate.index.c64': '所属部门',
  'src.pages.ShoppingManage.MallCreate.index.c85':
    '说明：设置后，只有该指定的所属部门和上级部门的相关员工才有关于该店铺的数据权限。',
  'src.pages.ShoppingManage.MallCreate.index.c106': '营业时间：',
  'src.pages.ShoppingManage.MallCreate.index.c127': '周一至周日，10:00-22:00',
  'src.pages.ShoppingManage.MallCreate.index.c148': '客服电话：',
  'src.pages.ShoppingManage.MallCreate.index.c169': '门店地址：',
  'src.pages.ShoppingManage.MallCreate.index.c190': '请输入门店地址',
  'src.pages.ShoppingManage.MallCreate.index.c211': '更正地址',
  'src.pages.ShoppingManage.MallCreate.index.c232': '请输入门店地址',
  'src.pages.ShoppingManage.MallCreate.index.c253':
    '注：手动输入修改地址后，并不影响地图坐标定位，如需更换坐标点，请在地图中重新选点。',
  'src.pages.ShoppingManage.MallCreate.index.c274': '店铺Logo：',
  'src.pages.ShoppingManage.MallCreate.index.c295':
    '说明：支持png、jpg图片，建议尺寸：128*128',
  'src.pages.ShoppingManage.MallCreate.index.c316': '店铺图片：',
  'src.pages.ShoppingManage.MallCreate.index.c337':
    '说明：支持png、jpg图片，建议尺寸：375*200 ，最多上传9张，第一张默认为主图',
  'src.pages.ShoppingManage.MallCreate.index.c358': '店铺简介',
  'src.pages.ShoppingManage.MallCreate.index.c379': '请输入简介说明',
  'src.pages.ShoppingManage.MallCreate.index.c400': '商城设置',
  'src.pages.ShoppingManage.MallCreate.index.c421': '商城可用状态：',
  'src.pages.ShoppingManage.MallCreate.index.c442':
    '说明：店铺的商城禁用后，隐藏客户端该店铺的商城入口',
  'src.pages.ShoppingManage.MallCreate.index.c505': '订单自动完成时间：',
  'src.pages.ShoppingManage.MallCreate.index.c526':
    '说明：设置后，订单的物流状态变为“收货”后，买家未在此时间内确认收货，订单的状态自动由待收货变为已完成。',
  'src.pages.ShoppingManage.MallCreate.index.c547': '预约设置',
  'src.pages.ShoppingManage.MallCreate.index.c568': '预约可用状态：',
  'src.pages.ShoppingManage.MallCreate.index.c589':
    '说明：店铺预约禁用后，在客户端隐藏该店铺的预约入口',
  'src.pages.ShoppingManage.MallCreate.index.c610': '订单处理方式：',
  'src.pages.ShoppingManage.MallCreate.index.c631':
    '说明：预约成功后，自动生成对应的任务，通过处理任务来处理订单，订单状态和任务状态同步',
  'src.pages.ShoppingManage.MallCreate.index.c652': '订单自动关闭时间：',
  'src.pages.ShoppingManage.MallCreate.index.c673':
    '说明：设置后，买家未在此时间内付款，待付款订单将自动关闭，状态由待付款变为已关闭',
  'src.pages.ShoppingManage.MallCreate.index.c694': '预约提醒：',
  'src.pages.ShoppingManage.MallCreate.index.c715':
    '说明：通过短信和微信提前通知客户。',
  'src.pages.ShoppingManage.MallFreight.components.FreightModal.index.c1':
    '请输入模板名称',
  'src.pages.ShoppingManage.MallFreight.components.FreightModal.index.c2':
    '请输入起计件数',
  'src.pages.ShoppingManage.MallFreight.components.FreightModal.index.c3':
    '请输入运费',
  'src.pages.ShoppingManage.MallFreight.components.FreightModal.index.c4':
    '请输入续件件数',
  'src.pages.ShoppingManage.MallFreight.components.FreightModal.index.c5':
    '请输入续费',
  'src.pages.ShoppingManage.MallFreight.index.c1': '确定删除吗？',
  'src.pages.ShoppingManage.MallFreight.index.c2':
    '表单搜索项会从 params 传入，传递给后端接口。',
  'src.pages.ShoppingManage.MallFreight.index.c3': '确定',
  'src.pages.ShoppingManage.MallFreight.index.c5': '取消',
  'src.pages.ShoppingManage.MallFreight.index.c7': '运费模板',
  'src.pages.ShoppingManage.MallShop.index.c3': '删除确认',
  'src.pages.ShoppingManage.MallShop.index.c5': '正常',
  'src.pages.ShoppingManage.MallShop.index.c9': '是否删除？',
  'src.pages.ShoppingManage.MallShop.index.c13': '确认',
  'src.pages.ShoppingManage.MallShop.index.c17': '取消',
  'src.pages.ShoppingManage.OrderManage.components.OrderManageItemModel.index.c1':
    '是否确认取消订单?',
  'src.pages.ShoppingManage.OrderManage.components.OrderManageItemModel.index.c7':
    '发货',
  'src.pages.ShoppingManage.OrderManage.components.OrderManageItemModel.index.c13':
    '发货方式',
  'src.pages.ShoppingManage.OrderManage.components.OrderManageItemModel.index.c19':
    '快递公司',
  'src.pages.ShoppingManage.OrderManage.components.OrderManageItemModel.index.c25':
    '请选择快递公司',
  'src.pages.ShoppingManage.OrderManage.components.OrderManageItemModel.index.c31':
    '请输入快递单号',
  'src.pages.ShoppingManage.OrderManage.components.OrderManageItemModel.index.c37':
    '审核',
  'src.pages.ShoppingManage.OrderManage.components.OrderManageItemModel.index.c43':
    '服务套餐',
  'src.pages.ShoppingManage.OrderManage.components.OrderManageItemModel.index.c49':
    '服务团队',
  'src.pages.ShoppingManage.OrderManage.index.c1': '是否确认取消订单?',
  'src.pages.ShoppingManage.OrderManage.index.c5': '发货',
  'src.pages.ShoppingManage.OrderManage.index.c9': '发货方式',
  'src.pages.ShoppingManage.OrderManage.index.c13': '快递公司',
  'src.pages.ShoppingManage.OrderManage.index.c17': '请选择快递公司',
  'src.pages.ShoppingManage.OrderManage.index.c21': '请输入快递单号',
  'src.pages.ShoppingManage.OrderManage.index.c25': '审核',
  'src.pages.ShoppingManage.OrderManage.index.c29': '服务套餐',
  'src.pages.ShoppingManage.OrderManage.index.c33': '服务团队',
  'src.pages.ShoppingManage.PromoteOrder.index.c1': '姓名或登录账号',
  'src.pages.ShoppingManage.PromoteOrder.index.c2': '详情的modal',
  'src.pages.SmsManage.SmsQuery.index.c1': '系统',
  'src.pages.SmsManage.SmsQuery.index.c2': '手机号码',
  'src.pages.SmsManage.SmsQuery.index.c3': '输入关键词',
  'src.pages.SmsManage.SmsQuery.index.c4': '短信内容',
  'src.pages.SmsManage.SmsQuery.index.c5': '共 {total} 条记录',
  'src.pages.SmsManage.SmsQuery.index.c6': '扣费条数',
  'src.pages.SmsManage.SmsQuery.index.c7': '提交时间',
  'src.pages.SmsManage.SmsQuery.index.c8': '发送时间',
  'src.pages.SmsManage.SmsQuery.index.c9': '发送状态',
  'src.pages.SmsManage.SmsQuery.index.c10': '发送成功',
  'src.pages.SmsManage.SmsQuery.index.c11': '发送失败',
  'src.pages.SmsManage.SmsQuery.index.c12': '正在发送',
  'src.pages.SmsManage.SmsQuery.index.c13': '状态说明',
  'src.pages.SmsManage.SmsQuery.index.c14': '操作人',
  'src.pages.SmsManage.SmsGroup.index.c1': '系统',
  'src.pages.SmsManage.SmsGroup.index.c2': '取消发送成功',
  'src.pages.SmsManage.SmsGroup.index.c3': '批次号',
  'src.pages.SmsManage.SmsGroup.index.c4': '短信内容',
  'src.pages.SmsManage.SmsGroup.index.c5': '输入关键词',
  'src.pages.SmsManage.SmsGroup.index.c6': '发送号码数',
  'src.pages.SmsManage.SmsGroup.index.c7': '状态',
  'src.pages.SmsManage.SmsGroup.index.c8': '提交状态',
  'src.pages.SmsManage.SmsGroup.index.c9': '已提交',
  'src.pages.SmsManage.SmsGroup.index.c10': '待提交',
  'src.pages.SmsManage.SmsGroup.index.c11': '已取消',
  'src.pages.SmsManage.SmsGroup.index.c12': '提交时间',
  'src.pages.SmsManage.SmsGroup.index.c13': '手机号码',
  'src.pages.SmsManage.SmsGroup.index.c14': '备注',
  'src.pages.SmsManage.SmsGroup.index.c15': '操作人',
  'src.pages.SmsManage.SmsGroup.index.c16': '操作',
  'src.pages.SmsManage.SmsGroup.index.c17': '查询',
  'src.pages.SmsManage.SmsGroup.index.c18': '编辑',
  'src.pages.SmsManage.SmsGroup.index.c19': '重发',
  'src.pages.SmsManage.SmsGroup.index.c20': '确认要取消发送？',
  'src.pages.SmsManage.SmsGroup.index.c21': '取消',
  'src.pages.SmsManage.SmsGroup.index.c22': '共 {total} 条记录',
  'src.pages.SmsManage.SmsGroup.index.c23': '发送短信',
  'src.pages.SmsManage.SmsGroup.UpdateGroupSend.index.c1': '发送',
  'src.pages.SmsManage.SmsGroup.UpdateGroupSend.index.c2': '编辑',
  'src.pages.SmsManage.SmsGroup.UpdateGroupSend.index.c3': '重发',
  'src.pages.SmsManage.SmsGroup.UpdateGroupSend.index.c4': '{action}短信',
  'src.pages.SmsManage.SmsGroup.UpdateGroupSend.index.c5': '成功',
  'src.pages.SmsManage.SmsGroup.UpdateGroupSend.index.c6': '失败，请稍后重试',
  'src.pages.SmsManage.SmsGroup.UpdateGroupSend.index.c7': '手机号码',
  'src.pages.SmsManage.SmsGroup.UpdateGroupSend.index.c8':
    '请输入手机号码,多个号码请用回车键分隔',
  'src.pages.SmsManage.SmsGroup.UpdateGroupSend.index.c9': '请输入手机号码',
  'src.pages.SmsManage.SmsGroup.UpdateGroupSend.index.c10': '从客户列表选择',
  'src.pages.SmsManage.SmsGroup.UpdateGroupSend.index.c11': '短信内容',
  'src.pages.SmsManage.SmsGroup.UpdateGroupSend.index.c12':
    '短信签名为【{signature}】，无需在短信内容里输入。',
  'src.pages.SmsManage.SmsGroup.UpdateGroupSend.index.c13': '请输入短信内容',
  'src.pages.SmsManage.SmsGroup.UpdateGroupSend.index.c14': '从模板库选择',
  'src.pages.SmsManage.SmsGroup.UpdateGroupSend.index.c15': '备注',
  'src.pages.SmsManage.SmsGroup.UpdateGroupSend.index.c16':
    '可备注短信发送的目的',
  'src.pages.SmsManage.SmsGroup.UpdateGroupSend.index.c17': '发送时间',
  'src.pages.SmsManage.SmsGroup.UpdateGroupSend.index.c18': '立即发送',
  'src.pages.SmsManage.SmsGroup.UpdateGroupSend.index.c19': '定时发送',
  'src.pages.SmsManage.SmsGroup.UpdateGroupSend.index.c20': '请选择客户',
  'src.pages.SmsManage.SmsGroup.UpdateGroupSend.index.c21': '插入成功',
  'src.pages.SmsManage.SmsGroup.ClientList.index.c1': '80岁以上',
  'src.pages.SmsManage.SmsGroup.ClientList.index.c2': '60~79岁',
  'src.pages.SmsManage.SmsGroup.ClientList.index.c3': '50~59岁',
  'src.pages.SmsManage.SmsGroup.ClientList.index.c4': '30~49岁',
  'src.pages.SmsManage.SmsGroup.ClientList.index.c5': '29岁以下',
  'src.pages.SmsManage.SmsGroup.ClientList.index.c6': '我的客户',
  'src.pages.SmsManage.SmsGroup.ClientList.index.c7': '部门客户',
  'src.pages.SmsManage.SmsGroup.ClientList.index.c8': '潜在客户',
  'src.pages.SmsManage.SmsGroup.ClientList.index.c9': '客户',
  'src.pages.SmsManage.SmsGroup.ClientList.index.c10': '客户信息',
  'src.pages.SmsManage.SmsGroup.ClientList.index.c11':
    '客户姓名、档案号、手机号、身份证号',
  'src.pages.SmsManage.SmsGroup.ClientList.index.c12': '岁',
  'src.pages.SmsManage.SmsGroup.ClientList.index.c13': '手机号码',
  'src.pages.SmsManage.SmsGroup.ClientList.index.c14': '客户标签',
  'src.pages.SmsManage.SmsGroup.ClientList.index.c15': '会员等级',
  'src.pages.SmsManage.SmsGroup.ClientList.index.c16': '客户等级',
  'src.pages.SmsManage.SmsGroup.ClientList.index.c17': '所属服务团队',
  'src.pages.SmsManage.SmsGroup.ClientList.index.c18': '服务团队',
  'src.pages.SmsManage.SmsGroup.ClientList.index.c19': '服务套餐',
  'src.pages.SmsManage.SmsGroup.ClientList.index.c20': '性别',
  'src.pages.SmsManage.SmsGroup.ClientList.index.c21': '男',
  'src.pages.SmsManage.SmsGroup.ClientList.index.c22': '女',
  'src.pages.SmsManage.SmsGroup.ClientList.index.c23': '年龄段',
  'src.pages.SmsManage.SmsGroup.ClientList.index.c24': '提交选择',
  'src.pages.SmsManage.SmsGroup.ClientList.index.c25': '请选择',
  'src.pages.SmsManage.SmsGroup.TemplateList.index.c1': '编号',
  'src.pages.SmsManage.SmsGroup.TemplateList.index.c2': '名称',
  'src.pages.SmsManage.SmsGroup.TemplateList.index.c3': '短信模板',
  'src.pages.SmsManage.SmsGroup.TemplateList.index.c4': '操作',
  'src.pages.SmsManage.SmsGroup.TemplateList.index.c5': '插入',
  'src.pages.SmsManage.SmsGroup.TemplateList.index.c6': '从模板库选择',
  'src.pages.SmsManage.SmsGroup.TemplateList.index.c7': '关闭',
  'src.pages.SmsManage.SmsRecord.index.c1': '手机号码',
  'src.pages.SmsManage.SmsRecord.index.c2': '短信内容',
  'src.pages.SmsManage.SmsRecord.index.c3': '扣费条数',
  'src.pages.SmsManage.SmsRecord.index.c4': '提交时间',
  'src.pages.SmsManage.SmsRecord.index.c5': '发送时间',
  'src.pages.SmsManage.SmsRecord.index.c6': '发送状态',
  'src.pages.SmsManage.SmsRecord.index.c7': '发送成功',
  'src.pages.SmsManage.SmsRecord.index.c8': '发送失败',
  'src.pages.SmsManage.SmsRecord.index.c9': '正在发送',
  'src.pages.SmsManage.SmsRecord.index.c10': '状态说明',
  'src.pages.SmsManage.SmsRecord.index.c11': '操作人',
  'src.pages.SmsManage.SmsRecord.index.c12':
    '当前查询批次：{batchId} 的短信群发记录。',
  'src.pages.SmsManage.SmsRecord.index.c13': '查看全部',
  'src.pages.Statistics.Customer.components.CustomerTagLevelCard.index.c1':
    '客户标签',
  'src.pages.Statistics.Customer.components.CustomerTagLevelCard.index.c2':
    '初始化 echart',
  'src.pages.Statistics.Customer.components.CustomerTagLevelCard.index.c3':
    '初始化 echart 实例',
  'src.pages.Statistics.Customer.components.CustomerTagLevelCard.index.c4':
    '清除 echart 实例',
  'src.pages.Statistics.Customer.components.CustomerTagLevelCard.index.c5':
    '客户等级',
  'src.pages.Statistics.Customer.components.StatisticsCardBox.index.c1':
    '绑定服务团队的客户判定为服务客户',
  'src.pages.Statistics.Customer.components.StatisticsCardBox.index.c2':
    '近三十天新增服务客户数量',
  'src.pages.Statistics.Customer.components.StatisticsCardBox.index.c3':
    '近30天服务已到期的客户数量，包括服务套餐“已过期”“已取消”，或者服务客户被取消了绑定服务团队',
  'src.pages.Statistics.Customer.components.StatisticsCardBox.index.c4':
    '已建档，但未绑定服务团队的客户',
  'src.pages.Statistics.Service.components.SatisfactionCard.index.c1':
    '团队满意度',
  'src.pages.Statistics.Service.components.SatisfactionCard.index.c2':
    '初始化 echart',
  'src.pages.Statistics.Service.components.SatisfactionCard.index.c3':
    '初始化 echart 实例',
  'src.pages.Statistics.Service.components.SatisfactionCard.index.c4':
    '清除 echart 实例',
  'src.pages.Statistics.Service.components.SatisfactionCard.index.c5':
    '图表、表格',
  'src.pages.Statistics.Service.components.SatisfactionCard.index.c6':
    '个人满意度',
  'src.pages.Statistics.Service.components.ServiceItemCard.index.c1':
    '请选择服务分类',
  'src.pages.Statistics.Service.components.ServiceTypeCard.index.c1': '请选择',
  'src.pages.Statistics.Service.components.StatisticsCardList.index.c3':
    '健管人员数',
  'src.pages.Statistics.Service.components.StatisticsCardList.index.c10':
    '提示文字',
  'src.pages.Statistics.Service.components.WorkEfficientCard.index.c1':
    '团队工作效率',
  'src.pages.Statistics.Service.components.WorkEfficientCard.index.c2':
    '初始化 echart 实例',
  'src.pages.Statistics.Service.components.WorkEfficientCard.index.c3':
    '计算 按时完成 = 实际已完成 * 未逾期占比、逾期完成 = 实际已完成 * 逾期占比、未完成的值 = 计划任务待处理 + 计划任务处理中',
  'src.pages.Statistics.Service.components.WorkEfficientCard.index.c4':
    '统计卡片',
  'src.pages.Statistics.Service.components.WorkEfficientCard.index.c5': '图表',
  'src.pages.Statistics.Service.components.WorkEfficientCard.index.c6': '表格',
  'src.pages.Statistics.Service.components.WorkEfficientCard.index.c7':
    '个人工作效率',
  'src.pages.Statistics.Service.components.ServiceStatistics.index.c1': '1月',
  'src.pages.Statistics.Service.components.ServiceStatistics.index.c2': '2月',
  'src.pages.Statistics.Service.components.ServiceStatistics.index.c3': '3月',
  'src.pages.Statistics.Service.components.ServiceStatistics.index.c4': '4月',
  'src.pages.Statistics.Service.components.ServiceStatistics.index.c5': '5月',
  'src.pages.Statistics.Service.components.ServiceStatistics.index.c6': '6月',
  'src.pages.Statistics.Service.components.ServiceStatistics.index.c7': '7月',
  'src.pages.Statistics.Service.components.ServiceStatistics.index.c8': '8月',
  'src.pages.Statistics.Service.components.ServiceStatistics.index.c9': '9月',
  'src.pages.Statistics.Service.components.ServiceStatistics.index.c10': '10月',
  'src.pages.Statistics.Service.components.ServiceStatistics.index.c11': '11月',
  'src.pages.Statistics.Service.components.ServiceStatistics.index.c12': '12月',
  'src.pages.Statistics.Service.components.ServiceStatistics.index.c21':
    '团队服务统计',
  'src.pages.Statistics.Service.components.ServiceStatistics.index.c22':
    '个人服务统计',
  'src.pages.System.EmployerManage.AuthSetting.index.c1': '部门分配',
  'src.pages.System.EmployerManage.AuthSetting.index.c2':
    '树节点选择，点击一个节点时',
  'src.pages.System.EmployerManage.AuthSetting.index.c3':
    '如果是【勾选】操作，则将子节点和父节点都勾上',
  'src.pages.System.EmployerManage.AuthSetting.index.c4':
    '如果是【取消勾选】，则取消本节点和子节点选中，不操作父节点',
  'src.pages.System.EmployerManage.AuthSetting.index.c5': '获取子节点 keys',
  'src.pages.System.EmployerManage.AuthSetting.index.c6': '当前点击节点 key',
  'src.pages.System.EmployerManage.AuthSetting.index.c7': '选中操作',
  'src.pages.System.EmployerManage.AuthSetting.index.c8': '去重后塞入',
  'src.pages.System.EmployerManage.AuthSetting.index.c9': '取消选中操作',
  'src.pages.System.EmployerManage.AuthSetting.index.c10': '确定',
  'src.pages.System.EmployerManage.AuthSetting.index.c19': '取消',
  'src.pages.System.EmployerManage.AuthSetting.index.c28':
    '为员工设置部门的管理权限，设置了之后员工可以查阅或管理对应部门的下属客户和服务人员。',
  'src.pages.System.EmployerManage.index.c1': '修改密码',
  'src.pages.System.EmployerManage.index.c2': '部门分配',
  'src.pages.System.EmployerManage.index.c4': '编辑',
  'src.pages.System.EmployerManage.index.c5': '部门分配',
  'src.pages.System.EmployerManage.index.c6': '重设密码',
  'src.pages.System.EmployerManage.index.c7': '更多 ',
  'src.pages.System.EmployerManage.index.c8': '新增员工',
  'src.pages.System.EmployerManage.index.c9': '请输入新密码',
  'src.pages.System.EmployerManage.index.c10': '请输入旧密码',
  'src.pages.System.EmployerManage.InfoForm.index.c1': '员工姓名',
  'src.pages.System.EmployerManage.InfoForm.index.c2': '请输入',
  'src.pages.System.EmployerManage.InfoForm.index.c3':
    '请输入正确格式的联系电话',
  'src.pages.System.EmployerManage.InfoForm.index.c4':
    '请输入正确的手机号码或固定电话，固定电话格式为“区号+号码”',
  'src.pages.System.EmployerManage.InfoForm.index.c5':
    '如01088888888，中间无需标点符号连接。',
  'src.pages.System.EmployerManage.InfoForm.index.c7': '创建新团队',
  'src.pages.System.EmployerManage.InfoForm.index.c13': '登录名',
  'src.pages.System.EmployerManage.InfoForm.index.c25': '所属部门',
  'src.pages.System.EmployerManage.InfoForm.index.c37': '联系电话',
  'src.pages.System.EmployerManage.InfoForm.index.c49': '出生年月',
  'src.pages.System.EmployerManage.InfoForm.index.c8': '上一步',
  'src.pages.System.EmployerManage.InfoForm.index.c9': '完成',
  'src.pages.System.EmployerManage.InfoForm.index.c11': '下一步',
  'src.pages.System.EmployerManage.InfoForm.index.c61': '性别',
  'src.pages.System.EmployerManage.InfoForm.index.c73': '角色设置',
  'src.pages.System.EmployerManage.InfoForm.index.c85': '岗位性质',
  'src.pages.System.EmployerManage.InfoForm.index.c97': '服务团队',
  'src.pages.System.EmployerManage.InfoForm.index.c109': '部门分配',
  'src.pages.System.EmployerManage.InfoForm.index.c121':
    '可设置该账号可管理的机构/部门，不设置则默认为仅能查看本人的客户和任务。',
  'src.pages.System.EmployerManage.InfoForm.index.c133': '请选择部门',
  'src.pages.System.EmployerManage.InfoForm.index.c145': '账号状态',
  'src.pages.System.EmployerManage.InfoForm.index.c157': '基本信息',
  'src.pages.System.EmployerManage.InfoForm.index.c169': '个人简介',
  'src.pages.System.EmployerManage.InfoForm.index.c181': '部门分配',
  'src.pages.System.EmployerManage.InfoForm.index.c193': '登录名已经被注册',
  'src.pages.System.OrgManage.components.UpdateLogo.c1': '部门LOGO设置',
  'src.pages.System.OrgManage.components.UpdateLogo.c3':
    '显示于系统界面左上角建议尺寸300*100 ',
  'src.pages.System.OrgManage.components.UpdateLogo.c4':
    '显示于健康评估报告打印版封面，建议尺寸300*300',
  'src.pages.System.OrgManage.components.UpdateLogo.c5': '部门名称',
  'src.pages.System.OrgManage.components.UpdateLogo.c9': '系统界面LOGO',
  'src.pages.System.OrgManage.components.UpdateLogo.c13': '健康评估报告LOGO',
  'src.pages.System.OrgManage.components.UpdateOrg.c1': '父级id',
  'src.pages.System.OrgManage.components.UpdateOrg.c4': '父级部门',
  'src.pages.System.OrgManage.components.UpdateOrg.c7': '部门名称',
  'src.pages.System.OrgManage.components.UpdateOrg.c10': '简称',
  'src.pages.System.OrgManage.components.UpdateOrg.c13': '简拼关键词',
  'src.pages.System.OrgManage.components.UpdateOrg.c16': '描述',
  'src.pages.System.OrgManage.components.UpdateOrg.c19': '排序',
  'src.pages.System.OrgManage.index.c1': '确认删除该部门？',
  'src.pages.System.OrgManage.index.c2': '打开部门编辑 Modal',
  'src.pages.System.OrgManage.index.c3': '操作类型',
  'src.pages.System.OrgManage.index.c4': '当前选择的行',
  'src.pages.System.OrgManage.index.c5':
    '如果是新增子用户，则将 parentId 改成 id',
  'src.pages.System.OrgManage.index.c6': '打开 logo 编辑 Modal',
  'src.pages.System.OrgManage.index.c7': '当前选择行',
  'src.pages.System.OrgManage.index.c8': '删除部门',
  'src.pages.System.OrgManage.index.c9': '部门ID',
  'src.pages.System.OrgManage.index.c10': '处理部门父级名称，处理子部门排序',
  'src.pages.System.OrgManage.index.c11': '部门',
  'src.pages.System.OrgManage.index.c12': '部门',
  'src.pages.System.OrgManage.index.c13': '名称',
  'src.pages.System.OrgManage.index.c14': '排序',
  'src.pages.System.RoleAdd.index.c1': '角色名称',
  'src.pages.System.RoleAdd.index.c2': '将 button 处理成 TreeType 格式',
  'src.pages.System.RoleAdd.index.c3':
    '将 menu 和 subPage 处理成 TreeType 格式',
  'src.pages.System.RoleAdd.index.c4': '将 tree 处理成接口需要的格式',
  'src.pages.System.RoleAdd.index.c5': '获取所有的 name，给 Tree 组件使用',
  'src.pages.System.RoleAdd.index.c6': '是否只获取 permitted = true 的',
  'src.pages.System.RoleAdd.index.c7': '获取本次操作节点的 children key',
  'src.pages.System.RoleAdd.index.c8': '从接口获取的原始树',
  'src.pages.System.RoleAdd.index.c9': '组件需要用到的格式树',
  'src.pages.System.RoleAdd.index.c10': '树节点选择，点击一个节点时',
  'src.pages.System.RoleAdd.index.c11':
    '如果是【勾选】操作，则将子节点和父节点都勾上',
  'src.pages.System.RoleAdd.index.c12':
    '如果是【取消勾选】，则取消本节点和子节点选中，不操作父节点',
  'src.pages.System.RoleAdd.index.c13': '获取子节点 keys',
  'src.pages.System.RoleAdd.index.c14': '当前点击节点 key',
  'src.pages.System.RoleAdd.index.c15': '选中操作',
  'src.pages.System.RoleAdd.index.c16': '获取父节点 keys',
  'src.pages.System.RoleAdd.index.c17': '去重后塞入',
  'src.pages.System.RoleAdd.index.c18': '取消选中操作',
  'src.pages.System.RoleAdd.index.c19': '默认展开全部',
  'src.pages.System.RoleAdd.index.c20': '默认展开第一层',
  'src.pages.System.RoleAdd.index.c21': '默认勾选',
  'src.pages.System.RoleAdd.index.c22': '表单塞值',
  'src.pages.System.RoleAdd.index.c23': '取消',
  'src.pages.System.RoleAdd.index.c24': '提交',
  'src.pages.System.RoleAdd.index.c25': '请输入角色名称',
  'src.pages.System.RoleAdd.index.c49': '角色描述',
  'src.pages.System.RoleAdd.index.c73': '请输入角色描述',
  'src.pages.System.RoleManage.index.c1': '操作',
  'src.pages.System.RoleManage.index.c2': '确认删除该角色？',
  'src.pages.SystemNotification.Announcement.index.c1': '推送对象类型',
  'src.pages.SystemNotification.Announcement.index.c2': '客户',
  'src.pages.SystemNotification.Announcement.index.c3': '管理员',
  'src.pages.SystemNotification.Announcement.index.c4': '推送对象',
  'src.pages.SystemNotification.Announcement.index.c5': '全部',
  'src.pages.SystemNotification.Announcement.index.c6': '管理员',
  'src.pages.SystemNotification.Announcement.index.c7': '客户',
  'src.pages.SystemNotification.Announcement.index.c8': '搜索姓名或手机号',
  'src.pages.SystemNotification.Announcement.index.c9': '公告标题',
  'src.pages.SystemNotification.Announcement.index.c10': '公告内容',
  'src.pages.SystemNotification.Announcement.index.c11': '消息内容',
  'src.pages.SystemNotification.Announcement.index.c12': '搜索标题和内容',
  'src.pages.SystemNotification.Announcement.index.c13': '推送状态',
  'src.pages.SystemNotification.Announcement.index.c14': '待推送',
  'src.pages.SystemNotification.Announcement.index.c15': '已推送',
  'src.pages.SystemNotification.Announcement.index.c16': '失败',
  'src.pages.SystemNotification.Announcement.index.c17': '操作人',
  'src.pages.SystemNotification.Announcement.index.c18': '推送时间',
  'src.pages.SystemNotification.Announcement.index.c19': '共 {total} 条记录',
  'src.pages.SystemNotification.Announcement.index.c20': '发送公告',
  'src.pages.SystemNotification.Announcement.UpdateAnnouncementSend.index.c1':
    '发送公告',
  'src.pages.SystemNotification.Announcement.UpdateAnnouncementSend.index.c2':
    '请选择推荐对象',
  'src.pages.SystemNotification.Announcement.UpdateAnnouncementSend.index.c3':
    '请选择推荐管理员',
  'src.pages.SystemNotification.Announcement.UpdateAnnouncementSend.index.c4':
    '请选择推荐客户',
  'src.pages.SystemNotification.Announcement.UpdateAnnouncementSend.index.c5':
    '请选择推荐角色',
  'src.pages.SystemNotification.Announcement.UpdateAnnouncementSend.index.c6':
    '请选择推荐团队',
  'src.pages.SystemNotification.Announcement.UpdateAnnouncementSend.index.c7':
    '请选择商品',
  'src.pages.SystemNotification.Announcement.UpdateAnnouncementSend.index.c8':
    '请选择预约服务项目',
  'src.pages.SystemNotification.Announcement.UpdateAnnouncementSend.index.c9':
    '请选择健康资讯',
  'src.pages.SystemNotification.Announcement.UpdateAnnouncementSend.index.c10':
    '成功',
  'src.pages.SystemNotification.Announcement.UpdateAnnouncementSend.index.c11':
    '失败，请稍后重试',
  'src.pages.SystemNotification.Announcement.UpdateAnnouncementSend.index.c12':
    '选择推荐对象',
  'src.pages.SystemNotification.Announcement.UpdateAnnouncementSend.index.c13':
    '管理员',
  'src.pages.SystemNotification.Announcement.UpdateAnnouncementSend.index.c14':
    '客户',
  'src.pages.SystemNotification.Announcement.UpdateAnnouncementSend.index.c15':
    '请选择',
  'src.pages.SystemNotification.Announcement.UpdateAnnouncementSend.index.c16':
    '全体人员',
  'src.pages.SystemNotification.Announcement.UpdateAnnouncementSend.index.c17':
    '按角色选择',
  'src.pages.SystemNotification.Announcement.UpdateAnnouncementSend.index.c18':
    '按团队选择',
  'src.pages.SystemNotification.Announcement.UpdateAnnouncementSend.index.c19':
    '按人员选择',
  'src.pages.SystemNotification.Announcement.UpdateAnnouncementSend.index.c20':
    '全部服务客户',
  'src.pages.SystemNotification.Announcement.UpdateAnnouncementSend.index.c21':
    '全部潜在客户',
  'src.pages.SystemNotification.Announcement.UpdateAnnouncementSend.index.c22':
    '全部客户',
  'src.pages.SystemNotification.Announcement.UpdateAnnouncementSend.index.c23':
    '自定义',
  'src.pages.SystemNotification.Announcement.UpdateAnnouncementSend.index.c24':
    '请选择角色',
  'src.pages.SystemNotification.Announcement.UpdateAnnouncementSend.index.c25':
    '请选择团队',
  'src.pages.SystemNotification.Announcement.UpdateAnnouncementSend.index.c26':
    '请从管理员列表选择',
  'src.pages.SystemNotification.Announcement.UpdateAnnouncementSend.index.c27':
    '请从客户列表选择',
  'src.pages.SystemNotification.Announcement.UpdateAnnouncementSend.index.c28':
    '从管理员列表选择',
  'src.pages.SystemNotification.Announcement.UpdateAnnouncementSend.index.c29':
    '从客户列表选择',
  'src.pages.SystemNotification.Announcement.UpdateAnnouncementSend.index.c30':
    '公告标题',
  'src.pages.SystemNotification.Announcement.UpdateAnnouncementSend.index.c31':
    '请输入公告标题',
  'src.pages.SystemNotification.Announcement.UpdateAnnouncementSend.index.c32':
    '公告内容',
  'src.pages.SystemNotification.Announcement.UpdateAnnouncementSend.index.c33':
    '请输入公告内容',
  'src.pages.SystemNotification.Announcement.UpdateAnnouncementSend.index.c34':
    '链接设置',
  'src.pages.SystemNotification.Announcement.UpdateAnnouncementSend.index.c35':
    '系统预设',
  'src.pages.SystemNotification.Announcement.UpdateAnnouncementSend.index.c36':
    '自定义页面',
  'src.pages.SystemNotification.Announcement.UpdateAnnouncementSend.index.c37':
    '其他',
  'src.pages.SystemNotification.Announcement.UpdateAnnouncementSend.index.c38':
    '请选择页面',
  'src.pages.SystemNotification.Announcement.UpdateAnnouncementSend.index.c39':
    '请输入链接地址',
  'src.pages.SystemNotification.Announcement.UpdateAnnouncementSend.index.c40':
    '发送时间',
  'src.pages.SystemNotification.Announcement.UpdateAnnouncementSend.index.c41':
    '立即发送',
  'src.pages.SystemNotification.Announcement.UpdateAnnouncementSend.index.c42':
    '定时发送',
  'src.pages.SystemNotification.Announcement.UpdateAnnouncementSend.index.c43':
    '请选择客户',
  'src.pages.SystemNotification.Announcement.UpdateAnnouncementSend.index.c44':
    '请选择管理员',
  'src.pages.SystemNotification.Announcement.AdministratorList.index.c1':
    '姓名',
  'src.pages.SystemNotification.Announcement.AdministratorList.index.c2':
    '客户信息',
  'src.pages.SystemNotification.Announcement.AdministratorList.index.c3':
    '输入姓名或账号',
  'src.pages.SystemNotification.Announcement.AdministratorList.index.c4':
    '账号',
  'src.pages.SystemNotification.Announcement.AdministratorList.index.c5':
    '角色',
  'src.pages.SystemNotification.Announcement.AdministratorList.index.c6':
    '所属服务团队',
  'src.pages.SystemNotification.Announcement.AdministratorList.index.c7':
    '团队',
  'src.pages.SystemNotification.Announcement.AdministratorList.index.c8':
    '请选择',
  'src.pages.SystemNotification.Announcement.AdministratorList.index.c9':
    '部门',
  'src.pages.SystemNotification.Announcement.AdministratorList.index.c10':
    '选择管理员',
  'src.pages.SystemNotification.Announcement.AdministratorList.index.c11':
    '提交选择',
  'src.pages.SystemNotification.Notice.index.c1': '推送对象类型',
  'src.pages.SystemNotification.Notice.index.c2': '客户',
  'src.pages.SystemNotification.Notice.index.c3': '管理员',
  'src.pages.SystemNotification.Notice.index.c4': '推送对象',
  'src.pages.SystemNotification.Notice.index.c5': '全部',
  'src.pages.SystemNotification.Notice.index.c6': '搜索姓名或手机号',
  'src.pages.SystemNotification.Notice.index.c7': '标题',
  'src.pages.SystemNotification.Notice.index.c8': '内容',
  'src.pages.SystemNotification.Notice.index.c9': '消息内容',
  'src.pages.SystemNotification.Notice.index.c10': '搜索标题和内容',
  'src.pages.SystemNotification.Notice.index.c11': '推送状态',
  'src.pages.SystemNotification.Notice.index.c12': '待推送',
  'src.pages.SystemNotification.Notice.index.c13': '已推送',
  'src.pages.SystemNotification.Notice.index.c14': '失败',
  'src.pages.SystemNotification.Notice.index.c15': '操作人',
  'src.pages.SystemNotification.Notice.index.c16': '推送时间',
  'src.pages.SystemNotification.Notice.index.c17': '共 {total} 条记录',

  'src.pages.SystemNotification.OATemplateMessage.index.c1': '推送时间',
  'src.pages.SystemNotification.OATemplateMessage.index.c2': '推送对象',
  'src.pages.SystemNotification.OATemplateMessage.index.c3': '模版标题',
  'src.pages.SystemNotification.OATemplateMessage.index.c4': '推送对象',
  'src.pages.SystemNotification.OATemplateMessage.index.c6': '推送内容',
  'src.pages.SystemNotification.OATemplateMessage.index.c8': '模版内容',
  'src.pages.SystemNotification.OATemplateMessage.index.c9': '推送状态',
  'src.pages.SystemNotification.OATemplateMessage.index.c9.1': '已推送',
  'src.pages.SystemNotification.OATemplateMessage.index.c9.2': '待推送',
  'src.pages.SystemNotification.OATemplateMessage.index.c10': '系统',
  'src.pages.SystemNotification.OATemplateMessage.index.c11': '发送时间',
  'src.pages.SystemNotification.OATemplateMessage.index.c12': '查看',
  'src.pages.SystemNotification.OATemplateMessage.index.c13': '编辑',
  'src.pages.SystemNotification.OATemplateMessage.index.c14': '操作',
  'src.pages.SystemNotification.OATemplateMessage.index.c15':
    '共 {total} 条记录',
  'src.pages.SystemNotification.OATemplateMessage.index.c16': '发送消息',
  'src.pages.SystemNotification.OATemplateMessage.index.c17': '推送人',

  // new
  'src.pages.SystemNotification.OATemplateMessage.index.c18': '公众号模版消息',
  'src.pages.SystemNotification.OATemplateMessage.index.c19': '发送',
  'src.pages.SystemNotification.OATemplateMessage.index.c20': '编辑',
  'src.pages.SystemNotification.OATemplateMessage.index.c21': '查看',
  'src.pages.SystemNotification.OATemplateMessage.index.c22': '推送内容',
  'src.pages.SystemNotification.OATemplateMessage.index.c23': '健康评估',
  'src.pages.SystemNotification.OATemplateMessage.index.c23.1': '工单处理提醒',
  'src.pages.SystemNotification.OATemplateMessage.index.c23.2': '工单名称',
  'src.pages.SystemNotification.OATemplateMessage.index.c23.2.1':
    '中医体质辨识问卷填写',
  'src.pages.SystemNotification.OATemplateMessage.index.c23.2.2': '工作人员',
  'src.pages.SystemNotification.OATemplateMessage.index.c23.2.3': '张三',
  'src.pages.SystemNotification.OATemplateMessage.index.c23.2.4': '下发时间',
  'src.pages.SystemNotification.OATemplateMessage.index.c23.2.5': '18574301413',
  'src.pages.SystemNotification.OATemplateMessage.index.c24': '活动管理',
  'src.pages.SystemNotification.OATemplateMessage.index.c24.1': '收到报名申请',
  'src.pages.SystemNotification.OATemplateMessage.index.c24.2': '报名名称',
  'src.pages.SystemNotification.OATemplateMessage.index.c24.3':
    '健步走活动提醒',
  'src.pages.SystemNotification.OATemplateMessage.index.c24.4': '报名人',
  'src.pages.SystemNotification.OATemplateMessage.index.c24.5': '联系电话',
  'src.pages.SystemNotification.OATemplateMessage.index.c24.6': '开始时间',
  'src.pages.SystemNotification.OATemplateMessage.index.c24.7':
    '2024年10月19日 14:00',
  'src.pages.SystemNotification.OATemplateMessage.index.c25': '健康资讯',
  'src.pages.SystemNotification.OATemplateMessage.index.c25.1':
    '订单创建成功通知',
  'src.pages.SystemNotification.OATemplateMessage.index.c25.2': '产品名称',
  'src.pages.SystemNotification.OATemplateMessage.index.c25.3':
    '高血压，请注意！',
  'src.pages.SystemNotification.OATemplateMessage.index.c25.4': '下单人',
  'src.pages.SystemNotification.OATemplateMessage.index.c25.5': '下单时间',
  'src.pages.SystemNotification.OATemplateMessage.index.c26': '模版消息',
  'src.pages.SystemNotification.OATemplateMessage.index.c27': '预览模版内容',
  'src.pages.SystemNotification.OATemplateMessage.index.c28': '群发对象',
  'src.pages.SystemNotification.OATemplateMessage.index.c29': '全部',
  'src.pages.SystemNotification.OATemplateMessage.index.c30': '标签客户',
  'src.pages.SystemNotification.OATemplateMessage.index.c31': '企业/部门',
  'src.pages.SystemNotification.OATemplateMessage.index.c32': '指定人群',
  'src.pages.SystemNotification.OATemplateMessage.index.c33': '选择问卷',
  'src.pages.SystemNotification.OATemplateMessage.index.c34': '发送时间',
  'src.pages.SystemNotification.OATemplateMessage.index.c35': '日期时间',
  'src.pages.SystemNotification.OATemplateMessage.index.c36': '立即发送',
  'src.pages.SystemNotification.OATemplateMessage.index.c37': '定时发送',
  'src.pages.SystemNotification.OATemplateMessage.index.c39': '健康资讯',
  'src.pages.SystemNotification.OATemplateMessage.index.c40': '待推送',
  'src.pages.SystemNotification.OATemplateMessage.index.c41': '已推送',
  'src.pages.SystemNotification.OATemplateMessage.index.c42': '失败',
  'src.pages.SystemNotification.OATemplateMessage.index.c43': '取消',
  'src.pages.SystemNotification.OATemplateMessage.index.c44': '提交',
  'src.pages.SystemNotification.OATemplateMessage.index.c45': '推送时间',
  'src.pages.SystemNotification.OATemplateMessage.index.c46':
    '请输入姓名或手机号',

  'src.pages.TableList.components.UpdateForm.c1': '请输入规则名称！',
  'src.pages.TableList.components.UpdateForm.c2':
    '请输入至少五个字符的规则描述！',
  'src.pages.TableList.components.UpdateForm.c3': '请选择开始时间！',
  'src.pages.TaskView.BatchCreateTask.components.CreateTaskModal.index.c7':
    '确认',
  'src.pages.TaskView.BatchCreateTask.components.CreateTaskModal.index.c13':
    '取消',
  'src.pages.TaskView.BatchCreateTask.components.CreateTaskModal.index.c19':
    '服务项目',
  'src.pages.TaskView.BatchCreateTask.components.CreateTaskModal.index.c25':
    '请选择',
  'src.pages.TaskView.BatchCreateTask.components.CreateTaskModal.index.c31':
    '执行者',
  'src.pages.TaskView.BatchCreateTask.components.CreateTaskModal.index.c37':
    '处理时间',
  'src.pages.TaskView.BatchCreateTask.components.CreateTaskModal.index.c43':
    '固定时间',
  'src.pages.TaskView.BatchCreateTask.components.CreateTaskModal.index.c49':
    '任务次数',
  'src.pages.TaskView.BatchCreateTask.components.CreateTaskModal.index.c55':
    '间隔天数',
  'src.pages.TaskView.BatchCreateTask.components.CreateTaskModal.index.c61':
    '删除',
  'src.pages.TaskView.BatchCreateTask.components.CreateTaskModal.index.c67':
    '任务描述',
  'src.pages.TaskView.BatchCreateTask.components.CreateTaskModal.TeamModal.c1':
    '选择执行者：团队',
  'src.pages.TaskView.BatchCreateTask.components.CreateTaskModal.UserModal.c1':
    '请选择团队',
  'src.pages.TaskView.BatchCreateTask.components.CreateTaskModal.UserModal.c3':
    '选择执行者：个人',
  'src.pages.TaskView.MyTaskView.components.ListModel.index.c1': '确认开始处理',
  'src.pages.TaskView.MyTaskView.components.ListModel.index.c2': '待结束',
  'src.pages.TaskView.MyTaskView.components.ListModel.index.c4': '转交任务',
  'src.pages.TaskView.MyTaskView.components.ListModel.index.c6': '健管师',
  'src.pages.TaskView.MyTaskView.components.ListModel.index.c7': '查看详情',
  'src.pages.TaskView.MyTaskView.components.ListModel.index.c8': '开始处理',
  'src.pages.TaskView.MyTaskView.components.ListModel.index.c9': '更多操作 ',
  'src.pages.TaskView.MyTaskView.components.ListModel.index.c10':
    '确认继续处理',
  'src.pages.TaskView.MyTaskView.components.ListModel.index.c19': '任务详情',
  'src.pages.TaskView.MyTaskView.components.ListModel.index.c28': '相关任务',
  'src.pages.TaskView.MyTaskView.components.PassTask.index.c1': '创建任务',
  'src.pages.TaskView.MyTaskView.components.PassTask.index.c2': '当前执行者',
  'src.pages.TaskView.MyTaskView.components.PassTask.index.c3': '任务描述：',
  'src.pages.TaskView.MyTaskView.components.PassTask.index.c4': '执行者',
  'src.pages.TaskView.MyTaskView.components.PassTask.index.c5': '当前执行者',
  'src.pages.TaskView.MyTaskView.components.PassTask.index.c6': '任务描述：',
  'src.pages.TaskView.Overview.components.CalendarMode.index.c1': '服务项目',
  'src.pages.TaskView.Overview.components.CalendarMode.index.c5': '所属团队',
  'src.pages.TaskView.Overview.components.CalendarMode.index.c9': '筛选客户',
  'src.pages.TaskView.Overview.components.SearchForm.index.c1': '服务项目',
  'src.pages.TaskView.Overview.components.SearchForm.index.c3': '计划执行者',
  'src.pages.TaskView.Overview.components.SearchForm.index.c5': '筛选客户',
  'src.pages.TaskView.Overview.components.SearchForm.index.c7': '客户标签',
  'src.pages.TaskView.Overview.components.SearchForm.index.c9': '客户等级',
  'src.pages.TaskView.Overview.components.SearchForm.index.c11': '所属团队',
  'src.pages.TaskView.Overview.components.SearchForm.index.c13': '任务创建者',
  'src.pages.TaskView.Overview.components.SearchForm.index.c15': '任务转交者',
  'src.pages.TaskView.Overview.components.SearchForm.index.c17': '任务来源',
  'src.pages.TaskView.Overview.components.StatusBar.index.c1': '待处理',
  'src.pages.TaskView.Overview.components.StatusBar.index.c2': '处理中',
  'src.pages.TaskView.Overview.components.StatusBar.index.c3': '已完成',
  'src.pages.TaskView.Overview.components.StatusBar.index.c4': '已关闭',
  'src.pages.TaskView.Overview.components.TableList.index.c1': '任务详情',
  'src.pages.TaskView.Overview.components.TableList.index.c2': '编辑任务',
  'src.pages.TaskView.Overview.components.TableList.index.c3': '转交任务',
  'src.pages.TaskView.Overview.components.TableList.index.c4': '更多操作',
  'src.pages.TaskView.TaskProcess.components.CustomerSummary.index.c1':
    '服务客户',
  'src.pages.TaskView.TaskProcess.components.CustomerSummary.index.c2':
    '档案编号',
  'src.pages.TaskView.TaskProcess.components.CustomerSummary.index.c3':
    '联系电话',
  'src.pages.TaskView.TaskProcess.components.CustomerSummary.index.c4':
    '所属服务团队',
  'src.pages.TaskView.TaskProcess.components.CustomerSummary.index.c5':
    '会员等级',
  'src.pages.TaskView.TaskProcess.components.CustomerSummary.index.c6':
    '客户标签',
  'src.pages.TaskView.TaskProcess.components.ExpensesRecord.index.c1':
    '确认要删除该消费记录？',
  'src.pages.TaskView.TaskProcess.components.RecommendTask.index.c1':
    '服务项目',
  'src.pages.TaskView.TaskProcess.components.RecommendTask.index.c2':
    '计划执行者',
  'src.pages.TaskView.TaskProcess.components.RecommendTask.index.c3':
    '计划时间',
  'src.pages.TaskView.TaskProcess.components.RecommendTask.index.c4':
    '任务描述',
  'src.pages.TaskView.TaskProcess.components.RecommendTask.index.c5':
    '任务转交者',
  'src.pages.TaskView.TaskProcess.components.RecommendTask.index.c6':
    '任务创建者',
  'src.pages.TaskView.TaskProcess.components.TaskCountDown.index.c1': '已逾期',
  'src.pages.TaskView.TaskProcess.components.TaskCountDown.index.c7': '正常',
  'src.pages.TaskView.TaskProcess.components.TaskDetail.index.c1': '相关任务',
  'src.pages.TaskView.TaskProcess.components.TaskDetail.index.c3': '任务编号: ',
  'src.pages.TaskView.TaskProcess.components.TaskDetail.index.c4': '服务项目:',
  'src.pages.TaskView.TaskProcess.components.TaskDetail.index.c5': '任务动态',
  'src.pages.TaskView.TaskProcess.components.TaskDetail.TaskRelation.c1':
    '任务详情',
  'src.pages.TaskView.TaskProcess.components.TaskDetail.TaskRelation.c2':
    '任务编号: ',
  'src.pages.TaskView.TaskProcess.components.TaskDetail.TaskRelation.c3':
    '服务项目:',
  'src.pages.TaskView.TaskProcess.components.TaskDetail.TaskSummary.c1':
    '服务项目',
  'src.pages.TaskView.TaskProcess.components.TaskDetail.TaskSummary.c2':
    '任务来源',
  'src.pages.TaskView.TaskProcess.components.TaskDetail.TaskSummary.c3':
    '任务创建者',
  'src.pages.TaskView.TaskProcess.components.TaskDetail.TaskSummary.c4':
    '任务转交者',
  'src.pages.TaskView.TaskProcess.components.TaskDetail.TaskSummary.c5':
    '实际执行者',
  'src.pages.TaskView.TaskProcess.components.TaskDetail.TaskSummary.c6':
    '实际执行时间',
  'src.pages.TaskView.TaskProcess.components.TaskDetail.TaskSummary.c7':
    '计划执行者',
  'src.pages.TaskView.TaskProcess.components.TaskDetail.TaskSummary.c8':
    '计划执行时间',
  'src.pages.TaskView.TaskProcess.components.TaskDetail.TaskSummary.c9':
    '任务描述',
  'src.pages.TaskView.TaskProcess.index.c1': '确认同时处理该任务？',
  'src.pages.TaskView.TaskProcess.index.c12': '添加报告',
  'src.pages.TaskView.TaskProcess.index.c13': '服务形式',
  'src.pages.TaskView.TaskProcess.index.c25': '服务结果',
  'src.pages.TaskView.TaskProcess.index.c37': '服务备注',
  'src.pages.TaskView.TaskProcess.index.c49':
    '描述本次服务情况，便于下次服务或其他服务人员提供服务时参考，不对客户显示',
  'src.pages.TaskView.TaskProcess.index.c61': '服务评价',
  'src.pages.TaskView.TaskProcess.index.c73': '推送通知消息',
  'src.pages.TaskView.TaskProcess.index.c85': '服务总结',
  'src.pages.TaskView.TaskProcess.index.c97':
    '用于向客户介绍本次服务整体情况，客户可见',
  'src.pages.TaskView.TaskProcess.index.c109': '测量数据',
  'src.pages.TaskView.TaskProcess.index.c121': '上传检测报告：',
  'src.pages.TaskView.TaskProcess.index.c145': '方案标题',
  'src.pages.TaskView.TaskProcess.index.c157': '服务方案',
  'src.pages.TaskView.TaskProcess.index.c169': '方案描述',
  'src.pages.TaskView.TaskProcess.index.c181': '消费记录',
  'src.pages.TaskView.TaskProcessDetail.index.c1': '服务形式',
  'src.pages.TaskView.TaskProcessDetail.index.c7': '服务结果',
  'src.pages.TaskView.TaskProcessDetail.index.c13': '服务备注',
  'src.pages.TaskView.TaskProcessDetail.index.c19': '服务凭证',
  'src.pages.TaskView.TaskProcessDetail.index.c25': '服务地址',
  'src.pages.TaskView.TaskProcessDetail.index.c31': '服务评价',
  'src.pages.TaskView.TaskProcessDetail.index.c37': '推送通知消息',
  'src.pages.TaskView.TaskProcessDetail.index.c43': '服务总结',
  'src.pages.TaskView.TaskProcessDetail.index.c49': '测量数据',
  'src.pages.TaskView.TaskProcessDetail.index.c55': '上传检测报告：',
  'src.pages.TaskView.TaskProcessDetail.index.c61': '服务方案',
  'src.pages.TaskView.TaskProcessDetail.index.c67': '方案标题',
  'src.pages.TaskView.TaskProcessDetail.index.c73': '方案描述',
  'src.pages.TaskView.TaskProcessDetail.index.c79': '消费记录',
  'src.settingData.health.weight': '体重',
  'src.settingData.health.bmi': 'BMI',
  'src.settingData.health.systolicPressure': '收缩压',
  'src.settingData.health.diastolicPressure': '舒张压',
  'src.settingData.health.fastingBloodGlucose': '空腹血糖',
  'src.settingData.health.preprandialBloodGlucose': '餐前血糖',
  'src.settingData.health.postprandialBloodGlucose': '餐后血糖',
  'src.settingData.health.bodyFatRatio': '脂肪率',
  'src.settingData.health.muscleRatio': '肌肉率',
  'src.settingData.health.skeletonMuscleRatio': '骨骼肌率',
  'src.settingData.health.bodyMoistureRatio': '水分率',
  'src.settingData.health.proteinRatio': '蛋白质',
  'src.settingData.health.bmr': '基础代谢',
  'src.settingData.health.totalCholesterol': '总胆固醇',
  'src.settingData.health.triglycerides': '甘油三酯',
  'src.settingData.health.hdlCholesterol': '高密度脂蛋白胆固醇',
  'src.settingData.health.ldlCholesterol': '低密度脂蛋白胆固醇',
  'src.settingData.health.uricAcid': '尿酸',
  'src.settingData.health.bloodCreatinine': '血肌酐',
  'src.settingData.health.aspartateAminotransferase': '谷草转氨酶',
  'src.settingData.health.alanineAminotransferase': '谷丙转氨酶',
  'src.settingData.health.hemoglobinA1c': '糖化血红蛋白',
  'src.settingData.health.heartRateOfBP': '心率',
  'src.settingData.health.step': '步数',
  'src.settingData.health.sleep': '睡眠时长',
  'src.settingData.health.dynamicBloodGlucose': '动态血糖',
  'src.pages.Welcome.c1': '高级表格',
  'src.pages.Welcome.c2': '欢迎使用',
  'src.pages.Welcome.c3': '高级布局',
  'src.pages.Welcome.c4': '欢迎使用',
}
